import cashCopy from './cashTranslations';
import cashFlowCopy from './cashFlowTranslations';
import expenseCopy from './expenseTranslations';
import projectionCopy from './projectionTranslations';
import profitabilityCopy from './profitabilityTranslations';
import financialReportCopy from './financialReportTranslations';
import purchaseCopy from './purchaseTranslations';
import transportCopy from './transportTranslations';
const promotionCopy = {
  "es": {
    "BRIEFCASE · COBROS": "BRIEFCASE · COBROS",
    "Cerrar promociones": "Cerrar promociones",
    "No se pudo completar. Revisa los datos y vuelve a intentar.": "No se pudo completar. Revisa los datos y vuelve a intentar.",
    "Por referidos": "Por referidos",
    "Temporada especial": "Temporada especial",
    "Clientes favoritos": "Clientes favoritos",
    "Otra ocasión": "Otra ocasión",
    "Promoción guardada como borrador": "Promoción guardada como borrador",
    "Promoción activa. Ya puedes compartir su QR.": "Promoción activa. Ya puedes compartir su QR.",
    "Promoción pausada para nuevos pagos.": "Promoción pausada para nuevos pagos.",
    "{business}: {title}. {percent}% de descuento. Antes {before}, paga {total}. Válida hasta {date}. {link}": "{business}: {title}. {percent}% de descuento. Antes {before}, paga {total}. Válida hasta {date}. {link}",
    "Enlace promocional copiado": "Enlace promocional copiado",
    "Copia el enlace que aparece en pantalla.": "Copia el enlace que aparece en pantalla.",
    "No se pudo preparar la imagen QR. Puedes compartir el enlace.": "No se pudo preparar la imagen QR. Puedes compartir el enlace.",
    "CONVIERTE UN DETALLE EN UNA NUEVA VENTA": "CONVIERTE UN DETALLE EN UNA NUEVA VENTA",
    "Promociones con QR": "Promociones con QR",
    "Elige el descuento. Comparte el QR. Tu cliente paga sin registrarse.": "Elige el descuento. Comparte el QR. Tu cliente paga sin registrarse.",
    "Nueva promoción": "Nueva promoción",
    "Puedes preparar tus promociones ahora. Conecta y verifica Stripe para activar el QR y recibir pagos.": "Puedes preparar tus promociones ahora. Conecta y verifica Stripe para activar el QR y recibir pagos.",
    "Cargando promociones…": "Cargando promociones…",
    "TÚ ELIGES EL PORCENTAJE": "TÚ ELIGES EL PORCENTAJE",
    "Un descuento para cada ocasión.": "Un descuento para cada ocasión.",
    "Referidos, temporadas especiales o un agradecimiento a tus clientes favoritos.": "Referidos, temporadas especiales o un agradecimiento a tus clientes favoritos.",
    "Personalizado": "Personalizado",
    "Preparar mi primera promoción": "Preparar mi primera promoción",
    "EJEMPLO · 15% DE DESCUENTO": "EJEMPLO · 15% DE DESCUENTO",
    "El total siempre se muestra antes de pagar.": "El total siempre se muestra antes de pagar.",
    "Vencida": "Vencida",
    "Activa": "Activa",
    "Pausada / borrador": "Pausada / borrador",
    "de descuento": "de descuento",
    "Hasta {date} · {count} pagos confirmados": "Hasta {date} · {count} pagos confirmados",
    "Ver QR y detalles": "Ver QR y detalles",
    "Pausar": "Pausar",
    "Activar": "Activar",
    "El descuento se aplica al precio final indicado por el negocio. No se acumula con otros descuentos. Quien reciba el enlace activo podrá usarlo; la categoría «referidos» no verifica automáticamente una recomendación.": "El descuento se aplica al precio final indicado por el negocio. No se acumula con otros descuentos. Quien reciba el enlace activo podrá usarlo; la categoría «referidos» no verifica automáticamente una recomendación.",
    "Nombre de la promoción": "Nombre de la promoción",
    "Ej.: Gracias por recomendarnos": "Ej.: Gracias por recomendarnos",
    "Motivo": "Motivo",
    "Qué incluye": "Qué incluye",
    "Servicio o producto, condiciones e impuestos incluidos en este precio": "Servicio o producto, condiciones e impuestos incluidos en este precio",
    "Precio original": "Precio original",
    "Moneda": "Moneda",
    "Descuento que ofreces (%)": "Descuento que ofreces (%)",
    "Vigencia desde hoy": "Vigencia desde hoy",
    "{count} día(s)": "{count} día(s)",
    "VISTA PREVIA · AÚN SIN PUBLICAR": "VISTA PREVIA · AÚN SIN PUBLICAR",
    "Tu próxima promoción": "Tu próxima promoción",
    "Ahorro del cliente": "Ahorro del cliente",
    "El cliente paga": "El cliente paga",
    "El QR se habilita al activar la promoción.": "El QR se habilita al activar la promoción.",
    "Se guarda primero como borrador. Revisa el precio antes de activar y compartir.": "Se guarda primero como borrador. Revisa el precio antes de activar y compartir.",
    "Podrás compartirla varias veces durante su vigencia. Para cambiar el precio de una oferta guardada, crea una nueva.": "Podrás compartirla varias veces durante su vigencia. Para cambiar el precio de una oferta guardada, crea una nueva.",
    "Guardar promoción": "Guardar promoción",
    "QR promocional para pagar con descuento": "QR promocional para pagar con descuento",
    "{percent}% DE DESCUENTO": "{percent}% DE DESCUENTO",
    "Paga {amount}": "Paga {amount}",
    "Antes {amount}": "Antes {amount}",
    "Válida hasta {date}": "Válida hasta {date}",
    "Escanea, revisa y paga con tarjeta": "Escanea, revisa y paga con tarjeta",
    "BRIEFCASE · No necesitas crear una cuenta": "BRIEFCASE · No necesitas crear una cuenta",
    "QR vencido": "QR vencido",
    "QR sin activar": "QR sin activar",
    "El cliente podrá abrir la oferta cuando esté activa.": "El cliente podrá abrir la oferta cuando esté activa.",
    "Descuento sobre el precio final indicado.": "Descuento sobre el precio final indicado.",
    "Descuento ({percent}%)": "Descuento ({percent}%)",
    "Vigencia hasta {date}. Cualquier persona con el QR o enlace activo podrá usar esta oferta.": "Vigencia hasta {date}. Cualquier persona con el QR o enlace activo podrá usar esta oferta.",
    "Enlace promocional": "Enlace promocional",
    "Descargar / compartir QR": "Descargar / compartir QR",
    "Email": "Email",
    "WhatsApp y email abren el mensaje para que tú confirmes el envío.": "WhatsApp y email abren el mensaje para que tú confirmes el envío.",
    "Activar QR promocional": "Activar QR promocional",
    "Primero conecta y verifica Stripe desde Cobros.": "Primero conecta y verifica Stripe desde Cobros.",
    "Al pausar se bloquean nuevos intentos. Una pantalla de Stripe ya abierta podrá pagarse hasta su vencimiento (aproximadamente 30 minutos).": "Al pausar se bloquean nuevos intentos. Una pantalla de Stripe ya abierta podrá pagarse hasta su vencimiento (aproximadamente 30 minutos).",
    "Idioma": "Idioma",
    "COBROS SEGUROS": "COBROS SEGUROS",
    "No pudimos conectar. Vuelve a intentar en unos instantes.": "No pudimos conectar. Vuelve a intentar en unos instantes.",
    "Preparando tu promoción…": "Preparando tu promoción…",
    "Pago confirmado": "Pago confirmado",
    "El intento de pago venció": "El intento de pago venció",
    "Estamos verificando tu pago": "Estamos verificando tu pago",
    "El negocio ya tiene registrado el pago con tu descuento.": "El negocio ya tiene registrado el pago con tu descuento.",
    "No realices otro pago si ya recibiste un cargo. Actualiza la confirmación en unos instantes.": "No realices otro pago si ya recibiste un cargo. Actualiza la confirmación en unos instantes.",
    "Actualizar confirmación": "Actualizar confirmación",
    "PROMOCIÓN ESPECIAL": "PROMOCIÓN ESPECIAL",
    "DE DESCUENTO": "DE DESCUENTO",
    "Tu descuento ya está aplicado": "Tu descuento ya está aplicado",
    "Ahorras": "Ahorras",
    "Total a pagar": "Total a pagar",
    "Válida hasta {date}. Precio final indicado por el negocio.": "Válida hasta {date}. Precio final indicado por el negocio.",
    "No completaste el pago. Puedes volver a intentarlo.": "No completaste el pago. Puedes volver a intentarlo.",
    "Abriendo Stripe…": "Abriendo Stripe…",
    "Pagar {amount}": "Pagar {amount}",
    "Pagarás en la página segura de Stripe. No necesitas instalar BRIEFCASE ni crear una cuenta.": "Pagarás en la página segura de Stripe. No necesitas instalar BRIEFCASE ni crear una cuenta.",
    "Oferta compartida por el negocio. No acumulable con otros descuentos.": "Oferta compartida por el negocio. No acumulable con otros descuentos.",
    "Promoción no disponible": "Promoción no disponible",
    "Consulta al negocio por una oferta vigente.": "Consulta al negocio por una oferta vigente.",
    "Volver a consultar": "Volver a consultar",
    "Los productos, servicios y condiciones corresponden al negocio que comparte esta promoción.": "Los productos, servicios y condiciones corresponden al negocio que comparte esta promoción."
  },
  "en": {
    "BRIEFCASE · COBROS": "BRIEFCASE · PAYMENTS",
    "Cerrar promociones": "Close promotions",
    "No se pudo completar. Revisa los datos y vuelve a intentar.": "Unable to complete. Check the details and try again.",
    "Por referidos": "Referrals",
    "Temporada especial": "Special season",
    "Clientes favoritos": "Favorite customers",
    "Otra ocasión": "Another occasion",
    "Promoción guardada como borrador": "Promotion saved as a draft",
    "Promoción activa. Ya puedes compartir su QR.": "Promotion active. You can now share its QR code.",
    "Promoción pausada para nuevos pagos.": "Promotion paused for new payments.",
    "{business}: {title}. {percent}% de descuento. Antes {before}, paga {total}. Válida hasta {date}. {link}": "{business}: {title}. {percent}% off. Was {before}, pay {total}. Valid until {date}. {link}",
    "Enlace promocional copiado": "Promotion link copied",
    "Copia el enlace que aparece en pantalla.": "Copy the link shown on screen.",
    "No se pudo preparar la imagen QR. Puedes compartir el enlace.": "Unable to prepare the QR image. You can share the link.",
    "CONVIERTE UN DETALLE EN UNA NUEVA VENTA": "TURN A KIND GESTURE INTO A NEW SALE",
    "Promociones con QR": "QR promotions",
    "Elige el descuento. Comparte el QR. Tu cliente paga sin registrarse.": "Choose the discount. Share the QR code. Your customer pays without signing up.",
    "Nueva promoción": "New promotion",
    "Puedes preparar tus promociones ahora. Conecta y verifica Stripe para activar el QR y recibir pagos.": "Prepare your promotions now. Connect and verify Stripe to activate the QR code and receive payments.",
    "Cargando promociones…": "Loading promotions…",
    "TÚ ELIGES EL PORCENTAJE": "YOU CHOOSE THE PERCENTAGE",
    "Un descuento para cada ocasión.": "A discount for every occasion.",
    "Referidos, temporadas especiales o un agradecimiento a tus clientes favoritos.": "Referrals, special seasons or a thank-you to your favorite customers.",
    "Personalizado": "Custom",
    "Preparar mi primera promoción": "Prepare my first promotion",
    "EJEMPLO · 15% DE DESCUENTO": "EXAMPLE · 15% OFF",
    "El total siempre se muestra antes de pagar.": "The total is always shown before payment.",
    "Vencida": "Expired",
    "Activa": "Active",
    "Pausada / borrador": "Paused / draft",
    "de descuento": "off",
    "Hasta {date} · {count} pagos confirmados": "Until {date} · {count} confirmed payments",
    "Ver QR y detalles": "View QR and details",
    "Pausar": "Pause",
    "Activar": "Activate",
    "El descuento se aplica al precio final indicado por el negocio. No se acumula con otros descuentos. Quien reciba el enlace activo podrá usarlo; la categoría «referidos» no verifica automáticamente una recomendación.": "The discount applies to the final price set by the business and cannot be combined with other discounts. Anyone with the active link can use it; the referral category does not automatically verify a referral.",
    "Nombre de la promoción": "Promotion name",
    "Ej.: Gracias por recomendarnos": "E.g. Thanks for recommending us",
    "Motivo": "Occasion",
    "Qué incluye": "What is included",
    "Servicio o producto, condiciones e impuestos incluidos en este precio": "Service or product, terms and taxes included in this price",
    "Precio original": "Original price",
    "Moneda": "Currency",
    "Descuento que ofreces (%)": "Discount you offer (%)",
    "Vigencia desde hoy": "Valid from today",
    "{count} día(s)": "{count} day(s)",
    "VISTA PREVIA · AÚN SIN PUBLICAR": "PREVIEW · NOT YET PUBLISHED",
    "Tu próxima promoción": "Your next promotion",
    "Ahorro del cliente": "Customer savings",
    "El cliente paga": "Customer pays",
    "El QR se habilita al activar la promoción.": "The QR code becomes available when you activate the promotion.",
    "Se guarda primero como borrador. Revisa el precio antes de activar y compartir.": "It is first saved as a draft. Check the price before activating and sharing.",
    "Podrás compartirla varias veces durante su vigencia. Para cambiar el precio de una oferta guardada, crea una nueva.": "You can share it repeatedly while it is valid. To change the price of a saved offer, create a new one.",
    "Guardar promoción": "Save promotion",
    "QR promocional para pagar con descuento": "Promotional QR code for discounted payment",
    "{percent}% DE DESCUENTO": "{percent}% OFF",
    "Paga {amount}": "Pay {amount}",
    "Antes {amount}": "Was {amount}",
    "Válida hasta {date}": "Valid until {date}",
    "Escanea, revisa y paga con tarjeta": "Scan, review and pay by card",
    "BRIEFCASE · No necesitas crear una cuenta": "BRIEFCASE · No account needed",
    "QR vencido": "Expired QR code",
    "QR sin activar": "Inactive QR code",
    "El cliente podrá abrir la oferta cuando esté activa.": "The customer can open the offer when it is active.",
    "Descuento sobre el precio final indicado.": "Discount on the stated final price.",
    "Descuento ({percent}%)": "Discount ({percent}%)",
    "Vigencia hasta {date}. Cualquier persona con el QR o enlace activo podrá usar esta oferta.": "Valid until {date}. Anyone with the active QR code or link can use this offer.",
    "Enlace promocional": "Promotion link",
    "Descargar / compartir QR": "Download / share QR",
    "Email": "Email",
    "WhatsApp y email abren el mensaje para que tú confirmes el envío.": "WhatsApp and email open a draft for you to confirm sending.",
    "Activar QR promocional": "Activate promotional QR",
    "Primero conecta y verifica Stripe desde Cobros.": "First connect and verify Stripe from Payments.",
    "Al pausar se bloquean nuevos intentos. Una pantalla de Stripe ya abierta podrá pagarse hasta su vencimiento (aproximadamente 30 minutos).": "Pausing blocks new attempts. A Stripe payment page that is already open can still be paid until it expires (about 30 minutes).",
    "Idioma": "Language",
    "COBROS SEGUROS": "SECURE PAYMENTS",
    "No pudimos conectar. Vuelve a intentar en unos instantes.": "Unable to connect. Please try again in a moment.",
    "Preparando tu promoción…": "Preparing your promotion…",
    "Pago confirmado": "Payment confirmed",
    "El intento de pago venció": "The payment attempt expired",
    "Estamos verificando tu pago": "We are verifying your payment",
    "El negocio ya tiene registrado el pago con tu descuento.": "The business has recorded your discounted payment.",
    "No realices otro pago si ya recibiste un cargo. Actualiza la confirmación en unos instantes.": "Do not pay again if you have already been charged. Refresh the confirmation in a moment.",
    "Actualizar confirmación": "Refresh confirmation",
    "PROMOCIÓN ESPECIAL": "SPECIAL PROMOTION",
    "DE DESCUENTO": "OFF",
    "Tu descuento ya está aplicado": "Your discount is already applied",
    "Ahorras": "You save",
    "Total a pagar": "Total to pay",
    "Válida hasta {date}. Precio final indicado por el negocio.": "Valid until {date}. Final price set by the business.",
    "No completaste el pago. Puedes volver a intentarlo.": "Payment was not completed. You can try again.",
    "Abriendo Stripe…": "Opening Stripe…",
    "Pagar {amount}": "Pay {amount}",
    "Pagarás en la página segura de Stripe. No necesitas instalar BRIEFCASE ni crear una cuenta.": "You will pay on Stripe’s secure page. No BRIEFCASE installation or account is required.",
    "Oferta compartida por el negocio. No acumulable con otros descuentos.": "Offer shared by the business. Cannot be combined with other discounts.",
    "Promoción no disponible": "Promotion unavailable",
    "Consulta al negocio por una oferta vigente.": "Ask the business for a current offer.",
    "Volver a consultar": "Check again",
    "Los productos, servicios y condiciones corresponden al negocio que comparte esta promoción.": "Products, services and terms are the responsibility of the business sharing this promotion."
  },
  "pt": {
    "BRIEFCASE · COBROS": "BRIEFCASE · PAGAMENTOS",
    "Cerrar promociones": "Fechar promoções",
    "No se pudo completar. Revisa los datos y vuelve a intentar.": "Não foi possível concluir. Confira os dados e tente novamente.",
    "Por referidos": "Indicações",
    "Temporada especial": "Temporada especial",
    "Clientes favoritos": "Clientes favoritos",
    "Otra ocasión": "Outra ocasião",
    "Promoción guardada como borrador": "Promoção salva como rascunho",
    "Promoción activa. Ya puedes compartir su QR.": "Promoção ativa. Agora você pode compartilhar o QR.",
    "Promoción pausada para nuevos pagos.": "Promoção pausada para novos pagamentos.",
    "{business}: {title}. {percent}% de descuento. Antes {before}, paga {total}. Válida hasta {date}. {link}": "{business}: {title}. {percent}% de desconto. De {before}, pague {total}. Válida até {date}. {link}",
    "Enlace promocional copiado": "Link promocional copiado",
    "Copia el enlace que aparece en pantalla.": "Copie o link exibido na tela.",
    "No se pudo preparar la imagen QR. Puedes compartir el enlace.": "Não foi possível preparar a imagem QR. Você pode compartilhar o link.",
    "CONVIERTE UN DETALLE EN UNA NUEVA VENTA": "TRANSFORME UM GESTO EM UMA NOVA VENDA",
    "Promociones con QR": "Promoções com QR",
    "Elige el descuento. Comparte el QR. Tu cliente paga sin registrarse.": "Escolha o desconto. Compartilhe o QR. Seu cliente paga sem se cadastrar.",
    "Nueva promoción": "Nova promoção",
    "Puedes preparar tus promociones ahora. Conecta y verifica Stripe para activar el QR y recibir pagos.": "Prepare suas promoções agora. Conecte e verifique o Stripe para ativar o QR e receber pagamentos.",
    "Cargando promociones…": "Carregando promoções…",
    "TÚ ELIGES EL PORCENTAJE": "VOCÊ ESCOLHE A PORCENTAGEM",
    "Un descuento para cada ocasión.": "Um desconto para cada ocasião.",
    "Referidos, temporadas especiales o un agradecimiento a tus clientes favoritos.": "Indicações, temporadas especiais ou um agradecimento aos seus clientes favoritos.",
    "Personalizado": "Personalizado",
    "Preparar mi primera promoción": "Preparar minha primeira promoção",
    "EJEMPLO · 15% DE DESCUENTO": "EXEMPLO · 15% DE DESCONTO",
    "El total siempre se muestra antes de pagar.": "O total é sempre exibido antes de pagar.",
    "Vencida": "Expirada",
    "Activa": "Ativa",
    "Pausada / borrador": "Pausada / rascunho",
    "de descuento": "de desconto",
    "Hasta {date} · {count} pagos confirmados": "Até {date} · {count} pagamentos confirmados",
    "Ver QR y detalles": "Ver QR e detalhes",
    "Pausar": "Pausar",
    "Activar": "Ativar",
    "El descuento se aplica al precio final indicado por el negocio. No se acumula con otros descuentos. Quien reciba el enlace activo podrá usarlo; la categoría «referidos» no verifica automáticamente una recomendación.": "O desconto é aplicado ao preço final definido pelo negócio e não é cumulativo. Qualquer pessoa com o link ativo pode usá-lo; a categoria de indicações não verifica automaticamente uma recomendação.",
    "Nombre de la promoción": "Nome da promoção",
    "Ej.: Gracias por recomendarnos": "Ex.: Obrigado por nos indicar",
    "Motivo": "Motivo",
    "Qué incluye": "O que inclui",
    "Servicio o producto, condiciones e impuestos incluidos en este precio": "Serviço ou produto, condições e impostos incluídos neste preço",
    "Precio original": "Preço original",
    "Moneda": "Moeda",
    "Descuento que ofreces (%)": "Desconto oferecido (%)",
    "Vigencia desde hoy": "Validade a partir de hoje",
    "{count} día(s)": "{count} dia(s)",
    "VISTA PREVIA · AÚN SIN PUBLICAR": "PRÉVIA · AINDA NÃO PUBLICADA",
    "Tu próxima promoción": "Sua próxima promoção",
    "Ahorro del cliente": "Economia do cliente",
    "El cliente paga": "O cliente paga",
    "El QR se habilita al activar la promoción.": "O QR fica disponível ao ativar a promoção.",
    "Se guarda primero como borrador. Revisa el precio antes de activar y compartir.": "É salva primeiro como rascunho. Confira o preço antes de ativar e compartilhar.",
    "Podrás compartirla varias veces durante su vigencia. Para cambiar el precio de una oferta guardada, crea una nueva.": "Você pode compartilhá-la várias vezes durante a validade. Para alterar o preço de uma oferta salva, crie uma nova.",
    "Guardar promoción": "Salvar promoção",
    "QR promocional para pagar con descuento": "QR promocional para pagar com desconto",
    "{percent}% DE DESCUENTO": "{percent}% DE DESCONTO",
    "Paga {amount}": "Pague {amount}",
    "Antes {amount}": "De {amount}",
    "Válida hasta {date}": "Válida até {date}",
    "Escanea, revisa y paga con tarjeta": "Escaneie, confira e pague com cartão",
    "BRIEFCASE · No necesitas crear una cuenta": "BRIEFCASE · Não precisa criar uma conta",
    "QR vencido": "QR expirado",
    "QR sin activar": "QR não ativado",
    "El cliente podrá abrir la oferta cuando esté activa.": "O cliente poderá abrir a oferta quando estiver ativa.",
    "Descuento sobre el precio final indicado.": "Desconto sobre o preço final indicado.",
    "Descuento ({percent}%)": "Desconto ({percent}%)",
    "Vigencia hasta {date}. Cualquier persona con el QR o enlace activo podrá usar esta oferta.": "Válida até {date}. Qualquer pessoa com o QR ou link ativo pode usar esta oferta.",
    "Enlace promocional": "Link promocional",
    "Descargar / compartir QR": "Baixar / compartilhar QR",
    "Email": "E-mail",
    "WhatsApp y email abren el mensaje para que tú confirmes el envío.": "WhatsApp e e-mail abrem o texto para você confirmar o envio.",
    "Activar QR promocional": "Ativar QR promocional",
    "Primero conecta y verifica Stripe desde Cobros.": "Primeiro conecte e verifique o Stripe em Pagamentos.",
    "Al pausar se bloquean nuevos intentos. Una pantalla de Stripe ya abierta podrá pagarse hasta su vencimiento (aproximadamente 30 minutos).": "Pausar bloqueia novas tentativas. Uma página de pagamento Stripe já aberta pode ser paga até expirar (cerca de 30 minutos).",
    "Idioma": "Idioma",
    "COBROS SEGUROS": "PAGAMENTOS SEGUROS",
    "No pudimos conectar. Vuelve a intentar en unos instantes.": "Não foi possível conectar. Tente novamente em instantes.",
    "Preparando tu promoción…": "Preparando sua promoção…",
    "Pago confirmado": "Pagamento confirmado",
    "El intento de pago venció": "A tentativa de pagamento expirou",
    "Estamos verificando tu pago": "Estamos verificando seu pagamento",
    "El negocio ya tiene registrado el pago con tu descuento.": "O negócio já registrou seu pagamento com desconto.",
    "No realices otro pago si ya recibiste un cargo. Actualiza la confirmación en unos instantes.": "Não pague novamente se já houve uma cobrança. Atualize a confirmação em instantes.",
    "Actualizar confirmación": "Atualizar confirmação",
    "PROMOCIÓN ESPECIAL": "PROMOÇÃO ESPECIAL",
    "DE DESCUENTO": "DE DESCONTO",
    "Tu descuento ya está aplicado": "Seu desconto já foi aplicado",
    "Ahorras": "Você economiza",
    "Total a pagar": "Total a pagar",
    "Válida hasta {date}. Precio final indicado por el negocio.": "Válida até {date}. Preço final definido pelo negócio.",
    "No completaste el pago. Puedes volver a intentarlo.": "O pagamento não foi concluído. Você pode tentar novamente.",
    "Abriendo Stripe…": "Abrindo Stripe…",
    "Pagar {amount}": "Pagar {amount}",
    "Pagarás en la página segura de Stripe. No necesitas instalar BRIEFCASE ni crear una cuenta.": "Você pagará na página segura do Stripe. Não precisa instalar o BRIEFCASE nem criar uma conta.",
    "Oferta compartida por el negocio. No acumulable con otros descuentos.": "Oferta compartilhada pelo negócio. Não cumulativa com outros descontos.",
    "Promoción no disponible": "Promoção indisponível",
    "Consulta al negocio por una oferta vigente.": "Consulte o negócio sobre uma oferta válida.",
    "Volver a consultar": "Consultar novamente",
    "Los productos, servicios y condiciones corresponden al negocio que comparte esta promoción.": "Os produtos, serviços e condições são de responsabilidade do negócio que compartilha esta promoção."
  },
  "fr": {
    "BRIEFCASE · COBROS": "BRIEFCASE · PAIEMENTS",
    "Cerrar promociones": "Fermer les promotions",
    "No se pudo completar. Revisa los datos y vuelve a intentar.": "Impossible de terminer. Vérifiez les informations et réessayez.",
    "Por referidos": "Parrainages",
    "Temporada especial": "Période spéciale",
    "Clientes favoritos": "Clients favoris",
    "Otra ocasión": "Autre occasion",
    "Promoción guardada como borrador": "Promotion enregistrée comme brouillon",
    "Promoción activa. Ya puedes compartir su QR.": "Promotion active. Vous pouvez partager son QR code.",
    "Promoción pausada para nuevos pagos.": "Promotion suspendue pour les nouveaux paiements.",
    "{business}: {title}. {percent}% de descuento. Antes {before}, paga {total}. Válida hasta {date}. {link}": "{business} : {title}. {percent}% de réduction. Avant {before}, payez {total}. Valable jusqu’au {date}. {link}",
    "Enlace promocional copiado": "Lien promotionnel copié",
    "Copia el enlace que aparece en pantalla.": "Copiez le lien affiché à l’écran.",
    "No se pudo preparar la imagen QR. Puedes compartir el enlace.": "Impossible de préparer l’image QR. Vous pouvez partager le lien.",
    "CONVIERTE UN DETALLE EN UNA NUEVA VENTA": "TRANSFORMEZ UNE ATTENTION EN UNE VENTE",
    "Promociones con QR": "Promotions avec QR",
    "Elige el descuento. Comparte el QR. Tu cliente paga sin registrarse.": "Choisissez la réduction. Partagez le QR. Votre client paie sans s’inscrire.",
    "Nueva promoción": "Nouvelle promotion",
    "Puedes preparar tus promociones ahora. Conecta y verifica Stripe para activar el QR y recibir pagos.": "Préparez vos promotions dès maintenant. Connectez et vérifiez Stripe pour activer le QR et recevoir des paiements.",
    "Cargando promociones…": "Chargement des promotions…",
    "TÚ ELIGES EL PORCENTAJE": "VOUS CHOISISSEZ LE POURCENTAGE",
    "Un descuento para cada ocasión.": "Une réduction pour chaque occasion.",
    "Referidos, temporadas especiales o un agradecimiento a tus clientes favoritos.": "Parrainages, périodes spéciales ou remerciements à vos clients favoris.",
    "Personalizado": "Personnalisé",
    "Preparar mi primera promoción": "Préparer ma première promotion",
    "EJEMPLO · 15% DE DESCUENTO": "EXEMPLE · 15% DE RÉDUCTION",
    "El total siempre se muestra antes de pagar.": "Le total est toujours affiché avant le paiement.",
    "Vencida": "Expirée",
    "Activa": "Active",
    "Pausada / borrador": "Suspendue / brouillon",
    "de descuento": "de réduction",
    "Hasta {date} · {count} pagos confirmados": "Jusqu’au {date} · {count} paiements confirmés",
    "Ver QR y detalles": "Voir le QR et les détails",
    "Pausar": "Suspendre",
    "Activar": "Activer",
    "El descuento se aplica al precio final indicado por el negocio. No se acumula con otros descuentos. Quien reciba el enlace activo podrá usarlo; la categoría «referidos» no verifica automáticamente una recomendación.": "La réduction s’applique au prix final fixé par l’entreprise et n’est pas cumulable. Toute personne disposant du lien actif peut l’utiliser ; la catégorie parrainages ne vérifie pas automatiquement un parrainage.",
    "Nombre de la promoción": "Nom de la promotion",
    "Ej.: Gracias por recomendarnos": "Ex. : Merci de nous recommander",
    "Motivo": "Occasion",
    "Qué incluye": "Ce qui est inclus",
    "Servicio o producto, condiciones e impuestos incluidos en este precio": "Service ou produit, conditions et taxes inclus dans ce prix",
    "Precio original": "Prix initial",
    "Moneda": "Devise",
    "Descuento que ofreces (%)": "Réduction proposée (%)",
    "Vigencia desde hoy": "Validité à partir d’aujourd’hui",
    "{count} día(s)": "{count} jour(s)",
    "VISTA PREVIA · AÚN SIN PUBLICAR": "APERÇU · PAS ENCORE PUBLIÉ",
    "Tu próxima promoción": "Votre prochaine promotion",
    "Ahorro del cliente": "Économie du client",
    "El cliente paga": "Le client paie",
    "El QR se habilita al activar la promoción.": "Le QR devient disponible lorsque vous activez la promotion.",
    "Se guarda primero como borrador. Revisa el precio antes de activar y compartir.": "La promotion est d’abord enregistrée comme brouillon. Vérifiez le prix avant de l’activer et de la partager.",
    "Podrás compartirla varias veces durante su vigencia. Para cambiar el precio de una oferta guardada, crea una nueva.": "Vous pouvez la partager plusieurs fois pendant sa validité. Pour modifier le prix d’une offre enregistrée, créez-en une nouvelle.",
    "Guardar promoción": "Enregistrer la promotion",
    "QR promocional para pagar con descuento": "QR promotionnel pour payer avec réduction",
    "{percent}% DE DESCUENTO": "{percent}% DE RÉDUCTION",
    "Paga {amount}": "Payez {amount}",
    "Antes {amount}": "Avant {amount}",
    "Válida hasta {date}": "Valable jusqu’au {date}",
    "Escanea, revisa y paga con tarjeta": "Scannez, vérifiez et payez par carte",
    "BRIEFCASE · No necesitas crear una cuenta": "BRIEFCASE · Aucun compte nécessaire",
    "QR vencido": "QR expiré",
    "QR sin activar": "QR non activé",
    "El cliente podrá abrir la oferta cuando esté activa.": "Le client pourra ouvrir l’offre lorsqu’elle sera active.",
    "Descuento sobre el precio final indicado.": "Réduction sur le prix final indiqué.",
    "Descuento ({percent}%)": "Réduction ({percent}%)",
    "Vigencia hasta {date}. Cualquier persona con el QR o enlace activo podrá usar esta oferta.": "Valable jusqu’au {date}. Toute personne disposant du QR ou du lien actif peut utiliser cette offre.",
    "Enlace promocional": "Lien promotionnel",
    "Descargar / compartir QR": "Télécharger / partager le QR",
    "Email": "E-mail",
    "WhatsApp y email abren el mensaje para que tú confirmes el envío.": "WhatsApp et l’e-mail ouvrent le message pour que vous confirmiez l’envoi.",
    "Activar QR promocional": "Activer le QR promotionnel",
    "Primero conecta y verifica Stripe desde Cobros.": "Connectez et vérifiez d’abord Stripe dans Paiements.",
    "Al pausar se bloquean nuevos intentos. Una pantalla de Stripe ya abierta podrá pagarse hasta su vencimiento (aproximadamente 30 minutos).": "La suspension bloque les nouvelles tentatives. Une page Stripe déjà ouverte peut encore être payée jusqu’à son expiration (environ 30 minutes).",
    "Idioma": "Langue",
    "COBROS SEGUROS": "PAIEMENTS SÉCURISÉS",
    "No pudimos conectar. Vuelve a intentar en unos instantes.": "Connexion impossible. Réessayez dans quelques instants.",
    "Preparando tu promoción…": "Préparation de votre promotion…",
    "Pago confirmado": "Paiement confirmé",
    "El intento de pago venció": "La tentative de paiement a expiré",
    "Estamos verificando tu pago": "Nous vérifions votre paiement",
    "El negocio ya tiene registrado el pago con tu descuento.": "L’entreprise a enregistré votre paiement avec réduction.",
    "No realices otro pago si ya recibiste un cargo. Actualiza la confirmación en unos instantes.": "Ne payez pas à nouveau si vous avez déjà été débité. Actualisez la confirmation dans quelques instants.",
    "Actualizar confirmación": "Actualiser la confirmation",
    "PROMOCIÓN ESPECIAL": "PROMOTION SPÉCIALE",
    "DE DESCUENTO": "DE RÉDUCTION",
    "Tu descuento ya está aplicado": "Votre réduction est déjà appliquée",
    "Ahorras": "Vous économisez",
    "Total a pagar": "Total à payer",
    "Válida hasta {date}. Precio final indicado por el negocio.": "Valable jusqu’au {date}. Prix final fixé par l’entreprise.",
    "No completaste el pago. Puedes volver a intentarlo.": "Le paiement n’a pas été terminé. Vous pouvez réessayer.",
    "Abriendo Stripe…": "Ouverture de Stripe…",
    "Pagar {amount}": "Payer {amount}",
    "Pagarás en la página segura de Stripe. No necesitas instalar BRIEFCASE ni crear una cuenta.": "Vous paierez sur la page sécurisée de Stripe. Aucune installation de BRIEFCASE ni création de compte n’est nécessaire.",
    "Oferta compartida por el negocio. No acumulable con otros descuentos.": "Offre partagée par l’entreprise. Non cumulable avec d’autres réductions.",
    "Promoción no disponible": "Promotion indisponible",
    "Consulta al negocio por una oferta vigente.": "Demandez à l’entreprise une offre en cours.",
    "Volver a consultar": "Vérifier à nouveau",
    "Los productos, servicios y condiciones corresponden al negocio que comparte esta promoción.": "Les produits, services et conditions relèvent de l’entreprise qui partage cette promotion."
  }
};

const operationalCopy = {
  "es": {
    "Tu URL de Kiosko": "Tu URL de Kiosko",
    "Abre este link en cualquier tablet o teléfono en la entrada. Tus empleados marcan con su PIN de 4 dígitos.": "Abre este link en cualquier tablet o teléfono en la entrada. Tus empleados marcan con su PIN de 4 dígitos.",
    "¡Copiado!": "¡Copiado!",
    "Copiar": "Copiar",
    "Abrir": "Abrir",
    "No se pudo cargar el acceso al kiosco.": "No se pudo cargar el acceso al kiosco.",
    "No se pudo cargar la asistencia. Los marcajes están desactivados hasta recuperar los datos.": "No se pudo cargar la asistencia. Los marcajes están desactivados hasta recuperar los datos.",
    "Empleados activos": "Empleados activos",
    "Adentro ahora": "Adentro ahora",
    "Marcajes hoy": "Marcajes hoy",
    "Horas 7d": "Horas 7d",
    "Nadie ha marcado entrada hoy.": "Nadie ha marcado entrada hoy.",
    "desde": "desde",
    "Fuera / sin marcar": "Fuera / sin marcar",
    "¡Todos están adentro!": "¡Todos están adentro!",
    "sin PIN": "sin PIN",
    "Entrada": "Entrada",
    "Salida": "Salida",
    "Horas últimos 7 días": "Horas últimos 7 días",
    "No se pudieron cargar las horas.": "No se pudieron cargar las horas.",
    "Sin horas registradas aún.": "Sin horas registradas aún.",
    "Horas": "Horas",
    "Extra": "Extra",
    "Extras": "Extras",
    "Días": "Días",
    "Reporte de productividad": "Reporte de productividad",
    "Escanea para abrir el Kiosko": "Escanea para abrir el Kiosko",
    "Apunta la cámara del tablet/celular de la entrada.": "Apunta la cámara del tablet/celular de la entrada.",
    "No se pudo marcar": "No se pudo marcar",
    "Entrada registrada para {name}": "Entrada registrada para {name}",
    "Salida registrada para {name}": "Salida registrada para {name}",
    "No se pudo crear la tarea": "No se pudo crear la tarea",
    "No se pudo actualizar": "No se pudo actualizar",
    "¿Borrar esta tarea?": "¿Borrar esta tarea?",
    "No se pudo borrar": "No se pudo borrar",
    "Completadas": "Completadas",
    "Completada": "Completada",
    "Todos los empleados": "Todos los empleados",
    "Asignar tarea": "Asignar tarea",
    "No se pudieron cargar las tareas.": "No se pudieron cargar las tareas.",
    "Sin tareas": "Sin tareas",
    "Asigna labores a tus empleados con el botón \"Asignar tarea\".": "Asigna labores a tus empleados con el botón \"Asignar tarea\".",
    "Define la tarea, el responsable y la fecha límite.": "Define la tarea, el responsable y la fecha límite.",
    "Título de la tarea": "Título de la tarea",
    "Prioridad baja": "Prioridad baja",
    "Prioridad media": "Prioridad media",
    "Prioridad alta": "Prioridad alta",
    "Fecha límite": "Fecha límite",
    "Pendiente": "Pendiente",
    "Pendientes": "Pendientes",
    "En progreso": "En progreso",
    "Todos los estados": "Todos los estados",
    "Descripción (opcional)": "Descripción (opcional)",
    "-- Seleccionar empleado --": "-- Seleccionar empleado --",
    "Guardando...": "Guardando...",
    "Baja": "Baja",
    "Media": "Media",
    "Alta": "Alta",
    "No se pudo exportar Excel": "No se pudo exportar Excel",
    "No se pudo exportar PDF": "No se pudo exportar PDF",
    "Productividad": "Productividad",
    "Revisa la información y los detalles de esta herramienta.": "Revisa la información y los detalles de esta herramienta.",
    "Últimos 7 días": "Últimos 7 días",
    "Últimos 14 días": "Últimos 14 días",
    "Últimos 30 días": "Últimos 30 días",
    "Generando reporte...": "Generando reporte...",
    "No se pudo cargar el reporte.": "No se pudo cargar el reporte.",
    "No hay datos para mostrar": "No hay datos para mostrar",
    "Horas totales": "Horas totales",
    "Horas extras": "Horas extras",
    "Tareas completadas": "Tareas completadas",
    "Horas trabajadas por día": "Horas trabajadas por día",
    "Aún no hay horas registradas en este rango.": "Aún no hay horas registradas en este rango.",
    "Ver horas por fecha": "Ver horas por fecha",
    "Horas registradas por día": "Horas registradas por día",
    "Top empleados": "Top empleados",
    "Desglose por empleado": "Desglose por empleado",
    "Sin actividad de empleados.": "Sin actividad de empleados.",
    "Exporta este reporte para liquidar nómina o compartir con tu contador.": "Exporta este reporte para liquidar nómina o compartir con tu contador.",
    "Reporte de Productividad": "Reporte de Productividad",
    "Período": "Período",
    "Métrica": "Métrica",
    "Valor": "Valor",
    "Horas totales trabajadas": "Horas totales trabajadas",
    "Empleados que trabajaron": "Empleados que trabajaron",
    "Por empleado": "Por empleado",
    "Resumen": "Resumen",
    "Empleado": "Empleado",
    "Puesto": "Puesto",
    "Tareas": "Tareas",
    "Tareas/Hora": "Tareas/Hora",
    "Horas por día": "Horas por día",
    "Fecha": "Fecha",
    "Período del reporte": "Período del reporte",
    "HORAS TOTALES": "HORAS TOTALES",
    "HORAS EXTRAS": "HORAS EXTRAS",
    "TAREAS COMPLETADAS": "TAREAS COMPLETADAS",
    "EMPLEADOS": "EMPLEADOS",
    "Generado por BRIEFCASE": "Generado por BRIEFCASE",
    "Del {from} al {to} · {days} días": "Del {from} al {to} · {days} días",
    "Reloj Checador": "Reloj Checador",
    "Reporte": "Reporte",
    "Cámara": "Cámara",
    "Archivo": "Archivo",
    "Manual": "Manual",
    "¿Deseas agregar este producto al inventario?": "¿Deseas agregar este producto al inventario?",
    "Agregar Nuevo Producto": "Agregar Nuevo Producto",
    "Iniciando cámara...": "Iniciando cámara...",
    "📸 Consejos para mejor escaneo:": "📸 Consejos para mejor escaneo:",
    "• Mantén el código de barras dentro del recuadro.": "• Mantén el código de barras dentro del recuadro.",
    "• Asegúrate de tener buena iluminación.": "• Asegúrate de tener buena iluminación.",
    "• Mantén el teléfono a 10-15 cm del código.": "• Mantén el teléfono a 10-15 cm del código.",
    "• Si no funciona, prueba el modo Archivo o Manual.": "• Si no funciona, prueba el modo Archivo o Manual.",
    "Procesando imagen...": "Procesando imagen...",
    "Escanear desde imagen": "Escanear desde imagen",
    "Toca para tomar foto o seleccionar imagen": "Toca para tomar foto o seleccionar imagen",
    "✨ Mejor opción para móviles:": "✨ Mejor opción para móviles:",
    "• Ideal cuando la cámara en vivo no funciona": "• Ideal cuando la cámara en vivo no funciona",
    "• Toma una foto clara del código de barras": "• Toma una foto clara del código de barras",
    "• Funciona en todos los navegadores y dispositivos": "• Funciona en todos los navegadores y dispositivos",
    "💡 Cómo usar:": "💡 Cómo usar:",
    "Lector USB:": "Lector USB:",
    "Solo apunta al código de barras. Se leerá automáticamente.": "Solo apunta al código de barras. Se leerá automáticamente.",
    "Manual:": "Manual:",
    "Escribe el código y presiona Enter o clic en Buscar.": "Escribe el código y presiona Enter o clic en Buscar.",
    "Cámara:": "Cámara:",
    "Cambia al modo Cámara arriba si prefieres usar tu cámara.": "Cambia al modo Cámara arriba si prefieres usar tu cámara.",
    "Código escaneado:": "Código escaneado:",
    "Ajustar Stock:": "Ajustar Stock:",
    "Nuevo stock:": "Nuevo stock:",
    "Actualizar Stock": "Actualizar Stock",
    "Productos Escaneados (": "Productos Escaneados (",
    "Sistema:": "Sistema:",
    "Finalizar Conteo": "Finalizar Conteo",
    "Limpiar": "Limpiar",
    "Conteo de Inventario": "Conteo de Inventario",
    "Escáner de Código": "Escáner de Código",
    "Escanea productos para contar": "Escanea productos para contar",
    "Escanea o ingresa el código de barras": "Escanea o ingresa el código de barras",
    "Desactivar sonido": "Desactivar sonido",
    "Activar sonido": "Activar sonido",
    "El stock no puede ser negativo": "El stock no puede ser negativo",
    "No se pudo leer el código de barras de la imagen. Intenta con otra imagen más clara.": "No se pudo leer el código de barras de la imagen. Intenta con otra imagen más clara.",
    "Producto no encontrado con código: {code}": "Producto no encontrado con código: {code}",
    "No se pudo acceder a la cámara. Opciones:\n• Usa el modo 'Archivo' para escanear una foto\n• Usa el modo 'Manual/USB' para escribir el código\n• Verifica los permisos de cámara en tu navegador": "No se pudo acceder a la cámara. Opciones:\n• Usa el modo 'Archivo' para escanear una foto\n• Usa el modo 'Manual/USB' para escribir el código\n• Verifica los permisos de cámara en tu navegador",
    "QR del kiosco": "QR del kiosco",
    "QR para abrir el kiosco": "QR para abrir el kiosco",
    "Escanea con lector USB o escribe el código...": "Escanea con lector USB o escribe el código...",
    "Código de barras o SKU": "Código de barras o SKU",
    "Seleccionar cámara": "Seleccionar cámara",
    "Cerrar aviso": "Cerrar aviso",
    "Precio": "Precio",
    "Categoría": "Categoría",
    "Revisa los detalles antes de guardar.": "Revisa los detalles antes de guardar.",
    "tareas": "tareas",
    "Refrescar": "Refrescar"
  },
  "en": {
    "Tu URL de Kiosko": "Your kiosk link",
    "Abre este link en cualquier tablet o teléfono en la entrada. Tus empleados marcan con su PIN de 4 dígitos.": "Open this link on a tablet or phone at the entrance. Employees clock in using their 4-digit PIN.",
    "¡Copiado!": "Copied!",
    "Copiar": "Copy",
    "Abrir": "Open",
    "No se pudo cargar el acceso al kiosco.": "Could not load kiosk access.",
    "No se pudo cargar la asistencia. Los marcajes están desactivados hasta recuperar los datos.": "Could not load attendance. Clocking is disabled until the data is recovered.",
    "Empleados activos": "Active employees",
    "Adentro ahora": "Currently clocked in",
    "Marcajes hoy": "Today’s clock events",
    "Horas 7d": "Hours · 7 days",
    "Nadie ha marcado entrada hoy.": "Nobody has clocked in today.",
    "desde": "since",
    "Fuera / sin marcar": "Out / not clocked in",
    "¡Todos están adentro!": "Everyone is clocked in!",
    "sin PIN": "no PIN",
    "Entrada": "Clock in",
    "Salida": "Clock out",
    "Horas últimos 7 días": "Hours in the last 7 days",
    "No se pudieron cargar las horas.": "Could not load hours.",
    "Sin horas registradas aún.": "No hours recorded yet.",
    "Horas": "Hours",
    "Extra": "Overtime",
    "Extras": "Overtime",
    "Días": "Days",
    "Reporte de productividad": "Productivity report",
    "Escanea para abrir el Kiosko": "Scan to open the kiosk",
    "Apunta la cámara del tablet/celular de la entrada.": "Use the camera on the tablet or phone at the entrance.",
    "No se pudo marcar": "Could not record the clock event",
    "Entrada registrada para {name}": "Clock-in recorded for {name}",
    "Salida registrada para {name}": "Clock-out recorded for {name}",
    "No se pudo crear la tarea": "Could not create the task",
    "No se pudo actualizar": "Could not update",
    "¿Borrar esta tarea?": "Delete this task?",
    "No se pudo borrar": "Could not delete",
    "Completadas": "Completed",
    "Completada": "Completed",
    "Todos los empleados": "All employees",
    "Asignar tarea": "Assign task",
    "No se pudieron cargar las tareas.": "Could not load tasks.",
    "Sin tareas": "No tasks",
    "Asigna labores a tus empleados con el botón \"Asignar tarea\".": "Assign work to your employees using the “Assign task” button.",
    "Define la tarea, el responsable y la fecha límite.": "Set the task, assignee and due date.",
    "Título de la tarea": "Task title",
    "Prioridad baja": "Low priority",
    "Prioridad media": "Medium priority",
    "Prioridad alta": "High priority",
    "Fecha límite": "Due date",
    "Pendiente": "Pending",
    "Pendientes": "Pending",
    "En progreso": "In progress",
    "Todos los estados": "All statuses",
    "Descripción (opcional)": "Description (optional)",
    "-- Seleccionar empleado --": "-- Select employee --",
    "Guardando...": "Saving…",
    "Baja": "Low",
    "Media": "Medium",
    "Alta": "High",
    "No se pudo exportar Excel": "Could not export Excel",
    "No se pudo exportar PDF": "Could not export PDF",
    "Productividad": "Productivity",
    "Revisa la información y los detalles de esta herramienta.": "Review the information and details of this tool.",
    "Últimos 7 días": "Last 7 days",
    "Últimos 14 días": "Last 14 days",
    "Últimos 30 días": "Last 30 days",
    "Generando reporte...": "Generating report…",
    "No se pudo cargar el reporte.": "Could not load the report.",
    "No hay datos para mostrar": "No data to display",
    "Horas totales": "Total hours",
    "Horas extras": "Overtime hours",
    "Tareas completadas": "Completed tasks",
    "Horas trabajadas por día": "Hours worked per day",
    "Aún no hay horas registradas en este rango.": "No hours have been recorded in this date range.",
    "Ver horas por fecha": "View hours by date",
    "Horas registradas por día": "Hours recorded per day",
    "Top empleados": "Top employees",
    "Desglose por empleado": "Breakdown by employee",
    "Sin actividad de empleados.": "No employee activity.",
    "Exporta este reporte para liquidar nómina o compartir con tu contador.": "Export this report to prepare payroll or share it with your accountant.",
    "Reporte de Productividad": "Productivity Report",
    "Período": "Period",
    "Métrica": "Metric",
    "Valor": "Value",
    "Horas totales trabajadas": "Total hours worked",
    "Empleados que trabajaron": "Employees who worked",
    "Por empleado": "By employee",
    "Resumen": "Summary",
    "Empleado": "Employee",
    "Puesto": "Position",
    "Tareas": "Tasks",
    "Tareas/Hora": "Tasks/hour",
    "Horas por día": "Hours per day",
    "Fecha": "Date",
    "Período del reporte": "Report period",
    "HORAS TOTALES": "TOTAL HOURS",
    "HORAS EXTRAS": "OVERTIME HOURS",
    "TAREAS COMPLETADAS": "COMPLETED TASKS",
    "EMPLEADOS": "EMPLOYEES",
    "Generado por BRIEFCASE": "Generated by BRIEFCASE",
    "Del {from} al {to} · {days} días": "{from} to {to} · {days} days",
    "Reloj Checador": "Time Clock",
    "Reporte": "Report",
    "Cámara": "Camera",
    "Archivo": "File",
    "Manual": "Manual",
    "¿Deseas agregar este producto al inventario?": "Would you like to add this product to inventory?",
    "Agregar Nuevo Producto": "Add New Product",
    "Iniciando cámara...": "Starting camera…",
    "📸 Consejos para mejor escaneo:": "📸 Tips for better scanning:",
    "• Mantén el código de barras dentro del recuadro.": "• Keep the barcode inside the frame.",
    "• Asegúrate de tener buena iluminación.": "• Make sure there is enough light.",
    "• Mantén el teléfono a 10-15 cm del código.": "• Hold the phone 10–15 cm from the code.",
    "• Si no funciona, prueba el modo Archivo o Manual.": "• If it does not work, try File or Manual mode.",
    "Procesando imagen...": "Processing image…",
    "Escanear desde imagen": "Scan from an image",
    "Toca para tomar foto o seleccionar imagen": "Tap to take a photo or select an image",
    "✨ Mejor opción para móviles:": "✨ Recommended for mobile devices:",
    "• Ideal cuando la cámara en vivo no funciona": "• Useful when the live camera does not work",
    "• Toma una foto clara del código de barras": "• Take a clear photo of the barcode",
    "• Funciona en todos los navegadores y dispositivos": "• An alternative for scanning from your device",
    "💡 Cómo usar:": "💡 How to use:",
    "Lector USB:": "USB scanner:",
    "Solo apunta al código de barras. Se leerá automáticamente.": "Point the scanner at the barcode. It will be read automatically.",
    "Manual:": "Manual:",
    "Escribe el código y presiona Enter o clic en Buscar.": "Enter the code, then press Enter or click Search.",
    "Cámara:": "Camera:",
    "Cambia al modo Cámara arriba si prefieres usar tu cámara.": "Switch to Camera mode above to use your camera.",
    "Código escaneado:": "Scanned code:",
    "Ajustar Stock:": "Adjust stock:",
    "Nuevo stock:": "New stock:",
    "Actualizar Stock": "Update stock",
    "Productos Escaneados (": "Scanned products (",
    "Sistema:": "System:",
    "Finalizar Conteo": "Finish count",
    "Limpiar": "Clear",
    "Conteo de Inventario": "Inventory count",
    "Escáner de Código": "Code scanner",
    "Escanea productos para contar": "Scan products to count them",
    "Escanea o ingresa el código de barras": "Scan or enter the barcode",
    "Desactivar sonido": "Turn sound off",
    "Activar sonido": "Turn sound on",
    "El stock no puede ser negativo": "Stock cannot be negative",
    "No se pudo leer el código de barras de la imagen. Intenta con otra imagen más clara.": "Could not read the barcode in this image. Try a clearer image.",
    "Producto no encontrado con código: {code}": "No product found with code: {code}",
    "No se pudo acceder a la cámara. Opciones:\n• Usa el modo 'Archivo' para escanear una foto\n• Usa el modo 'Manual/USB' para escribir el código\n• Verifica los permisos de cámara en tu navegador": "Could not access the camera. Options:\n• Use File mode to scan a photo\n• Use Manual/USB mode to enter the code\n• Check the camera permissions in your browser",
    "QR del kiosco": "Kiosk QR code",
    "QR para abrir el kiosco": "QR code to open the kiosk",
    "Escanea con lector USB o escribe el código...": "Scan with a USB reader or enter the code…",
    "Código de barras o SKU": "Barcode or SKU",
    "Seleccionar cámara": "Select camera",
    "Cerrar aviso": "Dismiss message",
    "Precio": "Price",
    "Categoría": "Category",
    "Revisa los detalles antes de guardar.": "Review the details before saving.",
    "tareas": "tasks",
    "Refrescar": "Refresh"
  },
  "pt": {
    "Tu URL de Kiosko": "Seu link do quiosque",
    "Abre este link en cualquier tablet o teléfono en la entrada. Tus empleados marcan con su PIN de 4 dígitos.": "Abra este link em um tablet ou telefone na entrada. Os funcionários registram o ponto com seu PIN de 4 dígitos.",
    "¡Copiado!": "Copiado!",
    "Copiar": "Copiar",
    "Abrir": "Abrir",
    "No se pudo cargar el acceso al kiosco.": "Não foi possível carregar o acesso ao quiosque.",
    "No se pudo cargar la asistencia. Los marcajes están desactivados hasta recuperar los datos.": "Não foi possível carregar a frequência. O registro de ponto está desativado até recuperar os dados.",
    "Empleados activos": "Funcionários ativos",
    "Adentro ahora": "Presentes agora",
    "Marcajes hoy": "Registros de ponto hoje",
    "Horas 7d": "Horas · 7 dias",
    "Nadie ha marcado entrada hoy.": "Ninguém registrou entrada hoje.",
    "desde": "desde",
    "Fuera / sin marcar": "Fora / sem registro",
    "¡Todos están adentro!": "Todos registraram entrada!",
    "sin PIN": "sem PIN",
    "Entrada": "Entrada",
    "Salida": "Saída",
    "Horas últimos 7 días": "Horas dos últimos 7 dias",
    "No se pudieron cargar las horas.": "Não foi possível carregar as horas.",
    "Sin horas registradas aún.": "Ainda não há horas registradas.",
    "Horas": "Horas",
    "Extra": "Horas extras",
    "Extras": "Horas extras",
    "Días": "Dias",
    "Reporte de productividad": "Relatório de produtividade",
    "Escanea para abrir el Kiosko": "Escaneie para abrir o quiosque",
    "Apunta la cámara del tablet/celular de la entrada.": "Use a câmera do tablet ou telefone da entrada.",
    "No se pudo marcar": "Não foi possível registrar o ponto",
    "Entrada registrada para {name}": "Entrada registrada para {name}",
    "Salida registrada para {name}": "Saída registrada para {name}",
    "No se pudo crear la tarea": "Não foi possível criar a tarefa",
    "No se pudo actualizar": "Não foi possível atualizar",
    "¿Borrar esta tarea?": "Excluir esta tarefa?",
    "No se pudo borrar": "Não foi possível excluir",
    "Completadas": "Concluídas",
    "Completada": "Concluída",
    "Todos los empleados": "Todos os funcionários",
    "Asignar tarea": "Atribuir tarefa",
    "No se pudieron cargar las tareas.": "Não foi possível carregar as tarefas.",
    "Sin tareas": "Sem tarefas",
    "Asigna labores a tus empleados con el botón \"Asignar tarea\".": "Atribua atividades aos funcionários com o botão “Atribuir tarefa”.",
    "Define la tarea, el responsable y la fecha límite.": "Defina a tarefa, o responsável e o prazo.",
    "Título de la tarea": "Título da tarefa",
    "Prioridad baja": "Prioridade baixa",
    "Prioridad media": "Prioridade média",
    "Prioridad alta": "Prioridade alta",
    "Fecha límite": "Prazo",
    "Pendiente": "Pendente",
    "Pendientes": "Pendentes",
    "En progreso": "Em andamento",
    "Todos los estados": "Todos os estados",
    "Descripción (opcional)": "Descrição (opcional)",
    "-- Seleccionar empleado --": "-- Selecione um funcionário --",
    "Guardando...": "Salvando…",
    "Baja": "Baixa",
    "Media": "Média",
    "Alta": "Alta",
    "No se pudo exportar Excel": "Não foi possível exportar Excel",
    "No se pudo exportar PDF": "Não foi possível exportar PDF",
    "Productividad": "Produtividade",
    "Revisa la información y los detalles de esta herramienta.": "Revise as informações e os detalhes desta ferramenta.",
    "Últimos 7 días": "Últimos 7 dias",
    "Últimos 14 días": "Últimos 14 dias",
    "Últimos 30 días": "Últimos 30 dias",
    "Generando reporte...": "Gerando relatório…",
    "No se pudo cargar el reporte.": "Não foi possível carregar o relatório.",
    "No hay datos para mostrar": "Não há dados para mostrar",
    "Horas totales": "Total de horas",
    "Horas extras": "Horas extras",
    "Tareas completadas": "Tarefas concluídas",
    "Horas trabajadas por día": "Horas trabalhadas por dia",
    "Aún no hay horas registradas en este rango.": "Ainda não há horas registradas neste período.",
    "Ver horas por fecha": "Ver horas por data",
    "Horas registradas por día": "Horas registradas por dia",
    "Top empleados": "Destaques da equipe",
    "Desglose por empleado": "Detalhamento por funcionário",
    "Sin actividad de empleados.": "Nenhuma atividade dos funcionários.",
    "Exporta este reporte para liquidar nómina o compartir con tu contador.": "Exporte este relatório para preparar a folha de pagamento ou compartilhar com seu contador.",
    "Reporte de Productividad": "Relatório de Produtividade",
    "Período": "Período",
    "Métrica": "Métrica",
    "Valor": "Valor",
    "Horas totales trabajadas": "Total de horas trabalhadas",
    "Empleados que trabajaron": "Funcionários que trabalharam",
    "Por empleado": "Por funcionário",
    "Resumen": "Resumo",
    "Empleado": "Funcionário",
    "Puesto": "Cargo",
    "Tareas": "Tarefas",
    "Tareas/Hora": "Tarefas/hora",
    "Horas por día": "Horas por dia",
    "Fecha": "Data",
    "Período del reporte": "Período do relatório",
    "HORAS TOTALES": "TOTAL DE HORAS",
    "HORAS EXTRAS": "HORAS EXTRAS",
    "TAREAS COMPLETADAS": "TAREFAS CONCLUÍDAS",
    "EMPLEADOS": "FUNCIONÁRIOS",
    "Generado por BRIEFCASE": "Gerado por BRIEFCASE",
    "Del {from} al {to} · {days} días": "De {from} a {to} · {days} dias",
    "Reloj Checador": "Relógio de ponto",
    "Reporte": "Relatório",
    "Cámara": "Câmera",
    "Archivo": "Arquivo",
    "Manual": "Manual",
    "¿Deseas agregar este producto al inventario?": "Deseja adicionar este produto ao estoque?",
    "Agregar Nuevo Producto": "Adicionar novo produto",
    "Iniciando cámara...": "Iniciando câmera…",
    "📸 Consejos para mejor escaneo:": "📸 Dicas para escanear melhor:",
    "• Mantén el código de barras dentro del recuadro.": "• Mantenha o código de barras dentro da área.",
    "• Asegúrate de tener buena iluminación.": "• Garanta uma boa iluminação.",
    "• Mantén el teléfono a 10-15 cm del código.": "• Mantenha o telefone a 10–15 cm do código.",
    "• Si no funciona, prueba el modo Archivo o Manual.": "• Se não funcionar, tente o modo Arquivo ou Manual.",
    "Procesando imagen...": "Processando imagem…",
    "Escanear desde imagen": "Escanear a partir de imagem",
    "Toca para tomar foto o seleccionar imagen": "Toque para tirar uma foto ou selecionar uma imagem",
    "✨ Mejor opción para móviles:": "✨ Recomendado para dispositivos móveis:",
    "• Ideal cuando la cámara en vivo no funciona": "• Útil quando a câmera ao vivo não funciona",
    "• Toma una foto clara del código de barras": "• Tire uma foto nítida do código de barras",
    "• Funciona en todos los navegadores y dispositivos": "• Uma alternativa para escanear no seu dispositivo",
    "💡 Cómo usar:": "💡 Como usar:",
    "Lector USB:": "Leitor USB:",
    "Solo apunta al código de barras. Se leerá automáticamente.": "Aponte o leitor para o código de barras. A leitura será automática.",
    "Manual:": "Manual:",
    "Escribe el código y presiona Enter o clic en Buscar.": "Digite o código e pressione Enter ou clique em Buscar.",
    "Cámara:": "Câmera:",
    "Cambia al modo Cámara arriba si prefieres usar tu cámara.": "Mude para o modo Câmera acima para usar sua câmera.",
    "Código escaneado:": "Código escaneado:",
    "Ajustar Stock:": "Ajustar estoque:",
    "Nuevo stock:": "Novo estoque:",
    "Actualizar Stock": "Atualizar estoque",
    "Productos Escaneados (": "Produtos escaneados (",
    "Sistema:": "Sistema:",
    "Finalizar Conteo": "Finalizar contagem",
    "Limpiar": "Limpar",
    "Conteo de Inventario": "Contagem de estoque",
    "Escáner de Código": "Leitor de código",
    "Escanea productos para contar": "Escaneie produtos para contar",
    "Escanea o ingresa el código de barras": "Escaneie ou digite o código de barras",
    "Desactivar sonido": "Desativar som",
    "Activar sonido": "Ativar som",
    "El stock no puede ser negativo": "O estoque não pode ser negativo",
    "No se pudo leer el código de barras de la imagen. Intenta con otra imagen más clara.": "Não foi possível ler o código de barras da imagem. Tente uma imagem mais nítida.",
    "Producto no encontrado con código: {code}": "Produto não encontrado com o código: {code}",
    "No se pudo acceder a la cámara. Opciones:\n• Usa el modo 'Archivo' para escanear una foto\n• Usa el modo 'Manual/USB' para escribir el código\n• Verifica los permisos de cámara en tu navegador": "Não foi possível acessar a câmera. Opções:\n• Use o modo Arquivo para escanear uma foto\n• Use o modo Manual/USB para digitar o código\n• Verifique as permissões da câmera no navegador",
    "QR del kiosco": "QR do quiosque",
    "QR para abrir el kiosco": "QR para abrir o quiosque",
    "Escanea con lector USB o escribe el código...": "Escaneie com um leitor USB ou digite o código…",
    "Código de barras o SKU": "Código de barras ou SKU",
    "Seleccionar cámara": "Selecionar câmera",
    "Cerrar aviso": "Fechar aviso",
    "Precio": "Preço",
    "Categoría": "Categoria",
    "Revisa los detalles antes de guardar.": "Revise os detalhes antes de salvar.",
    "tareas": "tarefas",
    "Refrescar": "Atualizar"
  },
  "fr": {
    "Tu URL de Kiosko": "Votre lien de borne",
    "Abre este link en cualquier tablet o teléfono en la entrada. Tus empleados marcan con su PIN de 4 dígitos.": "Ouvrez ce lien sur une tablette ou un téléphone à l’entrée. Les employés pointent avec leur code PIN à 4 chiffres.",
    "¡Copiado!": "Copié !",
    "Copiar": "Copier",
    "Abrir": "Ouvrir",
    "No se pudo cargar el acceso al kiosco.": "Impossible de charger l’accès à la borne.",
    "No se pudo cargar la asistencia. Los marcajes están desactivados hasta recuperar los datos.": "Impossible de charger les présences. Le pointage est désactivé jusqu’au rétablissement des données.",
    "Empleados activos": "Employés actifs",
    "Adentro ahora": "Actuellement présents",
    "Marcajes hoy": "Pointages du jour",
    "Horas 7d": "Heures · 7 jours",
    "Nadie ha marcado entrada hoy.": "Personne n’a pointé aujourd’hui.",
    "desde": "depuis",
    "Fuera / sin marcar": "Absents / sans pointage",
    "¡Todos están adentro!": "Tout le monde est présent !",
    "sin PIN": "sans PIN",
    "Entrada": "Entrée",
    "Salida": "Sortie",
    "Horas últimos 7 días": "Heures des 7 derniers jours",
    "No se pudieron cargar las horas.": "Impossible de charger les heures.",
    "Sin horas registradas aún.": "Aucune heure enregistrée pour le moment.",
    "Horas": "Heures",
    "Extra": "Heures supplémentaires",
    "Extras": "Heures supplémentaires",
    "Días": "Jours",
    "Reporte de productividad": "Rapport de productivité",
    "Escanea para abrir el Kiosko": "Scannez pour ouvrir la borne",
    "Apunta la cámara del tablet/celular de la entrada.": "Utilisez la caméra de la tablette ou du téléphone à l’entrée.",
    "No se pudo marcar": "Impossible d’enregistrer le pointage",
    "Entrada registrada para {name}": "Entrée enregistrée pour {name}",
    "Salida registrada para {name}": "Sortie enregistrée pour {name}",
    "No se pudo crear la tarea": "Impossible de créer la tâche",
    "No se pudo actualizar": "Impossible de mettre à jour",
    "¿Borrar esta tarea?": "Supprimer cette tâche ?",
    "No se pudo borrar": "Impossible de supprimer",
    "Completadas": "Terminées",
    "Completada": "Terminée",
    "Todos los empleados": "Tous les employés",
    "Asignar tarea": "Attribuer une tâche",
    "No se pudieron cargar las tareas.": "Impossible de charger les tâches.",
    "Sin tareas": "Aucune tâche",
    "Asigna labores a tus empleados con el botón \"Asignar tarea\".": "Attribuez du travail aux employés avec le bouton « Attribuer une tâche ».",
    "Define la tarea, el responsable y la fecha límite.": "Définissez la tâche, le responsable et l’échéance.",
    "Título de la tarea": "Titre de la tâche",
    "Prioridad baja": "Priorité basse",
    "Prioridad media": "Priorité moyenne",
    "Prioridad alta": "Priorité haute",
    "Fecha límite": "Échéance",
    "Pendiente": "En attente",
    "Pendientes": "En attente",
    "En progreso": "En cours",
    "Todos los estados": "Tous les statuts",
    "Descripción (opcional)": "Description (facultative)",
    "-- Seleccionar empleado --": "-- Sélectionner un employé --",
    "Guardando...": "Enregistrement…",
    "Baja": "Basse",
    "Media": "Moyenne",
    "Alta": "Haute",
    "No se pudo exportar Excel": "Impossible d’exporter Excel",
    "No se pudo exportar PDF": "Impossible d’exporter le PDF",
    "Productividad": "Productivité",
    "Revisa la información y los detalles de esta herramienta.": "Consultez les informations et les détails de cet outil.",
    "Últimos 7 días": "7 derniers jours",
    "Últimos 14 días": "14 derniers jours",
    "Últimos 30 días": "30 derniers jours",
    "Generando reporte...": "Génération du rapport…",
    "No se pudo cargar el reporte.": "Impossible de charger le rapport.",
    "No hay datos para mostrar": "Aucune donnée à afficher",
    "Horas totales": "Total des heures",
    "Horas extras": "Heures supplémentaires",
    "Tareas completadas": "Tâches terminées",
    "Horas trabajadas por día": "Heures travaillées par jour",
    "Aún no hay horas registradas en este rango.": "Aucune heure enregistrée sur cette période.",
    "Ver horas por fecha": "Voir les heures par date",
    "Horas registradas por día": "Heures enregistrées par jour",
    "Top empleados": "Meilleurs employés",
    "Desglose por empleado": "Détail par employé",
    "Sin actividad de empleados.": "Aucune activité des employés.",
    "Exporta este reporte para liquidar nómina o compartir con tu contador.": "Exportez ce rapport pour préparer la paie ou le partager avec votre comptable.",
    "Reporte de Productividad": "Rapport de Productivité",
    "Período": "Période",
    "Métrica": "Indicateur",
    "Valor": "Valeur",
    "Horas totales trabajadas": "Total des heures travaillées",
    "Empleados que trabajaron": "Employés ayant travaillé",
    "Por empleado": "Par employé",
    "Resumen": "Résumé",
    "Empleado": "Employé",
    "Puesto": "Poste",
    "Tareas": "Tâches",
    "Tareas/Hora": "Tâches/heure",
    "Horas por día": "Heures par jour",
    "Fecha": "Date",
    "Período del reporte": "Période du rapport",
    "HORAS TOTALES": "TOTAL DES HEURES",
    "HORAS EXTRAS": "HEURES SUPPL.",
    "TAREAS COMPLETADAS": "TÂCHES TERMINÉES",
    "EMPLEADOS": "EMPLOYÉS",
    "Generado por BRIEFCASE": "Généré par BRIEFCASE",
    "Del {from} al {to} · {days} días": "Du {from} au {to} · {days} jours",
    "Reloj Checador": "Pointeuse",
    "Reporte": "Rapport",
    "Cámara": "Caméra",
    "Archivo": "Fichier",
    "Manual": "Manuel",
    "¿Deseas agregar este producto al inventario?": "Voulez-vous ajouter ce produit au stock ?",
    "Agregar Nuevo Producto": "Ajouter un produit",
    "Iniciando cámara...": "Démarrage de la caméra…",
    "📸 Consejos para mejor escaneo:": "📸 Conseils pour mieux scanner :",
    "• Mantén el código de barras dentro del recuadro.": "• Gardez le code-barres dans le cadre.",
    "• Asegúrate de tener buena iluminación.": "• Assurez-vous d’avoir assez de lumière.",
    "• Mantén el teléfono a 10-15 cm del código.": "• Tenez le téléphone à 10–15 cm du code.",
    "• Si no funciona, prueba el modo Archivo o Manual.": "• Sinon, essayez le mode Fichier ou Manuel.",
    "Procesando imagen...": "Traitement de l’image…",
    "Escanear desde imagen": "Scanner une image",
    "Toca para tomar foto o seleccionar imagen": "Touchez pour prendre une photo ou choisir une image",
    "✨ Mejor opción para móviles:": "✨ Recommandé sur mobile :",
    "• Ideal cuando la cámara en vivo no funciona": "• Utile si la caméra en direct ne fonctionne pas",
    "• Toma una foto clara del código de barras": "• Prenez une photo nette du code-barres",
    "• Funciona en todos los navegadores y dispositivos": "• Une autre façon de scanner depuis votre appareil",
    "💡 Cómo usar:": "💡 Mode d’emploi :",
    "Lector USB:": "Lecteur USB :",
    "Solo apunta al código de barras. Se leerá automáticamente.": "Pointez le lecteur vers le code-barres. La lecture est automatique.",
    "Manual:": "Manuel :",
    "Escribe el código y presiona Enter o clic en Buscar.": "Saisissez le code, puis appuyez sur Entrée ou cliquez sur Rechercher.",
    "Cámara:": "Caméra :",
    "Cambia al modo Cámara arriba si prefieres usar tu cámara.": "Passez au mode Caméra ci-dessus pour utiliser votre caméra.",
    "Código escaneado:": "Code scanné :",
    "Ajustar Stock:": "Ajuster le stock :",
    "Nuevo stock:": "Nouveau stock :",
    "Actualizar Stock": "Mettre à jour le stock",
    "Productos Escaneados (": "Produits scannés (",
    "Sistema:": "Système :",
    "Finalizar Conteo": "Terminer le comptage",
    "Limpiar": "Effacer",
    "Conteo de Inventario": "Comptage du stock",
    "Escáner de Código": "Lecteur de code",
    "Escanea productos para contar": "Scannez les produits pour les compter",
    "Escanea o ingresa el código de barras": "Scannez ou saisissez le code-barres",
    "Desactivar sonido": "Désactiver le son",
    "Activar sonido": "Activer le son",
    "El stock no puede ser negativo": "Le stock ne peut pas être négatif",
    "No se pudo leer el código de barras de la imagen. Intenta con otra imagen más clara.": "Impossible de lire le code-barres de l’image. Essayez une image plus nette.",
    "Producto no encontrado con código: {code}": "Aucun produit trouvé avec le code : {code}",
    "No se pudo acceder a la cámara. Opciones:\n• Usa el modo 'Archivo' para escanear una foto\n• Usa el modo 'Manual/USB' para escribir el código\n• Verifica los permisos de cámara en tu navegador": "Impossible d’accéder à la caméra. Options :\n• Utilisez le mode Fichier pour scanner une photo\n• Utilisez le mode Manuel/USB pour saisir le code\n• Vérifiez les autorisations de caméra du navigateur",
    "QR del kiosco": "Code QR de la borne",
    "QR para abrir el kiosco": "Code QR pour ouvrir la borne",
    "Escanea con lector USB o escribe el código...": "Scannez avec un lecteur USB ou saisissez le code…",
    "Código de barras o SKU": "Code-barres ou référence",
    "Seleccionar cámara": "Choisir la caméra",
    "Cerrar aviso": "Fermer le message",
    "Precio": "Prix",
    "Categoría": "Catégorie",
    "Revisa los detalles antes de guardar.": "Vérifiez les détails avant d’enregistrer.",
    "tareas": "tâches",
    "Refrescar": "Actualiser"
  }
};
const supplemental = {"es": {"Preguntas sugeridas": "Preguntas sugeridas", "Opciones de voz": "Opciones de voz", "Apagar activación por nombre": "Apagar activación por nombre", "Activar voz por «Briefy»": "Activar voz por «Briefy»", "Idioma del reconocimiento de voz": "Idioma del reconocimiento de voz", "Solicitando acceso al micrófono…": "Solicitando acceso al micrófono…", "Micrófono apagado": "Micrófono apagado", "Di «Briefy» para dar una orden": "Di «Briefy» para dar una orden", "Te escucho. Di tu orden y haz una pausa.": "Te escucho. Di tu orden y haz una pausa.", "Dictando. Puedes revisar el texto antes de enviarlo.": "Dictando. Puedes revisar el texto antes de enviarlo.", "Procesando tu orden…": "Procesando tu orden…", "Este navegador no admite reconocimiento de voz. Puedes escribir.": "Este navegador no admite reconocimiento de voz. Puedes escribir.", "El servicio de voz se detuvo. Pulsa el micrófono para volver a intentar.": "El servicio de voz se detuvo. Pulsa el micrófono para volver a intentar.", "Permite el micrófono en tu navegador para usar la voz.": "Permite el micrófono en tu navegador para usar la voz.", "El navegador bloqueó el servicio de voz. Puedes escribir.": "El navegador bloqueó el servicio de voz. Puedes escribir.", "No se detectó un micrófono disponible.": "No se detectó un micrófono disponible.", "Falló la conexión del reconocimiento de voz. Puedes volver a intentar.": "Falló la conexión del reconocimiento de voz. Puedes volver a intentar.", "No se pudo reconocer la voz. Vuelve a intentar.": "No se pudo reconocer la voz. Vuelve a intentar.", "No se pudo iniciar el micrófono. Vuelve a intentar.": "No se pudo iniciar el micrófono. Vuelve a intentar.", "Dictado detenido. Revisa el texto antes de enviarlo.": "Dictado detenido. Revisa el texto antes de enviarlo.", "Dictado terminado. Revisa el texto antes de enviarlo.": "Dictado terminado. Revisa el texto antes de enviarlo.", "Voz pausada al salir de BRIEFCASE. Actívala de nuevo para continuar.": "Voz pausada al salir de BRIEFCASE. Actívala de nuevo para continuar.", "Tu navegador no admite voz. Puedes escribir.": "Tu navegador no admite voz. Puedes escribir.", "Permite el micrófono en el navegador para usar voz.": "Permite el micrófono en el navegador para usar voz.", "No se pudo acceder al micrófono. Revisa el dispositivo.": "No se pudo acceder al micrófono. Revisa el dispositivo.", "Abriendo la herramienta solicitada.": "Abriendo la herramienta solicitada.", "Desactivar activación por Briefy": "Desactivar activación por Briefy", "Di «Briefy» · Apagar": "Di «Briefy» · Apagar", "Abrir asistente BRIEFY": "Abrir asistente BRIEFY", "Actívalo una vez y di «Briefy, abre facturas» o «Briefy, crea una cita…». Solo mientras BRIEFCASE está abierta y visible. El navegador puede procesar el audio con su servicio de voz.": "Actívalo una vez y di «Briefy, abre facturas» o «Briefy, crea una cita…». Solo mientras BRIEFCASE está abierta y visible. El navegador puede procesar el audio con su servicio de voz."}, "en": {"Preguntas sugeridas": "Suggested questions", "Opciones de voz": "Voice options", "Apagar activación por nombre": "Turn off wake word", "Activar voz por «Briefy»": "Enable “Briefy” wake word", "Idioma del reconocimiento de voz": "Speech recognition language", "Solicitando acceso al micrófono…": "Requesting microphone access…", "Micrófono apagado": "Microphone off", "Di «Briefy» para dar una orden": "Say “Briefy” to give a command", "Te escucho. Di tu orden y haz una pausa.": "Listening. Say your command, then pause.", "Dictando. Puedes revisar el texto antes de enviarlo.": "Dictating. Review the text before sending.", "Procesando tu orden…": "Processing your command…", "Este navegador no admite reconocimiento de voz. Puedes escribir.": "This browser does not support speech recognition. You can type.", "El servicio de voz se detuvo. Pulsa el micrófono para volver a intentar.": "Speech recognition stopped. Tap the microphone to try again.", "Permite el micrófono en tu navegador para usar la voz.": "Allow microphone access in your browser to use voice.", "El navegador bloqueó el servicio de voz. Puedes escribir.": "The browser blocked speech recognition. You can type.", "No se detectó un micrófono disponible.": "No microphone was detected.", "Falló la conexión del reconocimiento de voz. Puedes volver a intentar.": "Speech recognition lost its connection. You can try again.", "No se pudo reconocer la voz. Vuelve a intentar.": "Could not recognize speech. Try again.", "No se pudo iniciar el micrófono. Vuelve a intentar.": "Could not start the microphone. Try again.", "Dictado detenido. Revisa el texto antes de enviarlo.": "Dictation stopped. Review the text before sending.", "Dictado terminado. Revisa el texto antes de enviarlo.": "Dictation complete. Review the text before sending.", "Voz pausada al salir de BRIEFCASE. Actívala de nuevo para continuar.": "Voice paused after leaving BRIEFCASE. Enable it again to continue.", "Tu navegador no admite voz. Puedes escribir.": "Your browser does not support voice. You can type.", "Permite el micrófono en el navegador para usar voz.": "Allow microphone access in the browser to use voice.", "No se pudo acceder al micrófono. Revisa el dispositivo.": "Could not access the microphone. Check your device.", "Abriendo la herramienta solicitada.": "Opening the requested tool.", "Desactivar activación por Briefy": "Disable Briefy wake word", "Di «Briefy» · Apagar": "Say “Briefy” · Turn off", "Abrir asistente BRIEFY": "Open BRIEFY assistant", "Actívalo una vez y di «Briefy, abre facturas» o «Briefy, crea una cita…». Solo mientras BRIEFCASE está abierta y visible. El navegador puede procesar el audio con su servicio de voz.": "Enable it once, then say “Briefy, open invoices” or “Briefy, create an appointment…”. Works while BRIEFCASE is open and visible. Your browser may process audio using its speech service."}, "pt": {"Preguntas sugeridas": "Perguntas sugeridas", "Opciones de voz": "Opções de voz", "Apagar activación por nombre": "Desativar palavra de ativação", "Activar voz por «Briefy»": "Ativar voz por «Briefy»", "Idioma del reconocimiento de voz": "Idioma do reconhecimento de voz", "Solicitando acceso al micrófono…": "Solicitando acesso ao microfone…", "Micrófono apagado": "Microfone desligado", "Di «Briefy» para dar una orden": "Diga «Briefy» para dar um comando", "Te escucho. Di tu orden y haz una pausa.": "Estou ouvindo. Diga seu comando e faça uma pausa.", "Dictando. Puedes revisar el texto antes de enviarlo.": "Ditando. Revise o texto antes de enviar.", "Procesando tu orden…": "Processando seu comando…", "Este navegador no admite reconocimiento de voz. Puedes escribir.": "Este navegador não oferece reconhecimento de voz. Você pode digitar.", "El servicio de voz se detuvo. Pulsa el micrófono para volver a intentar.": "O serviço de voz parou. Toque no microfone para tentar novamente.", "Permite el micrófono en tu navegador para usar la voz.": "Permita o acesso ao microfone no navegador para usar a voz.", "El navegador bloqueó el servicio de voz. Puedes escribir.": "O navegador bloqueou o serviço de voz. Você pode digitar.", "No se detectó un micrófono disponible.": "Nenhum microfone disponível foi detectado.", "Falló la conexión del reconocimiento de voz. Puedes volver a intentar.": "A conexão do reconhecimento de voz falhou. Você pode tentar novamente.", "No se pudo reconocer la voz. Vuelve a intentar.": "Não foi possível reconhecer a voz. Tente novamente.", "No se pudo iniciar el micrófono. Vuelve a intentar.": "Não foi possível iniciar o microfone. Tente novamente.", "Dictado detenido. Revisa el texto antes de enviarlo.": "Ditado interrompido. Revise o texto antes de enviar.", "Dictado terminado. Revisa el texto antes de enviarlo.": "Ditado concluído. Revise o texto antes de enviar.", "Voz pausada al salir de BRIEFCASE. Actívala de nuevo para continuar.": "Voz pausada ao sair de BRIEFCASE. Ative novamente para continuar.", "Tu navegador no admite voz. Puedes escribir.": "Seu navegador não oferece suporte à voz. Você pode digitar.", "Permite el micrófono en el navegador para usar voz.": "Permita o microfone no navegador para usar a voz.", "No se pudo acceder al micrófono. Revisa el dispositivo.": "Não foi possível acessar o microfone. Verifique o dispositivo.", "Abriendo la herramienta solicitada.": "Abrindo a ferramenta solicitada.", "Desactivar activación por Briefy": "Desativar palavra de ativação Briefy", "Di «Briefy» · Apagar": "Diga «Briefy» · Desligar", "Abrir asistente BRIEFY": "Abrir assistente BRIEFY", "Actívalo una vez y di «Briefy, abre facturas» o «Briefy, crea una cita…». Solo mientras BRIEFCASE está abierta y visible. El navegador puede procesar el audio con su servicio de voz.": "Ative uma vez e diga «Briefy, abra faturas» ou «Briefy, crie um compromisso…». Funciona enquanto BRIEFCASE estiver aberta e visível. O navegador pode processar o áudio com seu serviço de voz."}, "fr": {"Preguntas sugeridas": "Questions suggérées", "Opciones de voz": "Options vocales", "Apagar activación por nombre": "Désactiver le mot d’activation", "Activar voz por «Briefy»": "Activer la voix avec « Briefy »", "Idioma del reconocimiento de voz": "Langue de reconnaissance vocale", "Solicitando acceso al micrófono…": "Demande d’accès au microphone…", "Micrófono apagado": "Microphone désactivé", "Di «Briefy» para dar una orden": "Dites « Briefy » pour donner une commande", "Te escucho. Di tu orden y haz una pausa.": "Je vous écoute. Dites votre commande, puis faites une pause.", "Dictando. Puedes revisar el texto antes de enviarlo.": "Dictée en cours. Relisez le texte avant de l’envoyer.", "Procesando tu orden…": "Traitement de votre commande…", "Este navegador no admite reconocimiento de voz. Puedes escribir.": "Ce navigateur ne prend pas en charge la reconnaissance vocale. Vous pouvez écrire.", "El servicio de voz se detuvo. Pulsa el micrófono para volver a intentar.": "La reconnaissance vocale s’est arrêtée. Touchez le microphone pour réessayer.", "Permite el micrófono en tu navegador para usar la voz.": "Autorisez le microphone dans votre navigateur pour utiliser la voix.", "El navegador bloqueó el servicio de voz. Puedes escribir.": "Le navigateur a bloqué la reconnaissance vocale. Vous pouvez écrire.", "No se detectó un micrófono disponible.": "Aucun microphone disponible n’a été détecté.", "Falló la conexión del reconocimiento de voz. Puedes volver a intentar.": "La connexion à la reconnaissance vocale a échoué. Vous pouvez réessayer.", "No se pudo reconocer la voz. Vuelve a intentar.": "Impossible de reconnaître la voix. Réessayez.", "No se pudo iniciar el micrófono. Vuelve a intentar.": "Impossible de démarrer le microphone. Réessayez.", "Dictado detenido. Revisa el texto antes de enviarlo.": "Dictée arrêtée. Relisez le texte avant de l’envoyer.", "Dictado terminado. Revisa el texto antes de enviarlo.": "Dictée terminée. Relisez le texte avant de l’envoyer.", "Voz pausada al salir de BRIEFCASE. Actívala de nuevo para continuar.": "Voix mise en pause en quittant BRIEFCASE. Réactivez-la pour continuer.", "Tu navegador no admite voz. Puedes escribir.": "Votre navigateur ne prend pas en charge la voix. Vous pouvez écrire.", "Permite el micrófono en el navegador para usar voz.": "Autorisez le microphone dans le navigateur pour utiliser la voix.", "No se pudo acceder al micrófono. Revisa el dispositivo.": "Impossible d’accéder au microphone. Vérifiez l’appareil.", "Abriendo la herramienta solicitada.": "Ouverture de l’outil demandé.", "Desactivar activación por Briefy": "Désactiver le mot d’activation Briefy", "Di «Briefy» · Apagar": "Dites « Briefy » · Désactiver", "Abrir asistente BRIEFY": "Ouvrir l’assistant BRIEFY", "Actívalo una vez y di «Briefy, abre facturas» o «Briefy, crea una cita…». Solo mientras BRIEFCASE está abierta y visible. El navegador puede procesar el audio con su servicio de voz.": "Activez une fois, puis dites « Briefy, ouvre les factures » ou « Briefy, crée un rendez-vous… ». Fonctionne lorsque BRIEFCASE est ouverte et visible. Le navigateur peut traiter l’audio avec son service vocal."}};
const messages = {
  "es": {
    "Desde": "Desde",
    "Período:": "Período:",
    "Base:": "Base:",
    "+Bonos:": "+Bonos:",
    "-Deducciones:": "-Deducciones:",
    "Neto a pagar": "Neto a pagar",
    "Neto a pagar:": "Neto a pagar:",
    "Marcar como pagado": "Marcar como pagado",
    "Compartir recibo": "Compartir recibo",
    "Registrar Asistencia": "Registrar Asistencia",
    "Presente": "Presente",
    "Ausente": "Ausente",
    "Tardanza": "Tardanza",
    "vacaciones": "vacaciones",
    "enfermedad": "enfermedad",
    "Horas": "Horas",
    "+ Registrar primera asistencia": "+ Registrar primera asistencia",
    "Empleado *": "Empleado *",
    "Seleccionar empleado": "Seleccionar empleado",
    "Seleccionar empleado...": "Seleccionar empleado...",
    "Fecha *": "Fecha *",
    "Hora Entrada": "Hora Entrada",
    "Hora Salida": "Hora Salida",
    "Notas adicionales...": "Notas adicionales...",
    "Escanear Pay Stub": "Escanear recibo de nómina",
    "Crear Pay Stub": "Crear recibo de nómina",
    "+ Crear primer pay stub": "+ Crear primer recibo de nómina",
    "Pay Stub": "Recibo de nómina",
    "Fecha de Pago:": "Fecha de Pago:",
    "Bruto:": "Bruto:",
    "Pago Neto": "Pago Neto",
    "Ver pay stub": "Ver recibo de nómina",
    "Completa los datos y confirma la tarifa por hora. Puedes revisar y ajustar las deducciones antes de guardar.": "Completa los datos y confirma la tarifa por hora. Puedes revisar y ajustar las deducciones antes de guardar.",
    "Los importes se redondean a centavos por concepto. Las retenciones sugeridas son estimaciones editables; los valores que cambies manualmente se conservan.": "Los importes se redondean a centavos por concepto. Las retenciones sugeridas son estimaciones editables; los valores que cambies manualmente se conservan.",
    "-- Seleccionar empleado --": "-- Seleccionar empleado --",
    "⚠️ Primero debes agregar empleados en el tab \"Empleados\"": "⚠️ Primero debes agregar empleados en el tab \"Empleados\"",
    "Empresa *": "Empresa *",
    "-- Seleccionar empresa --": "-- Seleccionar empresa --",
    "⚠️ Primero debes crear empresas en \"Mis Empresas\"": "⚠️ Primero debes crear empresas en \"Mis Empresas\"",
    "Fecha de Pago *": "Fecha de Pago *",
    "Inicio del Período *": "Inicio del Período *",
    "Fin del Período *": "Fin del Período *",
    "Ingresos": "Ingresos",
    "Horas Regulares": "Horas Regulares",
    "Horas Extra": "Horas Extra",
    "Tarifa por Hora ($)": "Tarifa por Hora ($)",
    "Bonificación ($)": "Bonificación ($)",
    "Comisión ($)": "Comisión ($)",
    "Salario Bruto ($)": "Salario Bruto ($)",
    "Deducciones (Automáticas según país)": "Deducciones (Automáticas según país)",
    "Federal Tax ($)": "Impuesto federal ($)",
    "State Tax ($)": "Impuesto estatal ($)",
    "Social Security ($)": "Seguro Social ($)",
    "Medicare ($)": "Medicare ($)",
    "Deducciones Opcionales:": "Deducciones Opcionales:",
    "Seguro Médico ($)": "Seguro Médico ($)",
    "Seguro Dental ($)": "Seguro Dental ($)",
    "Seguro de Visión ($)": "Seguro de Visión ($)",
    "Otras Deducciones ($)": "Otras Deducciones ($)",
    "Salario Bruto": "Salario Bruto",
    "Total Deducciones": "Total Deducciones",
    "Hay un guardado pendiente de confirmar. Reintenta para recuperar el mismo recibo; los datos se conservan.": "Hay un guardado pendiente de confirmar. Reintenta para recuperar el mismo recibo; los datos se conservan.",
    "Pay Stub Preview": "Vista previa del recibo",
    "RECIBO DE PAGO / PAY STUB": "RECIBO DE PAGO",
    "Nombre:": "Nombre:",
    "Posición:": "Posición:",
    "Departamento:": "Departamento:",
    "Tipo:": "Tipo:",
    "Recibo por período": "Recibo por período",
    "INGRESOS / EARNINGS": "INGRESOS",
    "Detalle": "Detalle",
    "Monto": "Monto",
    "hrs @ $": "hrs @ $",
    "/hr": "/hr",
    "TOTAL BRUTO": "TOTAL BRUTO",
    "DEDUCCIONES / DEDUCTIONS": "DEDUCCIONES",
    "Impuesto Federal": "Impuesto Federal",
    "Federal Tax": "Impuesto federal",
    "Impuesto Estatal": "Impuesto Estatal",
    "State Tax": "Impuesto estatal",
    "Seguro Social": "Seguro Social",
    "Social Security (6.2%)": "Seguro Social (6.2%)",
    "Health Insurance": "Seguro médico",
    "Retiro 401(k)": "Retiro 401(k)",
    "401(k) Contribution": "Aporte 401(k)",
    "Otras Deducciones": "Otras Deducciones",
    "Other Deductions": "Otras deducciones",
    "TOTAL DEDUCCIONES": "TOTAL DEDUCCIONES",
    "PAGO NETO / NET PAY": "PAGO NETO",
    "Este es un documento generado por BRIEFCASE ERP": "Este es un documento generado por BRIEFCASE ERP",
    "Para cualquier consulta, contacte al departamento de Recursos Humanos": "Para cualquier consulta, contacte al departamento de Recursos Humanos",
    "Compartir Recibo de Nómina": "Compartir Recibo de Nómina",
    "Mensaje (opcional)": "Mensaje (opcional)",
    "Mensaje adicional...": "Mensaje adicional...",
    "Nombre *": "Nombre *",
    "Cargo *": "Cargo *",
    "Departamento": "Departamento",
    "Salario Mensual": "Salario Mensual",
    "Frecuencia de Pago": "Frecuencia de Pago",
    "Por Hora": "Por Hora",
    "Diario": "Diario",
    "Semanal": "Semanal",
    "Quincenal": "Quincenal",
    "Mensual": "Mensual",
    "Valor por Hora": "Valor por Hora",
    "Valor por Día": "Valor por Día",
    "Fecha de Contratación *": "Fecha de Contratación *",
    "Salario Base *": "Salario Base *",
    "Bonos": "Bonos",
    "Deducciones": "Deducciones",
    "Escanear código de barras para buscar producto": "Escanear código de barras para buscar producto",
    "Escanear": "Escanear",
    "Conteo de inventario con escáner": "Conteo de inventario con escáner",
    "Conteo": "Conteo",
    "Crear etiquetas para productos": "Crear etiquetas para productos",
    "Compartir catálogo público": "Compartir catálogo público",
    "Catálogo": "Catálogo",
    "Nueva Propiedad": "Nueva Propiedad",
    "Recalcular clasificación ABC": "Recalcular clasificación ABC",
    "A: Alto (80%)": "A: Alto (80%)",
    "B: Medio (15%)": "B: Medio (15%)",
    "C: Bajo (5%)": "C: Bajo (5%)",
    "¡Alerta de Stock Bajo!": "¡Alerta de Stock Bajo!",
    "producto": "producto",
    "reabastecimiento": "reabastecimiento",
    "unidades": "unidades",
    "Mín:": "Mín:",
    "Ver detalles de stock": "Ver detalles de stock",
    "Generar Etiquetas (Código de Barras / QR)": "Generar Etiquetas (Código de Barras / QR)",
    "JPG, PNG o WebP · máx. 5MB": "JPG, PNG o WebP · máx. 5MB",
    "Código de Barras / SKU": "Código de Barras / SKU",
    "Escanea o escribe el código...": "Escanea o escribe el código...",
    "Escanear código": "Escanear código",
    "💡 Escanea cualquier código de barras para registrar el producto": "💡 Escanea cualquier código de barras para registrar el producto",
    "Ubicación en el Negocio": "Ubicación en el Negocio",
    "Ej: Estante A-1, Bodega, Vitrina...": "Ej: Estante A-1, Bodega, Vitrina...",
    "Clasificación ABC": "Clasificación ABC",
    "A - Alto valor (prioridad alta)": "A - Alto valor (prioridad alta)",
    "B - Valor medio": "B - Valor medio",
    "C - Bajo valor": "C - Bajo valor",
    "💡 Usa el botón de recalcular para clasificación automática": "💡 Usa el botón de recalcular para clasificación automática",
    "Fecha de Ingreso": "Fecha de Ingreso",
    "Stock Mínimo (Alerta)": "Stock Mínimo (Alerta)",
    "Se mostrará alerta cuando el stock sea igual o menor": "Se mostrará alerta cuando el stock sea igual o menor",
    "Título *": "Título *",
    "Ej: Casa 3 habitaciones en zona norte": "Ej: Casa 3 habitaciones en zona norte",
    "Precio (": "Precio (",
    "Ciudad, Barrio, Dirección...": "Ciudad, Barrio, Dirección...",
    "Habitaciones": "Habitaciones",
    "Baños": "Baños",
    "Área (m²)": "Área (m²)",
    "Descripción detallada de la propiedad...": "Descripción detallada de la propiedad...",
    "Preferencias/Requisitos": "Preferencias/Requisitos",
    "Ej: Solo familias, Permite mascotas...": "Ej: Características deseadas, permite mascotas...",
    "Budget Mínimo": "Presupuesto mínimo",
    "Budget Máximo": "Presupuesto máximo",
    "Foto de la Propiedad": "Foto de la Propiedad",
    "(opcional)": "(opcional)",
    "Subiendo...": "Subiendo...",
    "Subir Foto": "Subir Foto",
    "✓ Imagen cargada correctamente": "✓ Imagen cargada correctamente",
    "Compartir vía": "Compartir vía",
    "Teléfono (opcional)": "Teléfono (opcional)",
    "Email del destinatario *": "Email del destinatario *",
    "Crear Etiquetas": "Crear Etiquetas",
    "Selecciona un producto para crear etiquetas:": "Selecciona un producto para crear etiquetas:",
    "No hay productos con código de barras o SKU": "No hay productos con código de barras o SKU",
    "Agrega un código a tus productos para crear etiquetas": "Agrega un código a tus productos para crear etiquetas",
    "Detalles de Stock": "Detalles de Stock",
    "Stock Actual": "Stock Actual",
    "Stock Mínimo": "Stock Mínimo",
    "alerta": "alerta",
    "¡Stock Crítico!": "¡Stock Crítico!",
    "Necesitas reabastecer este producto urgentemente": "Necesitas reabastecer este producto urgentemente",
    "Stock Bajo": "Stock Bajo",
    "Considera hacer un pedido pronto": "Considera hacer un pedido pronto",
    "Stock Saludable": "Stock Saludable",
    "El inventario está en buen nivel": "El inventario está en buen nivel",
    "Información del Producto": "Información del Producto",
    "Código de Barras": "Código de Barras",
    "Precio de Venta": "Precio de Venta",
    "Costo": "Costo",
    "Valor del Inventario": "Valor del Inventario",
    "Editar Stock": "Editar Stock",
    "Mis Contactos": "Mis Contactos",
    "contactos en total": "contactos en total",
    "Distribuir (": "Distribuir (",
    "contactos seleccionados": "contactos seleccionados",
    "Deseleccionar": "Deseleccionar",
    "Distribuir a...": "Distribuir a...",
    "Buscar por nombre, teléfono, email o empresa...": "Buscar por nombre, teléfono, email o empresa...",
    "No hay contactos": "No hay contactos",
    "Agregar Contacto": "Agregar Contacto",
    "Nombre completo": "Nombre completo",
    "Dirección completa": "Dirección completa",
    "Nombre de la empresa": "Nombre de la empresa",
    "Importar desde Excel": "Importar desde Excel",
    "Categoría para los contactos importados:": "Categoría para los contactos importados:",
    "Deseleccionar todos": "Deseleccionar todos",
    "Importando...": "Importando...",
    "Importar": "Importar",
    "Distribuir Contactos": "Distribuir Contactos",
    "Enviando": "Enviando",
    "contacto(s) a otra herramienta": "contacto(s) a otra herramienta",
    "Seleccione el destino:": "Seleccione el destino:",
    "Enviando...": "Enviando...",
    "Catálogo de Servicios": "Catálogo de Servicios",
    "Buscar servicio…": "Buscar servicio…",
    "Todas las categorías": "Todas las categorías",
    "Nuevo Servicio": "Nuevo Servicio",
    "% comisión": "% comisión",
    "% imp.": "% imp.",
    "Eliminar servicio": "Eliminar servicio",
    "Crear primer servicio": "Crear primer servicio",
    "Ej: Corte de pelo dama / Preparación de taxes / Notarización": "Ej: Corte de pelo dama / Preparación de taxes / Notarización",
    "Detalles que ayuden al equipo y al cliente": "Detalles que ayuden al equipo y al cliente",
    "— Ninguno —": "— Ninguno —",
    "Cobrar impuesto sobre este servicio": "Cobrar impuesto sobre este servicio",
    "📊 Se creará automáticamente una cuenta contable individual para reportes:": "📊 Se creará automáticamente una cuenta contable individual para reportes:",
    "Ingresos · Servicios ·": "Ingresos · Servicios ·",
    "Control de Pagos": "Control de Pagos",
    "Evita intereses, paga a tiempo": "Evita intereses, paga a tiempo",
    "Reporte": "Reporte",
    "Agregar Cuenta": "Agregar Cuenta",
    "Nuevo Deudor": "Nuevo Deudor",
    "Cuentas por Pagar": "Cuentas por Pagar",
    "Control de Deudores": "Control de Deudores",
    "Vence:": "Vence:",
    "Pagado:": "Pagado:",
    "Marcar como pagada": "Marcar como pagada",
    "activos)": "activos)",
    "Enviar mensaje a deudores": "Enviar mensaje a deudores",
    "Enviar Mensaje": "Enviar Mensaje",
    "Imprimir lista de deudores": "Imprimir lista de deudores",
    "Deudores": "Deudores",
    "pendientes": "pendientes",
    "Deuda Total": "Deuda Total",
    "Total Cobrado": "Total Cobrado",
    "Por Cobrar": "Por Cobrar",
    "Deudor": "Deudor",
    "Concepto": "Concepto",
    "Monto Deuda": "Monto Deuda",
    "Ha Pagado": "Ha Pagado",
    "Debe": "Debe",
    "+ Agregar primer deudor": "+ Agregar primer deudor",
    "Registrar Pago/Abono": "Registrar Pago/Abono",
    "Enviar Mensaje/Recordatorio": "Enviar Mensaje/Recordatorio",
    "Historial de Pagos Recientes": "Historial de Pagos Recientes",
    "Ej: Luz, Internet, Tarjeta...": "Ej: Luz, Internet, Tarjeta...",
    "Monto *": "Monto *",
    "Fecha de Vencimiento *": "Fecha de Vencimiento *",
    "Recordatorio de Pago": "Recordatorio de Pago",
    "Notificarme": "Notificarme",
    "día(s) antes del vencimiento": "día(s) antes del vencimiento",
    "Recibirás un email de recordatorio antes del vencimiento": "Recibirás un email de recordatorio antes del vencimiento",
    "Reporte de Pagos por Categoría": "Reporte de Pagos por Categoría",
    "Desde:": "Desde:",
    "Hasta:": "Hasta:",
    "Total Pagado en el Período": "Total Pagado en el Período",
    "pagos": "pagos",
    "Nombre del Deudor *": "Nombre del Deudor *",
    "Nombre completo del deudor": "Nombre completo del deudor",
    "Teléfono / WhatsApp": "Teléfono / WhatsApp",
    "Necesario para enviar cobros por WhatsApp": "Necesario para enviar cobros por WhatsApp",
    "Concepto de la Deuda": "Concepto de la Deuda",
    "Ej: Préstamo personal, Mercancía, Servicio...": "Ej: Préstamo personal, Mercancía, Servicio...",
    "Monto de Deuda *": "Monto de Deuda *",
    "Registrar Pago": "Registrar Pago",
    "Saldo pendiente:": "Saldo pendiente:",
    "Tipo de Pago": "Tipo de Pago",
    "Abono": "Abono",
    "Pago parcial": "Pago parcial",
    "Pago Total": "Pago Total",
    "Liquidar deuda": "Liquidar deuda",
    "Monto del Abono *": "Monto del Abono *",
    "Se liquidará la deuda completa": "Se liquidará la deuda completa",
    "Fecha del Pago": "Fecha del Pago",
    "Notas (opcional)": "Notas (opcional)",
    "Nota sobre el pago...": "Nota sobre el pago...",
    "Tipo de Mensaje": "Tipo de Mensaje",
    "Automático": "Automático",
    "Personalizado": "Personalizado",
    "Escribe tu mensaje personalizado aquí...": "Escribe tu mensaje personalizado aquí...",
    "Selecciona un deudor para ver el mensaje automático": "Selecciona un deudor para ver el mensaje automático",
    "Saldo:": "Saldo:",
    "Selecciona cómo enviar el mensaje:": "Selecciona cómo enviar el mensaje:",
    "Copiar": "Copiar",
    "BRIEFCASE · PROPIEDADES": "BRIEFCASE · PROPIEDADES",
    "Cerrar administración": "Cerrar administración",
    "Administración de alquileres": "Administración de alquileres",
    "PARA PROPIETARIOS, ADMINISTRADORES Y AGENTES": "PARA PROPIETARIOS, ADMINISTRADORES Y AGENTES",
    "Inquilinos, rentas, contratos y mantenimiento en un solo lugar.": "Inquilinos, rentas, contratos y mantenimiento en un solo lugar.",
    "Nueva unidad": "Nueva unidad",
    "Mes de renta": "Mes de renta",
    "Nombre, unidad, referencia…": "Nombre, unidad, referencia…",
    "Cargando administración…": "Cargando administración…",
    "Tu primera propiedad, organizada": "Tu primera propiedad, organizada",
    "1. Añade una unidad. 2. Registra al inquilino. 3. Vincula el contrato para controlar sus rentas.": "1. Añade una unidad. 2. Registra al inquilino. 3. Vincula el contrato para controlar sus rentas.",
    "Añadir unidad": "Añadir unidad",
    "Añadir inquilino": "Añadir inquilino",
    "Rentas de": "Rentas de",
    "El resumen usa la renta mensual pactada de los contratos que coinciden con el mes. No aplica prorrateos ni recargos automáticos.": "El resumen usa la renta mensual pactada de los contratos que coinciden con el mes. No aplica prorrateos ni recargos automáticos.",
    "· Vence": "· Vence",
    "pendiente": "pendiente",
    "Registrar pago": "Registrar pago",
    "Cobrar con Briefcase": "Cobrar con Briefcase",
    "Propiedades y unidades administradas": "Propiedades y unidades administradas",
    "Propietario:": "Propietario:",
    "· Administrador:": "· Administrador:",
    "Editar unidad": "Editar unidad",
    "Añade casas, apartamentos, habitaciones o locales. Usa una unidad distinta para cada espacio alquilado.": "Añade casas, apartamentos, habitaciones o locales. Usa una unidad distinta para cada espacio alquilado.",
    "Inquilinos · A–Z": "Inquilinos · A–Z",
    "Editar inquilino": "Editar inquilino",
    "Guarda el nombre y los datos de contacto del inquilino. Luego vincúlalo a su contrato.": "Guarda el nombre y los datos de contacto del inquilino. Luego vincúlalo a su contrato.",
    "Contratos de alquiler": "Contratos de alquiler",
    "Registrar contrato": "Registrar contrato",
    "Registra las condiciones de tu contrato existente. Guarda el PDF y solicita firmas desde Archivador.": "Registra las condiciones de tu contrato existente. Guarda el PDF y solicita firmas desde Archivador.",
    "/ mes · Día": "/ mes · Día",
    "Depósito pactado:": "Depósito pactado:",
    "Archivos y firmas": "Archivos y firmas",
    "Registrar fin": "Registrar fin",
    "Primero añade una unidad y un inquilino para registrar el contrato.": "Primero añade una unidad y un inquilino para registrar el contrato.",
    "Rentas y cobros ·": "Rentas y cobros ·",
    "Verificar cobros": "Verificar cobros",
    "Registrar renta": "Registrar renta",
    "Efectivo y Zelle se registran manualmente después de recibirlos. Briefcase registra los cobros con tarjeta cuando Stripe los confirma.": "Efectivo y Zelle se registran manualmente después de recibirlos. Briefcase registra los cobros con tarjeta cuando Stripe los confirma.",
    "Configurar cobros electrónicos": "Configurar cobros electrónicos",
    "Recibo PDF": "Recibo PDF",
    "Anular registro": "Anular registro",
    "No hay rentas registradas para este mes y búsqueda.": "No hay rentas registradas para este mes y búsqueda.",
    "Mantenimiento": "Mantenimiento",
    "Nueva solicitud": "Nueva solicitud",
    "Estimado": "Estimado",
    "· Real": "· Real",
    "Actualizar estado": "Actualizar estado",
    "Registra reparaciones, responsables, fechas y costos por unidad.": "Registra reparaciones, responsables, fechas y costos por unidad.",
    "Contratos y expedientes": "Contratos y expedientes",
    "Organiza las carpetas por inquilino o propiedad. Sube tus contratos, guarda los documentos firmados y encuéntralos por nombre.": "Organiza las carpetas por inquilino o propiedad. Sube tus contratos, guarda los documentos firmados y encuéntralos por nombre.",
    "Enlace de pago preparado": "Enlace de pago preparado",
    "Enlace de cobro": "Enlace de cobro",
    "Copiar enlace": "Copiar enlace",
    "El inquilino puede pagar sin tener una cuenta Briefcase. El enlace contiene el importe pendiente al crearlo; verifica los cobros antes de emitir otro.": "El inquilino puede pagar sin tener una cuenta Briefcase. El enlace contiene el importe pendiente al crearlo; verifica los cobros antes de emitir otro.",
    "Listo": "Listo",
    "Registra únicamente dinero ya recibido. Este formulario no cobra ni transfiere fondos.": "Registra únicamente dinero ya recibido. Este formulario no cobra ni transfiere fondos.",
    "Genera un enlace de tarjeta por el saldo pendiente del mes. Necesitas conectar Stripe en Cobros.": "Genera un enlace de tarjeta por el saldo pendiente del mes. Necesitas conectar Stripe en Cobros.",
    "Seleccionar…": "Seleccionar…",
    "Abrir Cobros": "Abrir Cobros",
    "Buscar co-broker...": "Buscar co-broker...",
    "Importar desde celular": "Importar desde celular",
    "Importar desde contactos": "Importar desde contactos",
    "Nuevo Co-Broker": "Nuevo Co-Broker",
    "Agregar Listado": "Agregar Listado",
    "Documentos (": "Documentos (",
    "Subir": "Subir",
    "Sube contratos, acuerdos y otros archivos": "Sube contratos, acuerdos y otros archivos",
    "Firmado:": "Firmado:",
    "Ver documento": "Ver documento",
    "Firmar documento con E-Sign": "Firmar documento con E-Sign",
    "Firmar y descargar PDF": "Firmar y descargar PDF",
    "Firmado": "Firmado",
    "No hay listados para este co-broker": "No hay listados para este co-broker",
    "Tipo de Propiedad": "Tipo de Propiedad",
    "🏠 Casa": "🏠 Casa",
    "🏢 Apartamento": "🏢 Apartamento",
    "🌳 Terreno": "🌳 Terreno",
    "🏪 Comercial": "🏪 Comercial",
    "🏛️ Oficina": "🏛️ Oficina",
    "Transacción": "Transacción",
    "💰 Venta": "💰 Venta",
    "📅 Alquiler": "📅 Alquiler",
    "Precio *": "Precio *",
    "✅ Disponible": "✅ Disponible",
    "⏳ Reservado": "⏳ Reservado",
    "Vendido": "Vendido",
    "Alquilado": "Alquilado",
    "Rentado": "Rentado",
    "Estado/Provincia": "Estado/Provincia",
    "Galería de Fotos": "Galería de Fotos",
    "Categoría de documentación": "Categoría de documentación",
    "Teléfono *": "Teléfono *",
    "🏠 Comprador": "🏠 Comprador",
    "🔑 Inquilino (Rentar)": "🔑 Inquilino (Rentar)",
    "💰 Vendedor": "💰 Vendedor",
    "Inversor": "Inversor",
    "Presupuesto Mínimo": "Presupuesto Mínimo",
    "Presupuesto Máximo": "Presupuesto Máximo",
    "Ubicación Preferida": "Ubicación Preferida",
    "Ej: Miami, FL": "Ej: Miami, FL",
    "🏦 Pre-calificación Bancaria": "🏦 Pre-calificación Bancaria",
    "Banco": "Banco",
    "Ej: Bank of America": "Ej: Bank of America",
    "Monto Aprobado": "Monto Aprobado",
    "Fecha de Vencimiento": "Fecha de Vencimiento",
    "Documento de Pre-calificación": "Documento de Pre-calificación",
    "Subir Documento": "Subir Documento",
    "Foto": "Foto",
    "✅ Documento cargado": "✅ Documento cargado",
    "Ver / Descargar": "Ver / Descargar",
    "Nueva Interacción -": "Nueva Interacción -",
    "Tipo de Interacción": "Tipo de Interacción",
    "📞 Llamada": "📞 Llamada",
    "📧 Email": "📧 Email",
    "🤝 Reunión": "🤝 Reunión",
    "👁️ Visita a Propiedad": "👁️ Visita a Propiedad",
    "📝 Nota": "📝 Nota",
    "Notas *": "Notas *",
    "Describe la interacción...": "Describe la interacción...",
    "Fecha de Seguimiento (opcional)": "Fecha de Seguimiento (opcional)",
    "Guardar Interacción": "Guardar Interacción",
    "Auto-generado": "Auto-generado",
    "Orden (# para ordenar)": "Orden (# para ordenar)",
    "Dirección de Propiedad *": "Dirección de Propiedad *",
    "Comisión (%)": "Comisión (%)",
    "Detalles adicionales del listado...": "Detalles adicionales del listado...",
    "Casillero de Documentos": "Casillero de Documentos",
    "📝 Cómo firmar un documento:": "📝 Cómo firmar un documento:",
    "Sube tu documento PDF usando el botón \"Subir Documento\"": "Sube tu documento PDF usando el botón \"Subir Documento\"",
    "Una vez subido, haz clic en \"Firmar con BRIEFCASE\"": "Una vez subido, haz clic en \"Firmar con BRIEFCASE\"",
    "Dibuja tu firma y presiona \"Firmar Documento\"": "Dibuja tu firma y presiona \"Firmar Documento\"",
    "Descarga el PDF firmado con el botón verde": "Descarga el PDF firmado con el botón de descarga",
    "Notas del documento (opcional)": "Notas del documento (opcional)",
    "PDF, imágenes o documentos Word. Máximo 10MB.": "PDF, imágenes o documentos Word. Máximo 10MB.",
    "Sube contratos, identificaciones o documentos del cliente": "Sube contratos, identificaciones o documentos del cliente",
    "Firmado por": "Firmado por",
    "Abrir/Ver documento": "Abrir/Ver documento",
    "Firmar documento con BRIEFCASE": "Firmar documento con BRIEFCASE",
    "Firmar con BRIEFCASE": "Firmar con BRIEFCASE",
    "Enviar a tercero para firma": "Enviar a tercero para firma",
    "Descargar Firmado": "Descargar Firmado",
    "Descargar original": "Descargar original",
    "Enviar por WhatsApp": "Enviar por WhatsApp",
    "Enviar por Email": "Enviar por Email",
    "Seleccionar Contacto": "Seleccionar Contacto",
    "No hay contactos disponibles": "No hay contactos disponibles",
    "Agrega clientes en la sección de Clientes primero": "Agrega clientes en la sección de Clientes primero",
    "Importar Co-Brokers desde Excel": "Importar Co-Brokers desde Excel",
    "Se encontraron": "Se encontraron",
    "contactos. Selecciona los que deseas importar.": "contactos. Selecciona los que deseas importar.",
    "Seleccionar todos (": "Seleccionar todos (",
    "Importar Clientes desde Excel": "Importar Clientes desde Excel",
    "Importar Clientes desde Celular": "Importar Clientes desde Celular",
    "clientes seleccionados": "clientes seleccionados",
    "Tipo de cliente para los importados:": "Tipo de cliente para los importados:",
    "Comprador": "Comprador",
    "Vendedor": "Vendedor",
    "Inquilino/Renta": "Inquilino/Renta",
    "Seleccionar todos": "Seleccionar todos",
    "Importar Co-Brokers desde Celular": "Importar Co-Brokers desde Celular",
    "co-brokers seleccionados": "co-brokers seleccionados",
    "Firmar Documento": "Firmar Documento",
    "Sistema de Citas": "Sistema de Citas",
    "Gestiona tus citas con clientes": "Gestiona tus citas con clientes",
    "Cargando agenda…": "Cargando agenda…",
    "Reintentar carga": "Reintentar carga",
    "Citas de Hoy (": "Citas de Hoy (",
    "Buscar citas": "Buscar citas",
    "Buscar citas...": "Buscar citas...",
    "Filtrar por estado": "Filtrar por estado",
    "Todos los estados": "Todos los estados",
    "Lista": "Lista",
    "Calendario": "Calendario",
    "Crea tu primera cita para empezar": "Crea tu primera cita para empezar",
    "+ Crear Cita": "+ Crear Cita",
    "Fecha/Hora": "Fecha/Hora",
    "Título": "Título",
    "Ver detalles": "Ver detalles",
    "Mes anterior": "Mes anterior",
    "Mes siguiente": "Mes siguiente",
    "más": "más",
    "Cierra esta ventana y reintenta la carga.": "Cierra esta ventana y reintenta la carga.",
    "Cliente *": "Cliente *",
    "-- Seleccionar cliente --": "-- Seleccionar cliente --",
    "⚠️ Primero debes agregar clientes en la sección \"Clientes\"": "⚠️ Primero debes agregar clientes en la sección \"Clientes\"",
    "Título de la Cita *": "Título de la Cita *",
    "Ej: Consulta inicial, Revisión de propuesta...": "Ej: Consulta inicial, Revisión de propuesta...",
    "Detalles adicionales de la cita...": "Detalles adicionales de la cita...",
    "Hora *": "Hora *",
    "Duración (min)": "Duración (min)",
    "15 minutos": "15 minutos",
    "30 minutos": "30 minutos",
    "45 minutos": "45 minutos",
    "1 hora": "1 hora",
    "1.5 horas": "1.5 horas",
    "2 horas": "2 horas",
    "Zona horaria de la cita *": "Zona horaria de la cita *",
    "Ej: America/New_York": "Ej: America/New_York",
    "La fecha y hora corresponden a esta zona. Confírmala si la cita se realiza en otro lugar.": "La fecha y hora corresponden a esta zona. Confírmala si la cita se realiza en otro lugar.",
    "Dirección o lugar de la cita...": "Dirección o lugar de la cita...",
    "Recordatorios Automáticos": "Recordatorios Automáticos",
    "24 horas antes": "24 horas antes",
    "1 hora antes": "1 hora antes",
    "Notas Internas": "Notas Internas",
    "Notas privadas sobre esta cita...": "Notas privadas sobre esta cita...",
    "Detalles de la Cita": "Detalles de la Cita",
    "Cerrar detalles": "Cerrar detalles",
    "Estado de los recordatorios": "Estado de los recordatorios",
    "Registrar revisión del proveedor": "Registrar revisión del proveedor",
    "Historial de revisiones del proveedor": "Historial de revisiones del proveedor",
    "Identificador del mensaje:": "Identificador del mensaje:",
    "Registrar revisión:": "Registrar revisión:",
    "Resultado comprobado en el proveedor": "Resultado comprobado en el proveedor",
    "Selecciona el resultado": "Selecciona el resultado",
    "El proveedor aceptó el correo": "El proveedor aceptó el correo",
    "El proveedor confirmó que no se envió": "El proveedor confirmó que no se envió",
    "Identificador del mensaje en el proveedor *": "Identificador del mensaje en el proveedor *",
    "Nota de revisión (opcional)": "Nota de revisión (opcional)",
    "Al autorizar el reintento se libera este aviso. Si el servicio automático está activo y el horario corresponde, podrá enviar el correo nuevamente.": "Al autorizar el reintento se libera este aviso. Si el servicio automático está activo y el horario corresponde, podrá enviar el correo nuevamente.",
    "Cancelar revisión": "Cancelar revisión",
    "Actualizar información": "Actualizar información",
    "Preparar o enviar recordatorio": "Preparar o enviar recordatorio",
    "Email requiere un proveedor configurado. En WhatsApp tú revisas y envías el mensaje.": "Email requiere un proveedor configurado. En WhatsApp tú revisas y envías el mensaje.",
    "Abrir WhatsApp para revisar y enviar": "Abrir WhatsApp para revisar y enviar",
    "Cambiar Estado": "Cambiar Estado",
    "de": "de",
    "Venta": "Venta",
    "Renta": "Renta",
    "Compartir": "Compartir",
    "Reintentar": "Reintentar",
    "Actualizar": "Actualizar",
    "Buscar": "Buscar",
    "Cancelar": "Cancelar",
    "Cerrar": "Cerrar",
    "Editar": "Editar",
    "Empleado": "Empleado",
    "Entrada": "Entrada",
    "Salida": "Salida",
    "Descargar PDF": "Descargar PDF",
    "Compartir por WhatsApp": "Compartir por WhatsApp",
    "Empresa": "Empresa",
    "Contactos": "Contactos",
    "Celular": "Celular",
    "Ciudad": "Ciudad",
    "Tipo": "Tipo",
    "Enviar": "Enviar",
    "Hoy": "Hoy",
    "Programadas": "Programadas",
    "Confirmadas": "Confirmadas",
    "Atendidos": "Atendidos",
    "No Asistió": "No Asistió",
    "Canceladas": "Canceladas",
    "Programada": "Programada",
    "Confirmada": "Confirmada",
    "En Espera": "En Espera",
    "Atendido": "Atendido",
    "No Se Presentó": "No Se Presentó",
    "Cancelada": "Cancelada",
    "Reprogramada": "Reprogramada",
    "Por definir": "Por definir",
    "Nueva Cita": "Nueva Cita",
    "Editar Cita": "Editar Cita",
    "Crear Cita": "Crear Cita",
    "Guardando…": "Guardando…",
    "No se pudo verificar el servicio de recordatorios.": "No se pudo verificar el servicio de recordatorios.",
    "No se pudieron cargar las citas.": "No se pudieron cargar las citas.",
    "No se pudieron cargar los clientes.": "No se pudieron cargar los clientes.",
    "No se pudo cargar el resumen.": "No se pudo cargar el resumen.",
    "Estado del servicio sin verificar": "Estado del servicio sin verificar",
    "No se pudo comprobar si el envío automático está disponible. Actualiza la información antes de confiar en un aviso.": "No se pudo comprobar si el envío automático está disponible. Actualiza la información antes de confiar en un aviso.",
    "Comienza agregando contactos manualmente o importándolos": "Comienza agregando contactos manualmente o importándolos",
    "Crear Contacto": "Crear Contacto",
    "Rentas": "Rentas",
    "Ventas de Casas": "Ventas de Casas",
    "Inversores": "Inversores",
    "Referidos": "Referidos",
    "Proveedores": "Proveedores",
    "Guardar Cambios": "Guardar Cambios",
    "Ingresos del mes": "Ingresos del mes",
    "Comisiones": "Comisiones",
    "Pagadas a profesionales": "Pagadas a profesionales",
    "Ingreso neto": "Ingreso neto",
    "Ingresos − comisiones": "Ingresos − comisiones",
    "Impuestos": "Impuestos",
    "Recolectados este mes": "Recolectados este mes",
    "Crea tu primer servicio": "Crea tu primer servicio",
    "Ningún servicio coincide con tu búsqueda": "Ningún servicio coincide con tu búsqueda",
    "Configura cada servicio que ofreces: corte de pelo, notaría, taxes, consultoría, fotocopias, reparaciones… con su precio, duración, comisión y categoría profesional.": "Configura cada servicio que ofreces: corte de pelo, notaría, taxes, consultoría, fotocopias, reparaciones… con su precio, duración, comisión y categoría profesional.",
    "Nombre del servicio *": "Nombre del servicio *",
    "Descripción (opcional)": "Descripción (opcional)",
    "Duración (minutos)": "Duración (minutos)",
    "Categoría profesional": "Categoría profesional",
    "Profesional asignado (por defecto)": "Profesional asignado (por defecto)",
    "% Comisión profesional": "% Comisión profesional",
    "Tasa de impuesto %": "Tasa de impuesto %",
    "Crear Servicio": "Crear Servicio",
    "<nombre>": "<nombre>",
    "Producto": "Producto",
    "Servicio": "Servicio",
    "Propiedad": "Propiedad",
    "Disponible": "Disponible",
    "Reservado": "Reservado",
    "Agregar Servicio": "Agregar Servicio",
    "Ver Productos": "Ver Productos",
    "Ocultar": "Ocultar",
    "Vencidas": "Vencidas",
    "Vencen Hoy": "Vencen Hoy",
    "Pendientes": "Pendientes",
    "Pagadas": "Pagadas",
    "Todas": "Todas",
    "cuentas": "cuentas",
    "Nueva Cuenta": "Nueva Cuenta",
    "Editar Cuenta": "Editar Cuenta",
    "Agregar": "Agregar",
    "Nuevo Empleado": "Nuevo Empleado",
    "Editar Empleado": "Editar Empleado",
    "Guardar": "Guardar",
    "Otros": "Otros",
    "ventas": "ventas",
    "Medio Día": "Medio Día",
    "Vacaciones": "Vacaciones",
    "Enfermedad": "Enfermedad",
    "Envío automático desactivado": "Envío automático desactivado",
    "Puedes guardar tus preferencias. Los recordatorios automáticos todavía no se están enviando.": "Puedes guardar tus preferencias. Los recordatorios automáticos todavía no se están enviando.",
    "Correo pendiente de configuración": "Correo pendiente de configuración",
    "Las preferencias se guardan, pero falta configurar el proveedor de correo.": "Las preferencias se guardan, pero falta configurar el proveedor de correo.",
    "Servicio de recordatorios detenido": "Servicio de recordatorios detenido",
    "La configuración está habilitada, pero el proceso automático no está funcionando.": "La configuración está habilitada, pero el proceso automático no está funcionando.",
    "Servicio de recordatorios activo": "Servicio de recordatorios activo",
    "El servicio está preparado para procesar citas con zona horaria confirmada. La recepción del correo depende del proveedor.": "El servicio está preparado para procesar citas con zona horaria confirmada. La recepción del correo depende del proveedor.",
    "Editar Servicio": "Editar Servicio",
    "Ajusta los filtros para verlos todos.": "Ajusta los filtros para verlos todos.",
    "belleza": "belleza",
    "Todos": "Todos",
    "Clasificación": "Clasificación",
    "Cambiar foto": "Cambiar foto",
    "Subir foto": "Subir foto",
    "Nombre del Servicio": "Nombre del Servicio",
    "Sin código": "Sin código",
    "Generador de Etiquetas": "Generador de Etiquetas",
    "Revisa los detalles antes de guardar.": "Revisa los detalles antes de guardar.",
    "Etiquetas:": "Etiquetas:",
    "Barras": "Barras",
    "Tamaño": "Tamaño",
    "Cantidad:": "Cantidad:",
    "Cantidad de etiquetas": "Cantidad de etiquetas",
    "Nombre": "Nombre",
    "Precio": "Precio",
    "Preparando PDF…": "Preparando PDF…",
    "VER / IMPRIMIR ETIQUETAS": "VER / IMPRIMIR ETIQUETAS",
    "Se abrirá un PDF con solo las etiquetas y sus códigos. Imprime a tamaño real (100 %).": "Se abrirá un PDF con solo las etiquetas y sus códigos. Imprime a tamaño real (100 %).",
    "Preparando etiquetas": "Preparando etiquetas",
    "Preparando PDF de etiquetas…": "Preparando PDF de etiquetas…",
    "No se pudieron generar las etiquetas. Intenta de nuevo.": "No se pudieron generar las etiquetas. Intenta de nuevo.",
    "Reducir cantidad": "Reducir cantidad",
    "Aumentar cantidad": "Aumentar cantidad",
    "Cerrar aviso": "Cerrar aviso",
    "No hay productos que coincidan con la búsqueda.": "No hay productos que coincidan con la búsqueda.",
    "Buscar producto para etiquetas": "Buscar producto para etiquetas",
    "No se pudo generar el enlace": "No se pudo generar el enlace",
    "No se pudo copiar el enlace. Selecciónalo y cópialo manualmente.": "No se pudo copiar el enlace. Selecciónalo y cópialo manualmente.",
    "Enlace copiado": "Enlace copiado",
    "Enlace del catálogo": "Enlace del catálogo",
    "Catálogo Público": "Catálogo Público",
    "Tus clientes verán fotos y precios": "Tus clientes verán fotos y precios",
    "Ver catálogo": "Ver catálogo",
    "Mira nuestro catálogo de productos": "Mira nuestro catálogo de productos",
    "Comparte el enlace de tu catálogo con tus clientes.": "Comparte el enlace de tu catálogo con tus clientes.",
    "Se muestran los productos marcados como \"Visible en catálogo\". Puedes ocultar cualquier producto desde su formulario de edición.": "Se muestran los productos marcados como \"Visible en catálogo\". Puedes ocultar cualquier producto desde su formulario de edición.",
    "Te quedan {remaining} etiquetas este mes. Actualiza tu plan para generar más.": "Te quedan {remaining} etiquetas este mes. Actualiza tu plan para generar más.",
    "{count} producto necesita reabastecimiento": "{count} producto necesita reabastecimiento",
    "{count} productos necesitan reabastecimiento": "{count} productos necesitan reabastecimiento"
  },
  "en": {
    "Desde": "From",
    "Período:": "Period:",
    "Base:": "Base:",
    "+Bonos:": "+Bonuses:",
    "-Deducciones:": "-Deductions:",
    "Neto a pagar": "Net pay",
    "Neto a pagar:": "Net pay:",
    "Marcar como pagado": "Mark as paid",
    "Compartir recibo": "Share payslip",
    "Registrar Asistencia": "Record attendance",
    "Presente": "Present",
    "Ausente": "Absent",
    "Tardanza": "Late",
    "vacaciones": "vacation",
    "enfermedad": "sick leave",
    "Horas": "Hours",
    "+ Registrar primera asistencia": "+ Record first attendance",
    "Empleado *": "Employee *",
    "Seleccionar empleado": "Select employee",
    "Seleccionar empleado...": "Select employee...",
    "Fecha *": "Date *",
    "Hora Entrada": "Clock-in time",
    "Hora Salida": "Clock-out time",
    "Notas adicionales...": "Additional notes...",
    "Escanear Pay Stub": "Scan payslip",
    "Crear Pay Stub": "Create payslip",
    "+ Crear primer pay stub": "+ Create first payslip",
    "Pay Stub": "Payslip",
    "Fecha de Pago:": "Pay date:",
    "Bruto:": "Gross:",
    "Pago Neto": "Net pay",
    "Ver pay stub": "View payslip",
    "Completa los datos y confirma la tarifa por hora. Puedes revisar y ajustar las deducciones antes de guardar.": "Complete the details and confirm the hourly rate. Review and adjust deductions before saving.",
    "Los importes se redondean a centavos por concepto. Las retenciones sugeridas son estimaciones editables; los valores que cambies manualmente se conservan.": "Each amount is rounded to cents. Suggested withholdings are editable estimates; your manual changes are preserved.",
    "-- Seleccionar empleado --": "-- Select employee --",
    "⚠️ Primero debes agregar empleados en el tab \"Empleados\"": "⚠️ Add employees in the Employees tab first",
    "Empresa *": "Company *",
    "-- Seleccionar empresa --": "-- Select company --",
    "⚠️ Primero debes crear empresas en \"Mis Empresas\"": "⚠️ Create a company in My Companies first",
    "Fecha de Pago *": "Pay date *",
    "Inicio del Período *": "Period start *",
    "Fin del Período *": "Period end *",
    "Ingresos": "Earnings",
    "Horas Regulares": "Regular hours",
    "Horas Extra": "Overtime hours",
    "Tarifa por Hora ($)": "Hourly rate ($)",
    "Bonificación ($)": "Bonus ($)",
    "Comisión ($)": "Commission ($)",
    "Salario Bruto ($)": "Gross pay ($)",
    "Deducciones (Automáticas según país)": "Deductions (automatic by country)",
    "Federal Tax ($)": "Federal tax ($)",
    "State Tax ($)": "State tax ($)",
    "Social Security ($)": "Social Security ($)",
    "Medicare ($)": "Medicare ($)",
    "Deducciones Opcionales:": "Optional deductions:",
    "Seguro Médico ($)": "Health insurance ($)",
    "Seguro Dental ($)": "Dental insurance ($)",
    "Seguro de Visión ($)": "Vision insurance ($)",
    "Otras Deducciones ($)": "Other deductions ($)",
    "Salario Bruto": "Gross pay",
    "Total Deducciones": "Total deductions",
    "Hay un guardado pendiente de confirmar. Reintenta para recuperar el mismo recibo; los datos se conservan.": "A save is awaiting confirmation. Retry to recover the same payslip; your details are preserved.",
    "Pay Stub Preview": "Payslip preview",
    "RECIBO DE PAGO / PAY STUB": "PAYSLIP",
    "Nombre:": "Name:",
    "Posición:": "Position:",
    "Departamento:": "Department:",
    "Tipo:": "Type:",
    "Recibo por período": "Payslip for period",
    "INGRESOS / EARNINGS": "EARNINGS",
    "Detalle": "Details",
    "Monto": "Amount",
    "hrs @ $": "hrs at $",
    "/hr": "/hr",
    "TOTAL BRUTO": "GROSS TOTAL",
    "DEDUCCIONES / DEDUCTIONS": "DEDUCTIONS",
    "Impuesto Federal": "Federal tax",
    "Federal Tax": "Federal tax",
    "Impuesto Estatal": "State tax",
    "State Tax": "State tax",
    "Seguro Social": "Social Security",
    "Social Security (6.2%)": "Social Security (6.2%)",
    "Health Insurance": "Health insurance",
    "Retiro 401(k)": "401(k) retirement",
    "401(k) Contribution": "401(k) contribution",
    "Otras Deducciones": "Other deductions",
    "Other Deductions": "Other deductions",
    "TOTAL DEDUCCIONES": "TOTAL DEDUCTIONS",
    "PAGO NETO / NET PAY": "NET PAY",
    "Este es un documento generado por BRIEFCASE ERP": "This document was generated by BRIEFCASE ERP",
    "Para cualquier consulta, contacte al departamento de Recursos Humanos": "For questions, contact Human Resources",
    "Compartir Recibo de Nómina": "Share payslip",
    "Mensaje (opcional)": "Message (optional)",
    "Mensaje adicional...": "Additional message...",
    "Nombre *": "Name *",
    "Cargo *": "Position *",
    "Departamento": "Department",
    "Salario Mensual": "Monthly salary",
    "Frecuencia de Pago": "Pay frequency",
    "Por Hora": "Hourly",
    "Diario": "Daily",
    "Semanal": "Weekly",
    "Quincenal": "Every two weeks",
    "Mensual": "Monthly",
    "Valor por Hora": "Hourly amount",
    "Valor por Día": "Daily amount",
    "Fecha de Contratación *": "Hire date *",
    "Salario Base *": "Base salary *",
    "Bonos": "Bonuses",
    "Deducciones": "Deductions",
    "Escanear código de barras para buscar producto": "Scan a barcode to find a product",
    "Escanear": "Scan",
    "Conteo de inventario con escáner": "Inventory count with scanner",
    "Conteo": "Count",
    "Crear etiquetas para productos": "Create product labels",
    "Compartir catálogo público": "Share public catalog",
    "Catálogo": "Catalog",
    "Nueva Propiedad": "New property",
    "Recalcular clasificación ABC": "Recalculate ABC classification",
    "A: Alto (80%)": "A: High (80%)",
    "B: Medio (15%)": "B: Medium (15%)",
    "C: Bajo (5%)": "C: Low (5%)",
    "¡Alerta de Stock Bajo!": "Low stock alert!",
    "producto": "product",
    "reabastecimiento": "restocking",
    "unidades": "units",
    "Mín:": "Min:",
    "Ver detalles de stock": "View stock details",
    "Generar Etiquetas (Código de Barras / QR)": "Generate labels (barcode / QR)",
    "JPG, PNG o WebP · máx. 5MB": "JPG, PNG or WebP · max. 5MB",
    "Código de Barras / SKU": "Barcode / SKU",
    "Escanea o escribe el código...": "Scan or enter the code...",
    "Escanear código": "Scan code",
    "💡 Escanea cualquier código de barras para registrar el producto": "💡 Scan any barcode to register the product",
    "Ubicación en el Negocio": "Location in the business",
    "Ej: Estante A-1, Bodega, Vitrina...": "E.g. Shelf A-1, warehouse, display...",
    "Clasificación ABC": "ABC classification",
    "A - Alto valor (prioridad alta)": "A - High value (high priority)",
    "B - Valor medio": "B - Medium value",
    "C - Bajo valor": "C - Low value",
    "💡 Usa el botón de recalcular para clasificación automática": "💡 Use Recalculate for automatic classification",
    "Fecha de Ingreso": "Date added",
    "Stock Mínimo (Alerta)": "Minimum stock (alert)",
    "Se mostrará alerta cuando el stock sea igual o menor": "An alert appears when stock is at or below this amount",
    "Título *": "Title *",
    "Ej: Casa 3 habitaciones en zona norte": "E.g. 3-bedroom house in the north area",
    "Precio (": "Price (",
    "Ciudad, Barrio, Dirección...": "City, neighborhood, address...",
    "Habitaciones": "Bedrooms",
    "Baños": "Bathrooms",
    "Área (m²)": "Area (m²)",
    "Descripción detallada de la propiedad...": "Detailed property description...",
    "Preferencias/Requisitos": "Preferences / requirements",
    "Ej: Solo familias, Permite mascotas...": "E.g. Preferred features, pets allowed...",
    "Budget Mínimo": "Minimum budget",
    "Budget Máximo": "Maximum budget",
    "Foto de la Propiedad": "Property photo",
    "(opcional)": "(optional)",
    "Subiendo...": "Uploading...",
    "Subir Foto": "Upload photo",
    "✓ Imagen cargada correctamente": "✓ Image uploaded successfully",
    "Compartir vía": "Share via",
    "Teléfono (opcional)": "Phone (optional)",
    "Email del destinatario *": "Recipient email *",
    "Crear Etiquetas": "Create labels",
    "Selecciona un producto para crear etiquetas:": "Select a product to create labels:",
    "No hay productos con código de barras o SKU": "No products have a barcode or SKU",
    "Agrega un código a tus productos para crear etiquetas": "Add a product code to create labels",
    "Detalles de Stock": "Stock details",
    "Stock Actual": "Current stock",
    "Stock Mínimo": "Minimum stock",
    "alerta": "alert",
    "¡Stock Crítico!": "Critical stock!",
    "Necesitas reabastecer este producto urgentemente": "This product needs urgent restocking",
    "Stock Bajo": "Low stock",
    "Considera hacer un pedido pronto": "Consider placing an order soon",
    "Stock Saludable": "Healthy stock",
    "El inventario está en buen nivel": "Inventory is at a good level",
    "Información del Producto": "Product information",
    "Código de Barras": "Barcode",
    "Precio de Venta": "Selling price",
    "Costo": "Cost",
    "Valor del Inventario": "Inventory value",
    "Editar Stock": "Edit stock",
    "Mis Contactos": "My contacts",
    "contactos en total": "total contacts",
    "Distribuir (": "Distribute (",
    "contactos seleccionados": "selected contacts",
    "Deseleccionar": "Deselect",
    "Distribuir a...": "Distribute to...",
    "Buscar por nombre, teléfono, email o empresa...": "Search by name, phone, email or company...",
    "No hay contactos": "No contacts",
    "Agregar Contacto": "Add contact",
    "Nombre completo": "Full name",
    "Dirección completa": "Full address",
    "Nombre de la empresa": "Company name",
    "Importar desde Excel": "Import from Excel",
    "Categoría para los contactos importados:": "Category for imported contacts:",
    "Deseleccionar todos": "Deselect all",
    "Importando...": "Importing...",
    "Importar": "Import",
    "Distribuir Contactos": "Distribute contacts",
    "Enviando": "Sending",
    "contacto(s) a otra herramienta": "contact(s) to another tool",
    "Seleccione el destino:": "Select the destination:",
    "Enviando...": "Sending...",
    "Catálogo de Servicios": "Service catalog",
    "Buscar servicio…": "Search services…",
    "Todas las categorías": "All categories",
    "Nuevo Servicio": "New service",
    "% comisión": "% commission",
    "% imp.": "% tax",
    "Eliminar servicio": "Delete service",
    "Crear primer servicio": "Create first service",
    "Ej: Corte de pelo dama / Preparación de taxes / Notarización": "E.g. Haircut / Tax preparation / Notarization",
    "Detalles que ayuden al equipo y al cliente": "Details to help your team and customer",
    "— Ninguno —": "— None —",
    "Cobrar impuesto sobre este servicio": "Charge tax on this service",
    "📊 Se creará automáticamente una cuenta contable individual para reportes:": "📊 A separate ledger account will be created automatically for reports:",
    "Ingresos · Servicios ·": "Income · Services ·",
    "Control de Pagos": "Payment tracking",
    "Evita intereses, paga a tiempo": "Avoid interest, pay on time",
    "Reporte": "Report",
    "Agregar Cuenta": "Add bill",
    "Nuevo Deudor": "New debtor",
    "Cuentas por Pagar": "Accounts payable",
    "Control de Deudores": "Debtor tracking",
    "Vence:": "Due:",
    "Pagado:": "Paid:",
    "Marcar como pagada": "Mark as paid",
    "activos)": "active)",
    "Enviar mensaje a deudores": "Send message to debtors",
    "Enviar Mensaje": "Send message",
    "Imprimir lista de deudores": "Print debtor list",
    "Deudores": "Debtors",
    "pendientes": "pending",
    "Deuda Total": "Total debt",
    "Total Cobrado": "Total collected",
    "Por Cobrar": "Outstanding",
    "Deudor": "Debtor",
    "Concepto": "Description",
    "Monto Deuda": "Debt amount",
    "Ha Pagado": "Amount paid",
    "Debe": "Amount owed",
    "+ Agregar primer deudor": "+ Add first debtor",
    "Registrar Pago/Abono": "Record payment / installment",
    "Enviar Mensaje/Recordatorio": "Send message / reminder",
    "Historial de Pagos Recientes": "Recent payment history",
    "Ej: Luz, Internet, Tarjeta...": "E.g. Electricity, internet, card...",
    "Monto *": "Amount *",
    "Fecha de Vencimiento *": "Due date *",
    "Recordatorio de Pago": "Payment reminder",
    "Notificarme": "Notify me",
    "día(s) antes del vencimiento": "day(s) before the due date",
    "Recibirás un email de recordatorio antes del vencimiento": "You will receive an email reminder before the due date",
    "Reporte de Pagos por Categoría": "Payments by category report",
    "Desde:": "From:",
    "Hasta:": "To:",
    "Total Pagado en el Período": "Total paid in period",
    "pagos": "payments",
    "Nombre del Deudor *": "Debtor name *",
    "Nombre completo del deudor": "Debtor full name",
    "Teléfono / WhatsApp": "Phone / WhatsApp",
    "Necesario para enviar cobros por WhatsApp": "Required to send payment requests via WhatsApp",
    "Concepto de la Deuda": "Debt description",
    "Ej: Préstamo personal, Mercancía, Servicio...": "E.g. Personal loan, merchandise, service...",
    "Monto de Deuda *": "Debt amount *",
    "Registrar Pago": "Record payment",
    "Saldo pendiente:": "Outstanding balance:",
    "Tipo de Pago": "Payment type",
    "Abono": "Installment",
    "Pago parcial": "Partial payment",
    "Pago Total": "Full payment",
    "Liquidar deuda": "Settle debt",
    "Monto del Abono *": "Installment amount *",
    "Se liquidará la deuda completa": "The entire debt will be settled",
    "Fecha del Pago": "Payment date",
    "Notas (opcional)": "Notes (optional)",
    "Nota sobre el pago...": "Payment note...",
    "Tipo de Mensaje": "Message type",
    "Automático": "Automatic",
    "Personalizado": "Custom",
    "Escribe tu mensaje personalizado aquí...": "Write your custom message here...",
    "Selecciona un deudor para ver el mensaje automático": "Select a debtor to view the automatic message",
    "Saldo:": "Balance:",
    "Selecciona cómo enviar el mensaje:": "Choose how to send the message:",
    "Copiar": "Copy",
    "BRIEFCASE · PROPIEDADES": "BRIEFCASE · PROPERTIES",
    "Cerrar administración": "Close management",
    "Administración de alquileres": "Rental management",
    "PARA PROPIETARIOS, ADMINISTRADORES Y AGENTES": "FOR OWNERS, MANAGERS AND AGENTS",
    "Inquilinos, rentas, contratos y mantenimiento en un solo lugar.": "Tenants, rent, leases and maintenance in one place.",
    "Nueva unidad": "New unit",
    "Mes de renta": "Rent month",
    "Nombre, unidad, referencia…": "Name, unit, reference…",
    "Cargando administración…": "Loading management…",
    "Tu primera propiedad, organizada": "Your first property, organized",
    "1. Añade una unidad. 2. Registra al inquilino. 3. Vincula el contrato para controlar sus rentas.": "1. Add a unit. 2. Register the tenant. 3. Link the lease to track rent.",
    "Añadir unidad": "Add unit",
    "Añadir inquilino": "Add tenant",
    "Rentas de": "Rent for",
    "El resumen usa la renta mensual pactada de los contratos que coinciden con el mes. No aplica prorrateos ni recargos automáticos.": "The summary uses the agreed monthly rent for leases matching the month. No automatic proration or extra charges apply.",
    "· Vence": "· Due",
    "pendiente": "pending",
    "Registrar pago": "Record payment",
    "Cobrar con Briefcase": "Collect with Briefcase",
    "Propiedades y unidades administradas": "Managed properties and units",
    "Propietario:": "Owner:",
    "· Administrador:": "· Manager:",
    "Editar unidad": "Edit unit",
    "Añade casas, apartamentos, habitaciones o locales. Usa una unidad distinta para cada espacio alquilado.": "Add houses, apartments, rooms or commercial spaces. Use a separate unit for each rented space.",
    "Inquilinos · A–Z": "Tenants · A–Z",
    "Editar inquilino": "Edit tenant",
    "Guarda el nombre y los datos de contacto del inquilino. Luego vincúlalo a su contrato.": "Save the tenant’s name and contact details, then link the lease.",
    "Contratos de alquiler": "Leases",
    "Registrar contrato": "Record lease",
    "Registra las condiciones de tu contrato existente. Guarda el PDF y solicita firmas desde Archivador.": "Record the terms of your existing lease. Save the PDF and request signatures from the Digital Archive.",
    "/ mes · Día": "/ month · Day",
    "Depósito pactado:": "Agreed deposit:",
    "Archivos y firmas": "Files and signatures",
    "Registrar fin": "Record end date",
    "Primero añade una unidad y un inquilino para registrar el contrato.": "Add a unit and tenant before recording a lease.",
    "Rentas y cobros ·": "Rent and collections ·",
    "Verificar cobros": "Check collections",
    "Registrar renta": "Record rent",
    "Efectivo y Zelle se registran manualmente después de recibirlos. Briefcase registra los cobros con tarjeta cuando Stripe los confirma.": "Record cash and Zelle manually after receipt. Briefcase records card payments when Stripe confirms them.",
    "Configurar cobros electrónicos": "Set up electronic payments",
    "Recibo PDF": "PDF receipt",
    "Anular registro": "Void record",
    "No hay rentas registradas para este mes y búsqueda.": "No rent records match this month and search.",
    "Mantenimiento": "Maintenance",
    "Nueva solicitud": "New request",
    "Estimado": "Estimated",
    "· Real": "· Actual",
    "Actualizar estado": "Update status",
    "Registra reparaciones, responsables, fechas y costos por unidad.": "Record repairs, assignees, dates and costs by unit.",
    "Contratos y expedientes": "Leases and records",
    "Organiza las carpetas por inquilino o propiedad. Sube tus contratos, guarda los documentos firmados y encuéntralos por nombre.": "Organize folders by tenant or property. Upload leases, store signed documents and find them by name.",
    "Enlace de pago preparado": "Payment link ready",
    "Enlace de cobro": "Payment link",
    "Copiar enlace": "Copy link",
    "El inquilino puede pagar sin tener una cuenta Briefcase. El enlace contiene el importe pendiente al crearlo; verifica los cobros antes de emitir otro.": "Tenants can pay without a Briefcase account. The link contains the outstanding amount when created; check collections before issuing another.",
    "Listo": "Done",
    "Registra únicamente dinero ya recibido. Este formulario no cobra ni transfiere fondos.": "Record only money already received. This form does not collect or transfer funds.",
    "Genera un enlace de tarjeta por el saldo pendiente del mes. Necesitas conectar Stripe en Cobros.": "Create a card payment link for the month’s outstanding balance. Connect Stripe in Payments first.",
    "Seleccionar…": "Select…",
    "Abrir Cobros": "Open payments",
    "Buscar co-broker...": "Search co-brokers...",
    "Importar desde celular": "Import from phone",
    "Importar desde contactos": "Import from contacts",
    "Nuevo Co-Broker": "New co-broker",
    "Agregar Listado": "Add listing",
    "Documentos (": "Documents (",
    "Subir": "Upload",
    "Sube contratos, acuerdos y otros archivos": "Upload contracts, agreements and other files",
    "Firmado:": "Signed:",
    "Ver documento": "View document",
    "Firmar documento con E-Sign": "Sign document with E-Sign",
    "Firmar y descargar PDF": "Sign and download PDF",
    "Firmado": "Signed",
    "No hay listados para este co-broker": "No listings for this co-broker",
    "Tipo de Propiedad": "Property type",
    "🏠 Casa": "🏠 House",
    "🏢 Apartamento": "🏢 Apartment",
    "🌳 Terreno": "🌳 Land",
    "🏪 Comercial": "🏪 Commercial",
    "🏛️ Oficina": "🏛️ Office",
    "Transacción": "Transaction",
    "💰 Venta": "💰 Sale",
    "📅 Alquiler": "📅 Rental",
    "Precio *": "Price *",
    "✅ Disponible": "✅ Available",
    "⏳ Reservado": "⏳ Reserved",
    "Vendido": "Sold",
    "Alquilado": "Rented",
    "Rentado": "Rented",
    "Estado/Provincia": "State / province",
    "Galería de Fotos": "Photo gallery",
    "Categoría de documentación": "Document category",
    "Teléfono *": "Phone *",
    "🏠 Comprador": "🏠 Buyer",
    "🔑 Inquilino (Rentar)": "🔑 Tenant (rental)",
    "💰 Vendedor": "💰 Seller",
    "Inversor": "Investor",
    "Presupuesto Mínimo": "Minimum budget",
    "Presupuesto Máximo": "Maximum budget",
    "Ubicación Preferida": "Preferred location",
    "Ej: Miami, FL": "E.g. Miami, FL",
    "🏦 Pre-calificación Bancaria": "🏦 Bank prequalification",
    "Banco": "Bank",
    "Ej: Bank of America": "E.g. Bank of America",
    "Monto Aprobado": "Approved amount",
    "Fecha de Vencimiento": "Due date",
    "Documento de Pre-calificación": "Prequalification document",
    "Subir Documento": "Upload document",
    "Foto": "Photo",
    "✅ Documento cargado": "✅ Document uploaded",
    "Ver / Descargar": "View / download",
    "Nueva Interacción -": "New interaction -",
    "Tipo de Interacción": "Interaction type",
    "📞 Llamada": "📞 Call",
    "📧 Email": "📧 Email",
    "🤝 Reunión": "🤝 Meeting",
    "👁️ Visita a Propiedad": "👁️ Property viewing",
    "📝 Nota": "📝 Note",
    "Notas *": "Notes *",
    "Describe la interacción...": "Describe the interaction...",
    "Fecha de Seguimiento (opcional)": "Follow-up date (optional)",
    "Guardar Interacción": "Save interaction",
    "Auto-generado": "Auto-generated",
    "Orden (# para ordenar)": "Order (# to sort)",
    "Dirección de Propiedad *": "Property address *",
    "Comisión (%)": "Commission (%)",
    "Detalles adicionales del listado...": "Additional listing details...",
    "Casillero de Documentos": "Document cabinet",
    "📝 Cómo firmar un documento:": "📝 How to sign a document:",
    "Sube tu documento PDF usando el botón \"Subir Documento\"": "Upload your PDF using Upload document",
    "Una vez subido, haz clic en \"Firmar con BRIEFCASE\"": "After uploading, click Sign with BRIEFCASE",
    "Dibuja tu firma y presiona \"Firmar Documento\"": "Draw your signature and press Sign document",
    "Descarga el PDF firmado con el botón verde": "Download the signed PDF using the download button",
    "Notas del documento (opcional)": "Document notes (optional)",
    "PDF, imágenes o documentos Word. Máximo 10MB.": "PDF, images or Word documents. Maximum 10MB.",
    "Sube contratos, identificaciones o documentos del cliente": "Upload contracts, IDs or customer documents",
    "Firmado por": "Signed by",
    "Abrir/Ver documento": "Open / view document",
    "Firmar documento con BRIEFCASE": "Sign document with BRIEFCASE",
    "Firmar con BRIEFCASE": "Sign with BRIEFCASE",
    "Enviar a tercero para firma": "Send to a third party for signature",
    "Descargar Firmado": "Download signed document",
    "Descargar original": "Download original",
    "Enviar por WhatsApp": "Send via WhatsApp",
    "Enviar por Email": "Send via email",
    "Seleccionar Contacto": "Select contact",
    "No hay contactos disponibles": "No contacts available",
    "Agrega clientes en la sección de Clientes primero": "Add customers in the Customers section first",
    "Importar Co-Brokers desde Excel": "Import co-brokers from Excel",
    "Se encontraron": "Found",
    "contactos. Selecciona los que deseas importar.": "contacts. Select those you want to import.",
    "Seleccionar todos (": "Select all (",
    "Importar Clientes desde Excel": "Import customers from Excel",
    "Importar Clientes desde Celular": "Import customers from phone",
    "clientes seleccionados": "selected customers",
    "Tipo de cliente para los importados:": "Customer type for imports:",
    "Comprador": "Buyer",
    "Vendedor": "Seller",
    "Inquilino/Renta": "Tenant / rental",
    "Seleccionar todos": "Select all",
    "Importar Co-Brokers desde Celular": "Import co-brokers from phone",
    "co-brokers seleccionados": "selected co-brokers",
    "Firmar Documento": "Sign document",
    "Sistema de Citas": "Appointment system",
    "Gestiona tus citas con clientes": "Manage customer appointments",
    "Cargando agenda…": "Loading schedule…",
    "Reintentar carga": "Retry loading",
    "Citas de Hoy (": "Today’s appointments (",
    "Buscar citas": "Search appointments",
    "Buscar citas...": "Search appointments...",
    "Filtrar por estado": "Filter by status",
    "Todos los estados": "All statuses",
    "Lista": "List",
    "Calendario": "Calendar",
    "Crea tu primera cita para empezar": "Create your first appointment to get started",
    "+ Crear Cita": "+ Create appointment",
    "Fecha/Hora": "Date / time",
    "Título": "Title",
    "Ver detalles": "View details",
    "Mes anterior": "Previous month",
    "Mes siguiente": "Next month",
    "más": "more",
    "Cierra esta ventana y reintenta la carga.": "Close this window and try loading again.",
    "Cliente *": "Customer *",
    "-- Seleccionar cliente --": "-- Select customer --",
    "⚠️ Primero debes agregar clientes en la sección \"Clientes\"": "⚠️ Add customers in the Customers section first",
    "Título de la Cita *": "Appointment title *",
    "Ej: Consulta inicial, Revisión de propuesta...": "E.g. Initial consultation, proposal review...",
    "Detalles adicionales de la cita...": "Additional appointment details...",
    "Hora *": "Time *",
    "Duración (min)": "Duration (min)",
    "15 minutos": "15 minutes",
    "30 minutos": "30 minutes",
    "45 minutos": "45 minutes",
    "1 hora": "1 hour",
    "1.5 horas": "1.5 hours",
    "2 horas": "2 hours",
    "Zona horaria de la cita *": "Appointment time zone *",
    "Ej: America/New_York": "E.g. America/New_York",
    "La fecha y hora corresponden a esta zona. Confírmala si la cita se realiza en otro lugar.": "The date and time use this time zone. Confirm it if the appointment is elsewhere.",
    "Dirección o lugar de la cita...": "Appointment address or location...",
    "Recordatorios Automáticos": "Automatic reminders",
    "24 horas antes": "24 hours before",
    "1 hora antes": "1 hour before",
    "Notas Internas": "Internal notes",
    "Notas privadas sobre esta cita...": "Private notes about this appointment...",
    "Detalles de la Cita": "Appointment details",
    "Cerrar detalles": "Close details",
    "Estado de los recordatorios": "Reminder status",
    "Registrar revisión del proveedor": "Record provider review",
    "Historial de revisiones del proveedor": "Provider review history",
    "Identificador del mensaje:": "Message ID:",
    "Registrar revisión:": "Record review:",
    "Resultado comprobado en el proveedor": "Result verified with provider",
    "Selecciona el resultado": "Select the result",
    "El proveedor aceptó el correo": "Provider accepted the email",
    "El proveedor confirmó que no se envió": "Provider confirmed it was not sent",
    "Identificador del mensaje en el proveedor *": "Provider message ID *",
    "Nota de revisión (opcional)": "Review note (optional)",
    "Al autorizar el reintento se libera este aviso. Si el servicio automático está activo y el horario corresponde, podrá enviar el correo nuevamente.": "Authorizing a retry releases this reminder. If the automatic service is active and the timing matches, it may send the email again.",
    "Cancelar revisión": "Cancel review",
    "Actualizar información": "Refresh information",
    "Preparar o enviar recordatorio": "Prepare or send reminder",
    "Email requiere un proveedor configurado. En WhatsApp tú revisas y envías el mensaje.": "Email requires a configured provider. On WhatsApp, you review and send the message.",
    "Abrir WhatsApp para revisar y enviar": "Open WhatsApp to review and send",
    "Cambiar Estado": "Change status",
    "de": "of",
    "Venta": "Sale",
    "Renta": "Rental",
    "Compartir": "Share",
    "Reintentar": "Retry",
    "Actualizar": "Refresh",
    "Buscar": "Search",
    "Cancelar": "Cancel",
    "Cerrar": "Close",
    "Editar": "Edit",
    "Empleado": "Employee",
    "Entrada": "Clock in",
    "Salida": "Clock out",
    "Descargar PDF": "Download PDF",
    "Compartir por WhatsApp": "Share via WhatsApp",
    "Empresa": "Company",
    "Contactos": "Contacts",
    "Celular": "Phone",
    "Ciudad": "City",
    "Tipo": "Type",
    "Enviar": "Send",
    "Hoy": "Today",
    "Programadas": "Scheduled",
    "Confirmadas": "Confirmed",
    "Atendidos": "Attended",
    "No Asistió": "No-show",
    "Canceladas": "Cancelled",
    "Programada": "Scheduled",
    "Confirmada": "Confirmed",
    "En Espera": "Waiting",
    "Atendido": "Attended",
    "No Se Presentó": "No-show",
    "Cancelada": "Cancelled",
    "Reprogramada": "Rescheduled",
    "Por definir": "To be confirmed",
    "Nueva Cita": "New appointment",
    "Editar Cita": "Edit appointment",
    "Crear Cita": "Create appointment",
    "Guardando…": "Saving…",
    "No se pudo verificar el servicio de recordatorios.": "The reminder service could not be verified.",
    "No se pudieron cargar las citas.": "Appointments could not be loaded.",
    "No se pudieron cargar los clientes.": "Customers could not be loaded.",
    "No se pudo cargar el resumen.": "The summary could not be loaded.",
    "Estado del servicio sin verificar": "Service status unverified",
    "No se pudo comprobar si el envío automático está disponible. Actualiza la información antes de confiar en un aviso.": "Automatic delivery availability could not be verified. Refresh the information before relying on a reminder.",
    "Comienza agregando contactos manualmente o importándolos": "Start by adding contacts manually or importing them",
    "Crear Contacto": "Create contact",
    "Rentas": "Rentals",
    "Ventas de Casas": "House sales",
    "Inversores": "Investors",
    "Referidos": "Referrals",
    "Proveedores": "Suppliers",
    "Guardar Cambios": "Save changes",
    "Ingresos del mes": "Monthly revenue",
    "Comisiones": "Commissions",
    "Pagadas a profesionales": "Paid to professionals",
    "Ingreso neto": "Net income",
    "Ingresos − comisiones": "Revenue − commissions",
    "Impuestos": "Taxes",
    "Recolectados este mes": "Collected this month",
    "Crea tu primer servicio": "Create your first service",
    "Ningún servicio coincide con tu búsqueda": "No services match your search",
    "Configura cada servicio que ofreces: corte de pelo, notaría, taxes, consultoría, fotocopias, reparaciones… con su precio, duración, comisión y categoría profesional.": "Set up each service you offer: haircuts, notary services, tax services, consulting, copies, repairs… with its price, duration, commission and professional category.",
    "Nombre del servicio *": "Service name *",
    "Descripción (opcional)": "Description (optional)",
    "Duración (minutos)": "Duration (minutes)",
    "Categoría profesional": "Professional category",
    "Profesional asignado (por defecto)": "Assigned professional (default)",
    "% Comisión profesional": "Professional commission %",
    "Tasa de impuesto %": "Tax rate %",
    "Crear Servicio": "Create service",
    "<nombre>": "<name>",
    "Producto": "Product",
    "Servicio": "Service",
    "Propiedad": "Property",
    "Disponible": "Available",
    "Reservado": "Reserved",
    "Agregar Servicio": "Add service",
    "Ver Productos": "View products",
    "Ocultar": "Hide",
    "Vencidas": "Overdue",
    "Vencen Hoy": "Due today",
    "Pendientes": "Pending",
    "Pagadas": "Paid",
    "Todas": "All",
    "cuentas": "accounts",
    "Nueva Cuenta": "New bill",
    "Editar Cuenta": "Edit bill",
    "Agregar": "Add",
    "Nuevo Empleado": "New employee",
    "Editar Empleado": "Edit employee",
    "Guardar": "Save",
    "Otros": "Others",
    "ventas": "sales",
    "Medio Día": "Half day",
    "Vacaciones": "Vacation",
    "Enfermedad": "Sick leave",
    "Envío automático desactivado": "Automatic delivery disabled",
    "Puedes guardar tus preferencias. Los recordatorios automáticos todavía no se están enviando.": "You can save your preferences. Automatic reminders are not being sent yet.",
    "Correo pendiente de configuración": "Email setup pending",
    "Las preferencias se guardan, pero falta configurar el proveedor de correo.": "Preferences are saved, but the email provider still needs to be configured.",
    "Servicio de recordatorios detenido": "Reminder service stopped",
    "La configuración está habilitada, pero el proceso automático no está funcionando.": "The setting is enabled, but the automatic process is not running.",
    "Servicio de recordatorios activo": "Reminder service active",
    "El servicio está preparado para procesar citas con zona horaria confirmada. La recepción del correo depende del proveedor.": "The service is ready to process appointments with a confirmed time zone. Email delivery depends on the provider.",
    "Editar Servicio": "Edit service",
    "Ajusta los filtros para verlos todos.": "Adjust the filters to see all services.",
    "belleza": "Beauty",
    "Todos": "All",
    "Clasificación": "Classification",
    "Cambiar foto": "Change photo",
    "Subir foto": "Upload photo",
    "Nombre del Servicio": "Service name",
    "Sin código": "No code",
    "Generador de Etiquetas": "Label generator",
    "Revisa los detalles antes de guardar.": "Review the details before saving.",
    "Etiquetas:": "Labels:",
    "Barras": "Barcode",
    "Tamaño": "Size",
    "Cantidad:": "Quantity:",
    "Cantidad de etiquetas": "Label quantity",
    "Nombre": "Name",
    "Precio": "Price",
    "Preparando PDF…": "Preparing PDF…",
    "VER / IMPRIMIR ETIQUETAS": "VIEW / PRINT LABELS",
    "Se abrirá un PDF con solo las etiquetas y sus códigos. Imprime a tamaño real (100 %).": "A PDF containing only the labels and their codes will open. Print at actual size (100%).",
    "Preparando etiquetas": "Preparing labels",
    "Preparando PDF de etiquetas…": "Preparing label PDF…",
    "No se pudieron generar las etiquetas. Intenta de nuevo.": "Labels could not be generated. Try again.",
    "Reducir cantidad": "Decrease quantity",
    "Aumentar cantidad": "Increase quantity",
    "Cerrar aviso": "Dismiss message",
    "No hay productos que coincidan con la búsqueda.": "No products match your search.",
    "Buscar producto para etiquetas": "Find a product for labels",
    "No se pudo generar el enlace": "The link could not be generated",
    "No se pudo copiar el enlace. Selecciónalo y cópialo manualmente.": "The link could not be copied. Select it and copy it manually.",
    "Enlace copiado": "Link copied",
    "Enlace del catálogo": "Catalog link",
    "Catálogo Público": "Public catalog",
    "Tus clientes verán fotos y precios": "Your customers will see photos and prices",
    "Ver catálogo": "View catalog",
    "Mira nuestro catálogo de productos": "Browse our product catalog",
    "Comparte el enlace de tu catálogo con tus clientes.": "Share your catalog link with your customers.",
    "Se muestran los productos marcados como \"Visible en catálogo\". Puedes ocultar cualquier producto desde su formulario de edición.": "Products marked \"Visible in catalog\" are shown. You can hide any product from its edit form.",
    "Te quedan {remaining} etiquetas este mes. Actualiza tu plan para generar más.": "You have {remaining} labels left this month. Upgrade your plan to generate more.",
    "{count} producto necesita reabastecimiento": "{count} product needs restocking",
    "{count} productos necesitan reabastecimiento": "{count} products need restocking"
  },
  "pt": {
    "Desde": "Desde",
    "Período:": "Período:",
    "Base:": "Base:",
    "+Bonos:": "+Bônus:",
    "-Deducciones:": "-Deduções:",
    "Neto a pagar": "Líquido a pagar",
    "Neto a pagar:": "Líquido a pagar:",
    "Marcar como pagado": "Marcar como pago",
    "Compartir recibo": "Compartilhar recibo",
    "Registrar Asistencia": "Registrar presença",
    "Presente": "Presente",
    "Ausente": "Ausente",
    "Tardanza": "Atraso",
    "vacaciones": "férias",
    "enfermedad": "licença médica",
    "Horas": "Horas",
    "+ Registrar primera asistencia": "+ Registrar primeira presença",
    "Empleado *": "Funcionário *",
    "Seleccionar empleado": "Selecionar funcionário",
    "Seleccionar empleado...": "Selecionar funcionário...",
    "Fecha *": "Data *",
    "Hora Entrada": "Hora de entrada",
    "Hora Salida": "Hora de saída",
    "Notas adicionales...": "Notas adicionais...",
    "Escanear Pay Stub": "Escanear contracheque",
    "Crear Pay Stub": "Criar contracheque",
    "+ Crear primer pay stub": "+ Criar primeiro contracheque",
    "Pay Stub": "Contracheque",
    "Fecha de Pago:": "Data de pagamento:",
    "Bruto:": "Bruto:",
    "Pago Neto": "Pagamento líquido",
    "Ver pay stub": "Ver contracheque",
    "Completa los datos y confirma la tarifa por hora. Puedes revisar y ajustar las deducciones antes de guardar.": "Preencha os dados e confirme o valor por hora. Revise e ajuste as deduções antes de salvar.",
    "Los importes se redondean a centavos por concepto. Las retenciones sugeridas son estimaciones editables; los valores que cambies manualmente se conservan.": "Os valores são arredondados para centavos por item. As retenções sugeridas são estimativas editáveis; suas alterações manuais são preservadas.",
    "-- Seleccionar empleado --": "-- Selecionar funcionário --",
    "⚠️ Primero debes agregar empleados en el tab \"Empleados\"": "⚠️ Primeiro adicione funcionários na aba Funcionários",
    "Empresa *": "Empresa *",
    "-- Seleccionar empresa --": "-- Selecionar empresa --",
    "⚠️ Primero debes crear empresas en \"Mis Empresas\"": "⚠️ Primeiro crie uma empresa em Minhas Empresas",
    "Fecha de Pago *": "Data de pagamento *",
    "Inicio del Período *": "Início do período *",
    "Fin del Período *": "Fim do período *",
    "Ingresos": "Rendimentos",
    "Horas Regulares": "Horas regulares",
    "Horas Extra": "Horas extras",
    "Tarifa por Hora ($)": "Valor por hora ($)",
    "Bonificación ($)": "Bônus ($)",
    "Comisión ($)": "Comissão ($)",
    "Salario Bruto ($)": "Salário bruto ($)",
    "Deducciones (Automáticas según país)": "Deduções (automáticas por país)",
    "Federal Tax ($)": "Imposto federal ($)",
    "State Tax ($)": "Imposto estadual ($)",
    "Social Security ($)": "Previdência social ($)",
    "Medicare ($)": "Medicare ($)",
    "Deducciones Opcionales:": "Deduções opcionais:",
    "Seguro Médico ($)": "Seguro de saúde ($)",
    "Seguro Dental ($)": "Seguro odontológico ($)",
    "Seguro de Visión ($)": "Seguro de visão ($)",
    "Otras Deducciones ($)": "Outras deduções ($)",
    "Salario Bruto": "Salário bruto",
    "Total Deducciones": "Total de deduções",
    "Hay un guardado pendiente de confirmar. Reintenta para recuperar el mismo recibo; los datos se conservan.": "Um salvamento aguarda confirmação. Tente novamente para recuperar o mesmo recibo; os dados são preservados.",
    "Pay Stub Preview": "Prévia do contracheque",
    "RECIBO DE PAGO / PAY STUB": "CONTRACHEQUE",
    "Nombre:": "Nome:",
    "Posición:": "Cargo:",
    "Departamento:": "Departamento:",
    "Tipo:": "Tipo:",
    "Recibo por período": "Recibo por período",
    "INGRESOS / EARNINGS": "RENDIMENTOS",
    "Detalle": "Detalhes",
    "Monto": "Valor",
    "hrs @ $": "h a $",
    "/hr": "/h",
    "TOTAL BRUTO": "TOTAL BRUTO",
    "DEDUCCIONES / DEDUCTIONS": "DEDUÇÕES",
    "Impuesto Federal": "Imposto federal",
    "Federal Tax": "Imposto federal",
    "Impuesto Estatal": "Imposto estadual",
    "State Tax": "Imposto estadual",
    "Seguro Social": "Previdência social",
    "Social Security (6.2%)": "Previdência social (6,2%)",
    "Health Insurance": "Seguro de saúde",
    "Retiro 401(k)": "Aposentadoria 401(k)",
    "401(k) Contribution": "Contribuição 401(k)",
    "Otras Deducciones": "Outras deduções",
    "Other Deductions": "Outras deduções",
    "TOTAL DEDUCCIONES": "TOTAL DE DEDUÇÕES",
    "PAGO NETO / NET PAY": "PAGAMENTO LÍQUIDO",
    "Este es un documento generado por BRIEFCASE ERP": "Este documento foi gerado pelo BRIEFCASE ERP",
    "Para cualquier consulta, contacte al departamento de Recursos Humanos": "Em caso de dúvidas, entre em contato com Recursos Humanos",
    "Compartir Recibo de Nómina": "Compartilhar recibo de pagamento",
    "Mensaje (opcional)": "Mensagem (opcional)",
    "Mensaje adicional...": "Mensagem adicional...",
    "Nombre *": "Nome *",
    "Cargo *": "Cargo *",
    "Departamento": "Departamento",
    "Salario Mensual": "Salário mensal",
    "Frecuencia de Pago": "Frequência de pagamento",
    "Por Hora": "Por hora",
    "Diario": "Diário",
    "Semanal": "Semanal",
    "Quincenal": "Quinzenal",
    "Mensual": "Mensal",
    "Valor por Hora": "Valor por hora",
    "Valor por Día": "Valor por dia",
    "Fecha de Contratación *": "Data de contratação *",
    "Salario Base *": "Salário base *",
    "Bonos": "Bônus",
    "Deducciones": "Deduções",
    "Escanear código de barras para buscar producto": "Escanear código de barras para buscar produto",
    "Escanear": "Escanear",
    "Conteo de inventario con escáner": "Contagem de estoque com scanner",
    "Conteo": "Contagem",
    "Crear etiquetas para productos": "Criar etiquetas de produtos",
    "Compartir catálogo público": "Compartilhar catálogo público",
    "Catálogo": "Catálogo",
    "Nueva Propiedad": "Nova propriedade",
    "Recalcular clasificación ABC": "Recalcular classificação ABC",
    "A: Alto (80%)": "A: Alto (80%)",
    "B: Medio (15%)": "B: Médio (15%)",
    "C: Bajo (5%)": "C: Baixo (5%)",
    "¡Alerta de Stock Bajo!": "Alerta de estoque baixo!",
    "producto": "produto",
    "reabastecimiento": "reposição",
    "unidades": "unidades",
    "Mín:": "Mín:",
    "Ver detalles de stock": "Ver detalhes de estoque",
    "Generar Etiquetas (Código de Barras / QR)": "Gerar etiquetas (código de barras / QR)",
    "JPG, PNG o WebP · máx. 5MB": "JPG, PNG ou WebP · máx. 5MB",
    "Código de Barras / SKU": "Código de barras / SKU",
    "Escanea o escribe el código...": "Escaneie ou digite o código...",
    "Escanear código": "Escanear código",
    "💡 Escanea cualquier código de barras para registrar el producto": "💡 Escaneie qualquer código de barras para cadastrar o produto",
    "Ubicación en el Negocio": "Localização no negócio",
    "Ej: Estante A-1, Bodega, Vitrina...": "Ex.: Prateleira A-1, depósito, vitrine...",
    "Clasificación ABC": "Classificação ABC",
    "A - Alto valor (prioridad alta)": "A - Alto valor (prioridade alta)",
    "B - Valor medio": "B - Valor médio",
    "C - Bajo valor": "C - Baixo valor",
    "💡 Usa el botón de recalcular para clasificación automática": "💡 Use Recalcular para classificação automática",
    "Fecha de Ingreso": "Data de entrada",
    "Stock Mínimo (Alerta)": "Estoque mínimo (alerta)",
    "Se mostrará alerta cuando el stock sea igual o menor": "Um alerta será exibido quando o estoque for igual ou inferior",
    "Título *": "Título *",
    "Ej: Casa 3 habitaciones en zona norte": "Ex.: Casa com 3 quartos na zona norte",
    "Precio (": "Preço (",
    "Ciudad, Barrio, Dirección...": "Cidade, bairro, endereço...",
    "Habitaciones": "Quartos",
    "Baños": "Banheiros",
    "Área (m²)": "Área (m²)",
    "Descripción detallada de la propiedad...": "Descrição detalhada do imóvel...",
    "Preferencias/Requisitos": "Preferências / requisitos",
    "Ej: Solo familias, Permite mascotas...": "Ex.: Características desejadas, aceita animais...",
    "Budget Mínimo": "Orçamento mínimo",
    "Budget Máximo": "Orçamento máximo",
    "Foto de la Propiedad": "Foto do imóvel",
    "(opcional)": "(opcional)",
    "Subiendo...": "Enviando...",
    "Subir Foto": "Enviar foto",
    "✓ Imagen cargada correctamente": "✓ Imagem enviada com sucesso",
    "Compartir vía": "Compartilhar via",
    "Teléfono (opcional)": "Telefone (opcional)",
    "Email del destinatario *": "E-mail do destinatário *",
    "Crear Etiquetas": "Criar etiquetas",
    "Selecciona un producto para crear etiquetas:": "Selecione um produto para criar etiquetas:",
    "No hay productos con código de barras o SKU": "Nenhum produto possui código de barras ou SKU",
    "Agrega un código a tus productos para crear etiquetas": "Adicione um código aos produtos para criar etiquetas",
    "Detalles de Stock": "Detalhes do estoque",
    "Stock Actual": "Estoque atual",
    "Stock Mínimo": "Estoque mínimo",
    "alerta": "alerta",
    "¡Stock Crítico!": "Estoque crítico!",
    "Necesitas reabastecer este producto urgentemente": "Este produto precisa de reposição urgente",
    "Stock Bajo": "Estoque baixo",
    "Considera hacer un pedido pronto": "Considere fazer um pedido em breve",
    "Stock Saludable": "Estoque adequado",
    "El inventario está en buen nivel": "O estoque está em bom nível",
    "Información del Producto": "Informações do produto",
    "Código de Barras": "Código de barras",
    "Precio de Venta": "Preço de venda",
    "Costo": "Custo",
    "Valor del Inventario": "Valor do estoque",
    "Editar Stock": "Editar estoque",
    "Mis Contactos": "Meus contatos",
    "contactos en total": "contatos no total",
    "Distribuir (": "Distribuir (",
    "contactos seleccionados": "contatos selecionados",
    "Deseleccionar": "Desmarcar",
    "Distribuir a...": "Distribuir para...",
    "Buscar por nombre, teléfono, email o empresa...": "Buscar por nome, telefone, e-mail ou empresa...",
    "No hay contactos": "Nenhum contato",
    "Agregar Contacto": "Adicionar contato",
    "Nombre completo": "Nome completo",
    "Dirección completa": "Endereço completo",
    "Nombre de la empresa": "Nome da empresa",
    "Importar desde Excel": "Importar do Excel",
    "Categoría para los contactos importados:": "Categoria dos contatos importados:",
    "Deseleccionar todos": "Desmarcar todos",
    "Importando...": "Importando...",
    "Importar": "Importar",
    "Distribuir Contactos": "Distribuir contatos",
    "Enviando": "Enviando",
    "contacto(s) a otra herramienta": "contato(s) para outra ferramenta",
    "Seleccione el destino:": "Selecione o destino:",
    "Enviando...": "Enviando...",
    "Catálogo de Servicios": "Catálogo de serviços",
    "Buscar servicio…": "Buscar serviço…",
    "Todas las categorías": "Todas as categorias",
    "Nuevo Servicio": "Novo serviço",
    "% comisión": "% comissão",
    "% imp.": "% imposto",
    "Eliminar servicio": "Excluir serviço",
    "Crear primer servicio": "Criar primeiro serviço",
    "Ej: Corte de pelo dama / Preparación de taxes / Notarización": "Ex.: Corte de cabelo / Preparação de impostos / Serviço notarial",
    "Detalles que ayuden al equipo y al cliente": "Detalhes para ajudar a equipe e o cliente",
    "— Ninguno —": "— Nenhum —",
    "Cobrar impuesto sobre este servicio": "Cobrar imposto sobre este serviço",
    "📊 Se creará automáticamente una cuenta contable individual para reportes:": "📊 Uma conta contábil individual será criada automaticamente para relatórios:",
    "Ingresos · Servicios ·": "Receitas · Serviços ·",
    "Control de Pagos": "Controle de pagamentos",
    "Evita intereses, paga a tiempo": "Evite juros, pague em dia",
    "Reporte": "Relatório",
    "Agregar Cuenta": "Adicionar conta",
    "Nuevo Deudor": "Novo devedor",
    "Cuentas por Pagar": "Contas a pagar",
    "Control de Deudores": "Controle de devedores",
    "Vence:": "Vence:",
    "Pagado:": "Pago:",
    "Marcar como pagada": "Marcar como paga",
    "activos)": "ativos)",
    "Enviar mensaje a deudores": "Enviar mensagem aos devedores",
    "Enviar Mensaje": "Enviar mensagem",
    "Imprimir lista de deudores": "Imprimir lista de devedores",
    "Deudores": "Devedores",
    "pendientes": "pendentes",
    "Deuda Total": "Dívida total",
    "Total Cobrado": "Total recebido",
    "Por Cobrar": "A receber",
    "Deudor": "Devedor",
    "Concepto": "Descrição",
    "Monto Deuda": "Valor da dívida",
    "Ha Pagado": "Valor pago",
    "Debe": "Valor devido",
    "+ Agregar primer deudor": "+ Adicionar primeiro devedor",
    "Registrar Pago/Abono": "Registrar pagamento / parcela",
    "Enviar Mensaje/Recordatorio": "Enviar mensagem / lembrete",
    "Historial de Pagos Recientes": "Histórico de pagamentos recentes",
    "Ej: Luz, Internet, Tarjeta...": "Ex.: Luz, internet, cartão...",
    "Monto *": "Valor *",
    "Fecha de Vencimiento *": "Data de vencimento *",
    "Recordatorio de Pago": "Lembrete de pagamento",
    "Notificarme": "Notificar-me",
    "día(s) antes del vencimiento": "dia(s) antes do vencimento",
    "Recibirás un email de recordatorio antes del vencimiento": "Você receberá um lembrete por e-mail antes do vencimento",
    "Reporte de Pagos por Categoría": "Relatório de pagamentos por categoria",
    "Desde:": "De:",
    "Hasta:": "Até:",
    "Total Pagado en el Período": "Total pago no período",
    "pagos": "pagamentos",
    "Nombre del Deudor *": "Nome do devedor *",
    "Nombre completo del deudor": "Nome completo do devedor",
    "Teléfono / WhatsApp": "Telefone / WhatsApp",
    "Necesario para enviar cobros por WhatsApp": "Necessário para enviar cobranças pelo WhatsApp",
    "Concepto de la Deuda": "Descrição da dívida",
    "Ej: Préstamo personal, Mercancía, Servicio...": "Ex.: Empréstimo pessoal, mercadoria, serviço...",
    "Monto de Deuda *": "Valor da dívida *",
    "Registrar Pago": "Registrar pagamento",
    "Saldo pendiente:": "Saldo pendente:",
    "Tipo de Pago": "Tipo de pagamento",
    "Abono": "Parcela",
    "Pago parcial": "Pagamento parcial",
    "Pago Total": "Pagamento total",
    "Liquidar deuda": "Quitar dívida",
    "Monto del Abono *": "Valor da parcela *",
    "Se liquidará la deuda completa": "A dívida será totalmente quitada",
    "Fecha del Pago": "Data do pagamento",
    "Notas (opcional)": "Notas (opcional)",
    "Nota sobre el pago...": "Nota sobre o pagamento...",
    "Tipo de Mensaje": "Tipo de mensagem",
    "Automático": "Automático",
    "Personalizado": "Personalizado",
    "Escribe tu mensaje personalizado aquí...": "Escreva sua mensagem personalizada aqui...",
    "Selecciona un deudor para ver el mensaje automático": "Selecione um devedor para ver a mensagem automática",
    "Saldo:": "Saldo:",
    "Selecciona cómo enviar el mensaje:": "Escolha como enviar a mensagem:",
    "Copiar": "Copiar",
    "BRIEFCASE · PROPIEDADES": "BRIEFCASE · IMÓVEIS",
    "Cerrar administración": "Fechar gestão",
    "Administración de alquileres": "Gestão de aluguéis",
    "PARA PROPIETARIOS, ADMINISTRADORES Y AGENTES": "PARA PROPRIETÁRIOS, ADMINISTRADORES E CORRETORES",
    "Inquilinos, rentas, contratos y mantenimiento en un solo lugar.": "Inquilinos, aluguéis, contratos e manutenção em um só lugar.",
    "Nueva unidad": "Nova unidade",
    "Mes de renta": "Mês do aluguel",
    "Nombre, unidad, referencia…": "Nome, unidade, referência…",
    "Cargando administración…": "Carregando gestão…",
    "Tu primera propiedad, organizada": "Seu primeiro imóvel, organizado",
    "1. Añade una unidad. 2. Registra al inquilino. 3. Vincula el contrato para controlar sus rentas.": "1. Adicione uma unidade. 2. Cadastre o inquilino. 3. Vincule o contrato para controlar os aluguéis.",
    "Añadir unidad": "Adicionar unidade",
    "Añadir inquilino": "Adicionar inquilino",
    "Rentas de": "Aluguéis de",
    "El resumen usa la renta mensual pactada de los contratos que coinciden con el mes. No aplica prorrateos ni recargos automáticos.": "O resumo usa o aluguel mensal acordado nos contratos do mês. Não aplica rateios nem encargos automáticos.",
    "· Vence": "· Vence",
    "pendiente": "pendente",
    "Registrar pago": "Registrar pagamento",
    "Cobrar con Briefcase": "Cobrar com Briefcase",
    "Propiedades y unidades administradas": "Imóveis e unidades administrados",
    "Propietario:": "Proprietário:",
    "· Administrador:": "· Administrador:",
    "Editar unidad": "Editar unidade",
    "Añade casas, apartamentos, habitaciones o locales. Usa una unidad distinta para cada espacio alquilado.": "Adicione casas, apartamentos, quartos ou espaços comerciais. Use uma unidade diferente para cada espaço alugado.",
    "Inquilinos · A–Z": "Inquilinos · A–Z",
    "Editar inquilino": "Editar inquilino",
    "Guarda el nombre y los datos de contacto del inquilino. Luego vincúlalo a su contrato.": "Salve o nome e os dados de contato do inquilino. Depois vincule o contrato.",
    "Contratos de alquiler": "Contratos de aluguel",
    "Registrar contrato": "Registrar contrato",
    "Registra las condiciones de tu contrato existente. Guarda el PDF y solicita firmas desde Archivador.": "Registre as condições do contrato existente. Salve o PDF e solicite assinaturas no Arquivador.",
    "/ mes · Día": "/ mês · Dia",
    "Depósito pactado:": "Depósito acordado:",
    "Archivos y firmas": "Arquivos e assinaturas",
    "Registrar fin": "Registrar encerramento",
    "Primero añade una unidad y un inquilino para registrar el contrato.": "Adicione uma unidade e um inquilino antes de registrar o contrato.",
    "Rentas y cobros ·": "Aluguéis e cobranças ·",
    "Verificar cobros": "Verificar cobranças",
    "Registrar renta": "Registrar aluguel",
    "Efectivo y Zelle se registran manualmente después de recibirlos. Briefcase registra los cobros con tarjeta cuando Stripe los confirma.": "Registre dinheiro e Zelle manualmente após recebê-los. Briefcase registra pagamentos com cartão quando o Stripe os confirma.",
    "Configurar cobros electrónicos": "Configurar cobranças eletrônicas",
    "Recibo PDF": "Recibo PDF",
    "Anular registro": "Anular registro",
    "No hay rentas registradas para este mes y búsqueda.": "Nenhum aluguel registrado para este mês e busca.",
    "Mantenimiento": "Manutenção",
    "Nueva solicitud": "Nova solicitação",
    "Estimado": "Estimado",
    "· Real": "· Real",
    "Actualizar estado": "Atualizar status",
    "Registra reparaciones, responsables, fechas y costos por unidad.": "Registre reparos, responsáveis, datas e custos por unidade.",
    "Contratos y expedientes": "Contratos e registros",
    "Organiza las carpetas por inquilino o propiedad. Sube tus contratos, guarda los documentos firmados y encuéntralos por nombre.": "Organize pastas por inquilino ou imóvel. Envie contratos, guarde documentos assinados e encontre-os pelo nome.",
    "Enlace de pago preparado": "Link de pagamento pronto",
    "Enlace de cobro": "Link de cobrança",
    "Copiar enlace": "Copiar link",
    "El inquilino puede pagar sin tener una cuenta Briefcase. El enlace contiene el importe pendiente al crearlo; verifica los cobros antes de emitir otro.": "O inquilino pode pagar sem uma conta Briefcase. O link contém o saldo pendente na criação; verifique as cobranças antes de emitir outro.",
    "Listo": "Pronto",
    "Registra únicamente dinero ya recibido. Este formulario no cobra ni transfiere fondos.": "Registre apenas dinheiro já recebido. Este formulário não cobra nem transfere fundos.",
    "Genera un enlace de tarjeta por el saldo pendiente del mes. Necesitas conectar Stripe en Cobros.": "Gere um link de cartão para o saldo pendente do mês. Conecte o Stripe em Cobranças primeiro.",
    "Seleccionar…": "Selecionar…",
    "Abrir Cobros": "Abrir cobranças",
    "Buscar co-broker...": "Buscar corretores parceiros...",
    "Importar desde celular": "Importar do celular",
    "Importar desde contactos": "Importar dos contatos",
    "Nuevo Co-Broker": "Novo corretor parceiro",
    "Agregar Listado": "Adicionar anúncio",
    "Documentos (": "Documentos (",
    "Subir": "Enviar",
    "Sube contratos, acuerdos y otros archivos": "Envie contratos, acordos e outros arquivos",
    "Firmado:": "Assinado:",
    "Ver documento": "Ver documento",
    "Firmar documento con E-Sign": "Assinar documento com E-Sign",
    "Firmar y descargar PDF": "Assinar e baixar PDF",
    "Firmado": "Assinado",
    "No hay listados para este co-broker": "Nenhum anúncio deste corretor parceiro",
    "Tipo de Propiedad": "Tipo de imóvel",
    "🏠 Casa": "🏠 Casa",
    "🏢 Apartamento": "🏢 Apartamento",
    "🌳 Terreno": "🌳 Terreno",
    "🏪 Comercial": "🏪 Comercial",
    "🏛️ Oficina": "🏛️ Escritório",
    "Transacción": "Transação",
    "💰 Venta": "💰 Venda",
    "📅 Alquiler": "📅 Aluguel",
    "Precio *": "Preço *",
    "✅ Disponible": "✅ Disponível",
    "⏳ Reservado": "⏳ Reservado",
    "Vendido": "Vendido",
    "Alquilado": "Alugado",
    "Rentado": "Alugado",
    "Estado/Provincia": "Estado / província",
    "Galería de Fotos": "Galeria de fotos",
    "Categoría de documentación": "Categoria de documentação",
    "Teléfono *": "Telefone *",
    "🏠 Comprador": "🏠 Comprador",
    "🔑 Inquilino (Rentar)": "🔑 Inquilino (aluguel)",
    "💰 Vendedor": "💰 Vendedor",
    "Inversor": "Investidor",
    "Presupuesto Mínimo": "Orçamento mínimo",
    "Presupuesto Máximo": "Orçamento máximo",
    "Ubicación Preferida": "Localização preferida",
    "Ej: Miami, FL": "Ex.: Miami, FL",
    "🏦 Pre-calificación Bancaria": "🏦 Pré-qualificação bancária",
    "Banco": "Banco",
    "Ej: Bank of America": "Ex.: Bank of America",
    "Monto Aprobado": "Valor aprovado",
    "Fecha de Vencimiento": "Data de vencimento",
    "Documento de Pre-calificación": "Documento de pré-qualificação",
    "Subir Documento": "Enviar documento",
    "Foto": "Foto",
    "✅ Documento cargado": "✅ Documento enviado",
    "Ver / Descargar": "Ver / baixar",
    "Nueva Interacción -": "Nova interação -",
    "Tipo de Interacción": "Tipo de interação",
    "📞 Llamada": "📞 Ligação",
    "📧 Email": "📧 E-mail",
    "🤝 Reunión": "🤝 Reunião",
    "👁️ Visita a Propiedad": "👁️ Visita ao imóvel",
    "📝 Nota": "📝 Nota",
    "Notas *": "Notas *",
    "Describe la interacción...": "Descreva a interação...",
    "Fecha de Seguimiento (opcional)": "Data de acompanhamento (opcional)",
    "Guardar Interacción": "Salvar interação",
    "Auto-generado": "Gerado automaticamente",
    "Orden (# para ordenar)": "Ordem (número para ordenar)",
    "Dirección de Propiedad *": "Endereço do imóvel *",
    "Comisión (%)": "Comissão (%)",
    "Detalles adicionales del listado...": "Detalhes adicionais do anúncio...",
    "Casillero de Documentos": "Arquivo de documentos",
    "📝 Cómo firmar un documento:": "📝 Como assinar um documento:",
    "Sube tu documento PDF usando el botón \"Subir Documento\"": "Envie seu PDF usando Enviar documento",
    "Una vez subido, haz clic en \"Firmar con BRIEFCASE\"": "Após enviar, clique em Assinar com BRIEFCASE",
    "Dibuja tu firma y presiona \"Firmar Documento\"": "Desenhe sua assinatura e pressione Assinar documento",
    "Descarga el PDF firmado con el botón verde": "Baixe o PDF assinado usando o botão de download",
    "Notas del documento (opcional)": "Notas do documento (opcional)",
    "PDF, imágenes o documentos Word. Máximo 10MB.": "PDF, imagens ou documentos Word. Máximo 10MB.",
    "Sube contratos, identificaciones o documentos del cliente": "Envie contratos, identificações ou documentos do cliente",
    "Firmado por": "Assinado por",
    "Abrir/Ver documento": "Abrir / ver documento",
    "Firmar documento con BRIEFCASE": "Assinar documento com BRIEFCASE",
    "Firmar con BRIEFCASE": "Assinar com BRIEFCASE",
    "Enviar a tercero para firma": "Enviar a terceiros para assinatura",
    "Descargar Firmado": "Baixar documento assinado",
    "Descargar original": "Baixar original",
    "Enviar por WhatsApp": "Enviar pelo WhatsApp",
    "Enviar por Email": "Enviar por e-mail",
    "Seleccionar Contacto": "Selecionar contato",
    "No hay contactos disponibles": "Nenhum contato disponível",
    "Agrega clientes en la sección de Clientes primero": "Adicione clientes na seção Clientes primeiro",
    "Importar Co-Brokers desde Excel": "Importar corretores parceiros do Excel",
    "Se encontraron": "Encontrados",
    "contactos. Selecciona los que deseas importar.": "contatos. Selecione os que deseja importar.",
    "Seleccionar todos (": "Selecionar todos (",
    "Importar Clientes desde Excel": "Importar clientes do Excel",
    "Importar Clientes desde Celular": "Importar clientes do celular",
    "clientes seleccionados": "clientes selecionados",
    "Tipo de cliente para los importados:": "Tipo de cliente para importados:",
    "Comprador": "Comprador",
    "Vendedor": "Vendedor",
    "Inquilino/Renta": "Inquilino / aluguel",
    "Seleccionar todos": "Selecionar todos",
    "Importar Co-Brokers desde Celular": "Importar corretores parceiros do celular",
    "co-brokers seleccionados": "corretores parceiros selecionados",
    "Firmar Documento": "Assinar documento",
    "Sistema de Citas": "Sistema de agendamentos",
    "Gestiona tus citas con clientes": "Gerencie seus agendamentos com clientes",
    "Cargando agenda…": "Carregando agenda…",
    "Reintentar carga": "Tentar carregar novamente",
    "Citas de Hoy (": "Agendamentos de hoje (",
    "Buscar citas": "Buscar agendamentos",
    "Buscar citas...": "Buscar agendamentos...",
    "Filtrar por estado": "Filtrar por status",
    "Todos los estados": "Todos os status",
    "Lista": "Lista",
    "Calendario": "Calendário",
    "Crea tu primera cita para empezar": "Crie seu primeiro agendamento para começar",
    "+ Crear Cita": "+ Criar agendamento",
    "Fecha/Hora": "Data / hora",
    "Título": "Título",
    "Ver detalles": "Ver detalhes",
    "Mes anterior": "Mês anterior",
    "Mes siguiente": "Próximo mês",
    "más": "mais",
    "Cierra esta ventana y reintenta la carga.": "Feche esta janela e tente carregar novamente.",
    "Cliente *": "Cliente *",
    "-- Seleccionar cliente --": "-- Selecionar cliente --",
    "⚠️ Primero debes agregar clientes en la sección \"Clientes\"": "⚠️ Primeiro adicione clientes na seção Clientes",
    "Título de la Cita *": "Título do agendamento *",
    "Ej: Consulta inicial, Revisión de propuesta...": "Ex.: Consulta inicial, revisão de proposta...",
    "Detalles adicionales de la cita...": "Detalhes adicionais do agendamento...",
    "Hora *": "Hora *",
    "Duración (min)": "Duração (min)",
    "15 minutos": "15 minutos",
    "30 minutos": "30 minutos",
    "45 minutos": "45 minutos",
    "1 hora": "1 hora",
    "1.5 horas": "1,5 horas",
    "2 horas": "2 horas",
    "Zona horaria de la cita *": "Fuso horário do agendamento *",
    "Ej: America/New_York": "Ex.: America/New_York",
    "La fecha y hora corresponden a esta zona. Confírmala si la cita se realiza en otro lugar.": "A data e a hora usam este fuso. Confirme se o agendamento for em outro local.",
    "Dirección o lugar de la cita...": "Endereço ou local do agendamento...",
    "Recordatorios Automáticos": "Lembretes automáticos",
    "24 horas antes": "24 horas antes",
    "1 hora antes": "1 hora antes",
    "Notas Internas": "Notas internas",
    "Notas privadas sobre esta cita...": "Notas privadas sobre este agendamento...",
    "Detalles de la Cita": "Detalhes do agendamento",
    "Cerrar detalles": "Fechar detalhes",
    "Estado de los recordatorios": "Status dos lembretes",
    "Registrar revisión del proveedor": "Registrar revisão do provedor",
    "Historial de revisiones del proveedor": "Histórico de revisões do provedor",
    "Identificador del mensaje:": "Identificador da mensagem:",
    "Registrar revisión:": "Registrar revisão:",
    "Resultado comprobado en el proveedor": "Resultado verificado no provedor",
    "Selecciona el resultado": "Selecione o resultado",
    "El proveedor aceptó el correo": "O provedor aceitou o e-mail",
    "El proveedor confirmó que no se envió": "O provedor confirmou que não foi enviado",
    "Identificador del mensaje en el proveedor *": "Identificador da mensagem no provedor *",
    "Nota de revisión (opcional)": "Nota de revisão (opcional)",
    "Al autorizar el reintento se libera este aviso. Si el servicio automático está activo y el horario corresponde, podrá enviar el correo nuevamente.": "Autorizar uma nova tentativa libera este lembrete. Se o serviço automático estiver ativo e o horário corresponder, ele poderá enviar o e-mail novamente.",
    "Cancelar revisión": "Cancelar revisão",
    "Actualizar información": "Atualizar informações",
    "Preparar o enviar recordatorio": "Preparar ou enviar lembrete",
    "Email requiere un proveedor configurado. En WhatsApp tú revisas y envías el mensaje.": "O e-mail requer um provedor configurado. No WhatsApp, você revisa e envia a mensagem.",
    "Abrir WhatsApp para revisar y enviar": "Abrir WhatsApp para revisar e enviar",
    "Cambiar Estado": "Alterar status",
    "de": "de",
    "Venta": "Venda",
    "Renta": "Aluguel",
    "Compartir": "Compartilhar",
    "Reintentar": "Tentar novamente",
    "Actualizar": "Atualizar",
    "Buscar": "Buscar",
    "Cancelar": "Cancelar",
    "Cerrar": "Fechar",
    "Editar": "Editar",
    "Empleado": "Funcionário",
    "Entrada": "Entrada",
    "Salida": "Saída",
    "Descargar PDF": "Baixar PDF",
    "Compartir por WhatsApp": "Compartilhar pelo WhatsApp",
    "Empresa": "Empresa",
    "Contactos": "Contatos",
    "Celular": "Celular",
    "Ciudad": "Cidade",
    "Tipo": "Tipo",
    "Enviar": "Enviar",
    "Hoy": "Hoje",
    "Programadas": "Agendadas",
    "Confirmadas": "Confirmadas",
    "Atendidos": "Atendidos",
    "No Asistió": "Não compareceu",
    "Canceladas": "Canceladas",
    "Programada": "Agendada",
    "Confirmada": "Confirmada",
    "En Espera": "Em espera",
    "Atendido": "Atendido",
    "No Se Presentó": "Não compareceu",
    "Cancelada": "Cancelada",
    "Reprogramada": "Reagendada",
    "Por definir": "A definir",
    "Nueva Cita": "Novo agendamento",
    "Editar Cita": "Editar agendamento",
    "Crear Cita": "Criar agendamento",
    "Guardando…": "Salvando…",
    "No se pudo verificar el servicio de recordatorios.": "Não foi possível verificar o serviço de lembretes.",
    "No se pudieron cargar las citas.": "Não foi possível carregar os agendamentos.",
    "No se pudieron cargar los clientes.": "Não foi possível carregar os clientes.",
    "No se pudo cargar el resumen.": "Não foi possível carregar o resumo.",
    "Estado del servicio sin verificar": "Status do serviço não verificado",
    "No se pudo comprobar si el envío automático está disponible. Actualiza la información antes de confiar en un aviso.": "Não foi possível verificar a disponibilidade do envio automático. Atualize as informações antes de contar com um lembrete.",
    "Comienza agregando contactos manualmente o importándolos": "Comece adicionando contatos manualmente ou importando-os",
    "Crear Contacto": "Criar contato",
    "Rentas": "Aluguéis",
    "Ventas de Casas": "Vendas de imóveis",
    "Inversores": "Investidores",
    "Referidos": "Indicações",
    "Proveedores": "Fornecedores",
    "Guardar Cambios": "Salvar alterações",
    "Ingresos del mes": "Receita do mês",
    "Comisiones": "Comissões",
    "Pagadas a profesionales": "Pagas a profissionais",
    "Ingreso neto": "Receita líquida",
    "Ingresos − comisiones": "Receita − comissões",
    "Impuestos": "Impostos",
    "Recolectados este mes": "Arrecadados neste mês",
    "Crea tu primer servicio": "Crie seu primeiro serviço",
    "Ningún servicio coincide con tu búsqueda": "Nenhum serviço corresponde à sua busca",
    "Configura cada servicio que ofreces: corte de pelo, notaría, taxes, consultoría, fotocopias, reparaciones… con su precio, duración, comisión y categoría profesional.": "Configure cada serviço oferecido: cortes de cabelo, serviços notariais, serviços fiscais, consultoria, cópias, reparos… com preço, duração, comissão e categoria profissional.",
    "Nombre del servicio *": "Nome do serviço *",
    "Descripción (opcional)": "Descrição (opcional)",
    "Duración (minutos)": "Duração (minutos)",
    "Categoría profesional": "Categoria profissional",
    "Profesional asignado (por defecto)": "Profissional responsável (padrão)",
    "% Comisión profesional": "Comissão profissional %",
    "Tasa de impuesto %": "Alíquota de imposto %",
    "Crear Servicio": "Criar serviço",
    "<nombre>": "<nome>",
    "Producto": "Produto",
    "Servicio": "Serviço",
    "Propiedad": "Imóvel",
    "Disponible": "Disponível",
    "Reservado": "Reservado",
    "Agregar Servicio": "Adicionar serviço",
    "Ver Productos": "Ver produtos",
    "Ocultar": "Ocultar",
    "Vencidas": "Vencidas",
    "Vencen Hoy": "Vencem hoje",
    "Pendientes": "Pendentes",
    "Pagadas": "Pagas",
    "Todas": "Todas",
    "cuentas": "contas",
    "Nueva Cuenta": "Nova conta",
    "Editar Cuenta": "Editar conta",
    "Agregar": "Adicionar",
    "Nuevo Empleado": "Novo funcionário",
    "Editar Empleado": "Editar funcionário",
    "Guardar": "Salvar",
    "Otros": "Outros",
    "ventas": "vendas",
    "Medio Día": "Meio período",
    "Vacaciones": "Férias",
    "Enfermedad": "Licença médica",
    "Envío automático desactivado": "Envio automático desativado",
    "Puedes guardar tus preferencias. Los recordatorios automáticos todavía no se están enviando.": "Você pode salvar suas preferências. Os lembretes automáticos ainda não estão sendo enviados.",
    "Correo pendiente de configuración": "Configuração de e-mail pendente",
    "Las preferencias se guardan, pero falta configurar el proveedor de correo.": "As preferências são salvas, mas o provedor de e-mail ainda precisa ser configurado.",
    "Servicio de recordatorios detenido": "Serviço de lembretes parado",
    "La configuración está habilitada, pero el proceso automático no está funcionando.": "A configuração está ativada, mas o processo automático não está em execução.",
    "Servicio de recordatorios activo": "Serviço de lembretes ativo",
    "El servicio está preparado para procesar citas con zona horaria confirmada. La recepción del correo depende del proveedor.": "O serviço está pronto para processar agendamentos com fuso horário confirmado. A entrega do e-mail depende do provedor.",
    "Editar Servicio": "Editar serviço",
    "Ajusta los filtros para verlos todos.": "Ajuste os filtros para ver todos os serviços.",
    "belleza": "Beleza",
    "Todos": "Todos",
    "Clasificación": "Classificação",
    "Cambiar foto": "Alterar foto",
    "Subir foto": "Enviar foto",
    "Nombre del Servicio": "Nome do serviço",
    "Sin código": "Sem código",
    "Generador de Etiquetas": "Gerador de etiquetas",
    "Revisa los detalles antes de guardar.": "Revise os detalhes antes de salvar.",
    "Etiquetas:": "Etiquetas:",
    "Barras": "Código de barras",
    "Tamaño": "Tamanho",
    "Cantidad:": "Quantidade:",
    "Cantidad de etiquetas": "Quantidade de etiquetas",
    "Nombre": "Nome",
    "Precio": "Preço",
    "Preparando PDF…": "Preparando PDF…",
    "VER / IMPRIMIR ETIQUETAS": "VER / IMPRIMIR ETIQUETAS",
    "Se abrirá un PDF con solo las etiquetas y sus códigos. Imprime a tamaño real (100 %).": "Será aberto um PDF contendo apenas as etiquetas e seus códigos. Imprima em tamanho real (100%).",
    "Preparando etiquetas": "Preparando etiquetas",
    "Preparando PDF de etiquetas…": "Preparando PDF de etiquetas…",
    "No se pudieron generar las etiquetas. Intenta de nuevo.": "Não foi possível gerar as etiquetas. Tente novamente.",
    "Reducir cantidad": "Diminuir quantidade",
    "Aumentar cantidad": "Aumentar quantidade",
    "Cerrar aviso": "Fechar aviso",
    "No hay productos que coincidan con la búsqueda.": "Nenhum produto corresponde à busca.",
    "Buscar producto para etiquetas": "Buscar produto para etiquetas",
    "No se pudo generar el enlace": "Não foi possível gerar o link",
    "No se pudo copiar el enlace. Selecciónalo y cópialo manualmente.": "Não foi possível copiar o link. Selecione-o e copie manualmente.",
    "Enlace copiado": "Link copiado",
    "Enlace del catálogo": "Link do catálogo",
    "Catálogo Público": "Catálogo público",
    "Tus clientes verán fotos y precios": "Seus clientes verão fotos e preços",
    "Ver catálogo": "Ver catálogo",
    "Mira nuestro catálogo de productos": "Veja nosso catálogo de produtos",
    "Comparte el enlace de tu catálogo con tus clientes.": "Compartilhe o link do catálogo com seus clientes.",
    "Se muestran los productos marcados como \"Visible en catálogo\". Puedes ocultar cualquier producto desde su formulario de edición.": "São exibidos os produtos marcados como \"Visível no catálogo\". Você pode ocultar qualquer produto no formulário de edição.",
    "Te quedan {remaining} etiquetas este mes. Actualiza tu plan para generar más.": "Você tem {remaining} etiquetas restantes neste mês. Atualize seu plano para gerar mais.",
    "{count} producto necesita reabastecimiento": "{count} produto precisa de reposição",
    "{count} productos necesitan reabastecimiento": "{count} produtos precisam de reposição"
  },
  "fr": {
    "Desde": "Depuis",
    "Período:": "Période :",
    "Base:": "Base :",
    "+Bonos:": "+Primes :",
    "-Deducciones:": "-Retenues :",
    "Neto a pagar": "Net à payer",
    "Neto a pagar:": "Net à payer :",
    "Marcar como pagado": "Marquer comme payé",
    "Compartir recibo": "Partager le bulletin",
    "Registrar Asistencia": "Enregistrer la présence",
    "Presente": "Présent",
    "Ausente": "Absent",
    "Tardanza": "Retard",
    "vacaciones": "congés",
    "enfermedad": "congé maladie",
    "Horas": "Heures",
    "+ Registrar primera asistencia": "+ Enregistrer la première présence",
    "Empleado *": "Employé *",
    "Seleccionar empleado": "Sélectionner un employé",
    "Seleccionar empleado...": "Sélectionner un employé…",
    "Fecha *": "Date *",
    "Hora Entrada": "Heure d’arrivée",
    "Hora Salida": "Heure de départ",
    "Notas adicionales...": "Notes supplémentaires…",
    "Escanear Pay Stub": "Scanner un bulletin de paie",
    "Crear Pay Stub": "Créer un bulletin de paie",
    "+ Crear primer pay stub": "+ Créer le premier bulletin",
    "Pay Stub": "Bulletin de paie",
    "Fecha de Pago:": "Date de paiement :",
    "Bruto:": "Brut :",
    "Pago Neto": "Salaire net",
    "Ver pay stub": "Voir le bulletin de paie",
    "Completa los datos y confirma la tarifa por hora. Puedes revisar y ajustar las deducciones antes de guardar.": "Complétez les informations et confirmez le taux horaire. Vérifiez et ajustez les retenues avant d’enregistrer.",
    "Los importes se redondean a centavos por concepto. Las retenciones sugeridas son estimaciones editables; los valores que cambies manualmente se conservan.": "Les montants sont arrondis au centime par poste. Les retenues proposées sont des estimations modifiables ; vos changements manuels sont conservés.",
    "-- Seleccionar empleado --": "-- Sélectionner un employé --",
    "⚠️ Primero debes agregar empleados en el tab \"Empleados\"": "⚠️ Ajoutez d’abord des employés dans l’onglet Employés",
    "Empresa *": "Entreprise *",
    "-- Seleccionar empresa --": "-- Sélectionner une entreprise --",
    "⚠️ Primero debes crear empresas en \"Mis Empresas\"": "⚠️ Créez d’abord une entreprise dans Mes entreprises",
    "Fecha de Pago *": "Date de paiement *",
    "Inicio del Período *": "Début de période *",
    "Fin del Período *": "Fin de période *",
    "Ingresos": "Revenus",
    "Horas Regulares": "Heures normales",
    "Horas Extra": "Heures supplémentaires",
    "Tarifa por Hora ($)": "Taux horaire ($)",
    "Bonificación ($)": "Prime ($)",
    "Comisión ($)": "Commission ($)",
    "Salario Bruto ($)": "Salaire brut ($)",
    "Deducciones (Automáticas según país)": "Retenues (automatiques selon le pays)",
    "Federal Tax ($)": "Impôt fédéral ($)",
    "State Tax ($)": "Impôt de l’État ($)",
    "Social Security ($)": "Sécurité sociale ($)",
    "Medicare ($)": "Medicare ($)",
    "Deducciones Opcionales:": "Retenues facultatives :",
    "Seguro Médico ($)": "Assurance santé ($)",
    "Seguro Dental ($)": "Assurance dentaire ($)",
    "Seguro de Visión ($)": "Assurance optique ($)",
    "Otras Deducciones ($)": "Autres retenues ($)",
    "Salario Bruto": "Salaire brut",
    "Total Deducciones": "Total des retenues",
    "Hay un guardado pendiente de confirmar. Reintenta para recuperar el mismo recibo; los datos se conservan.": "Un enregistrement attend confirmation. Réessayez pour récupérer le même bulletin ; vos données sont conservées.",
    "Pay Stub Preview": "Aperçu du bulletin de paie",
    "RECIBO DE PAGO / PAY STUB": "BULLETIN DE PAIE",
    "Nombre:": "Nom :",
    "Posición:": "Poste :",
    "Departamento:": "Service :",
    "Tipo:": "Type :",
    "Recibo por período": "Bulletin par période",
    "INGRESOS / EARNINGS": "REVENUS",
    "Detalle": "Détail",
    "Monto": "Montant",
    "hrs @ $": "h à $",
    "/hr": "/h",
    "TOTAL BRUTO": "TOTAL BRUT",
    "DEDUCCIONES / DEDUCTIONS": "RETENUES",
    "Impuesto Federal": "Impôt fédéral",
    "Federal Tax": "Impôt fédéral",
    "Impuesto Estatal": "Impôt de l’État",
    "State Tax": "Impôt de l’État",
    "Seguro Social": "Sécurité sociale",
    "Social Security (6.2%)": "Sécurité sociale (6,2 %)",
    "Health Insurance": "Assurance santé",
    "Retiro 401(k)": "Retraite 401(k)",
    "401(k) Contribution": "Cotisation 401(k)",
    "Otras Deducciones": "Autres retenues",
    "Other Deductions": "Autres retenues",
    "TOTAL DEDUCCIONES": "TOTAL DES RETENUES",
    "PAGO NETO / NET PAY": "SALAIRE NET",
    "Este es un documento generado por BRIEFCASE ERP": "Ce document a été généré par BRIEFCASE ERP",
    "Para cualquier consulta, contacte al departamento de Recursos Humanos": "Pour toute question, contactez les ressources humaines",
    "Compartir Recibo de Nómina": "Partager le bulletin de paie",
    "Mensaje (opcional)": "Message (facultatif)",
    "Mensaje adicional...": "Message supplémentaire…",
    "Nombre *": "Nom *",
    "Cargo *": "Poste *",
    "Departamento": "Service",
    "Salario Mensual": "Salaire mensuel",
    "Frecuencia de Pago": "Fréquence de paiement",
    "Por Hora": "À l’heure",
    "Diario": "Quotidien",
    "Semanal": "Hebdomadaire",
    "Quincenal": "Toutes les deux semaines",
    "Mensual": "Mensuel",
    "Valor por Hora": "Montant horaire",
    "Valor por Día": "Montant journalier",
    "Fecha de Contratación *": "Date d’embauche *",
    "Salario Base *": "Salaire de base *",
    "Bonos": "Primes",
    "Deducciones": "Retenues",
    "Escanear código de barras para buscar producto": "Scanner un code-barres pour rechercher un produit",
    "Escanear": "Scanner",
    "Conteo de inventario con escáner": "Inventaire avec scanner",
    "Conteo": "Comptage",
    "Crear etiquetas para productos": "Créer des étiquettes de produits",
    "Compartir catálogo público": "Partager le catalogue public",
    "Catálogo": "Catalogue",
    "Nueva Propiedad": "Nouveau bien",
    "Recalcular clasificación ABC": "Recalculer la classification ABC",
    "A: Alto (80%)": "A : Élevé (80 %)",
    "B: Medio (15%)": "B : Moyen (15 %)",
    "C: Bajo (5%)": "C : Faible (5 %)",
    "¡Alerta de Stock Bajo!": "Alerte de stock faible !",
    "producto": "produit",
    "reabastecimiento": "réapprovisionnement",
    "unidades": "unités",
    "Mín:": "Min :",
    "Ver detalles de stock": "Voir le détail du stock",
    "Generar Etiquetas (Código de Barras / QR)": "Générer des étiquettes (code-barres / QR)",
    "JPG, PNG o WebP · máx. 5MB": "JPG, PNG ou WebP · max. 5 Mo",
    "Código de Barras / SKU": "Code-barres / SKU",
    "Escanea o escribe el código...": "Scannez ou saisissez le code…",
    "Escanear código": "Scanner le code",
    "💡 Escanea cualquier código de barras para registrar el producto": "💡 Scannez un code-barres pour enregistrer le produit",
    "Ubicación en el Negocio": "Emplacement dans l’entreprise",
    "Ej: Estante A-1, Bodega, Vitrina...": "Ex. : Étagère A-1, entrepôt, vitrine…",
    "Clasificación ABC": "Classification ABC",
    "A - Alto valor (prioridad alta)": "A - Valeur élevée (priorité haute)",
    "B - Valor medio": "B - Valeur moyenne",
    "C - Bajo valor": "C - Valeur faible",
    "💡 Usa el botón de recalcular para clasificación automática": "💡 Utilisez Recalculer pour la classification automatique",
    "Fecha de Ingreso": "Date d’entrée",
    "Stock Mínimo (Alerta)": "Stock minimum (alerte)",
    "Se mostrará alerta cuando el stock sea igual o menor": "Une alerte s’affiche lorsque le stock atteint ce seuil ou passe en dessous",
    "Título *": "Titre *",
    "Ej: Casa 3 habitaciones en zona norte": "Ex. : Maison de 3 chambres dans le secteur nord",
    "Precio (": "Prix (",
    "Ciudad, Barrio, Dirección...": "Ville, quartier, adresse…",
    "Habitaciones": "Chambres",
    "Baños": "Salles de bain",
    "Área (m²)": "Surface (m²)",
    "Descripción detallada de la propiedad...": "Description détaillée du bien…",
    "Preferencias/Requisitos": "Préférences / conditions",
    "Ej: Solo familias, Permite mascotas...": "Ex. : Caractéristiques souhaitées, animaux acceptés…",
    "Budget Mínimo": "Budget minimum",
    "Budget Máximo": "Budget maximum",
    "Foto de la Propiedad": "Photo du bien",
    "(opcional)": "(facultatif)",
    "Subiendo...": "Téléversement…",
    "Subir Foto": "Téléverser une photo",
    "✓ Imagen cargada correctamente": "✓ Image téléversée",
    "Compartir vía": "Partager via",
    "Teléfono (opcional)": "Téléphone (facultatif)",
    "Email del destinatario *": "E-mail du destinataire *",
    "Crear Etiquetas": "Créer des étiquettes",
    "Selecciona un producto para crear etiquetas:": "Sélectionnez un produit pour créer des étiquettes :",
    "No hay productos con código de barras o SKU": "Aucun produit n’a de code-barres ou de SKU",
    "Agrega un código a tus productos para crear etiquetas": "Ajoutez un code aux produits pour créer des étiquettes",
    "Detalles de Stock": "Détail du stock",
    "Stock Actual": "Stock actuel",
    "Stock Mínimo": "Stock minimum",
    "alerta": "alerte",
    "¡Stock Crítico!": "Stock critique !",
    "Necesitas reabastecer este producto urgentemente": "Ce produit doit être réapprovisionné d’urgence",
    "Stock Bajo": "Stock faible",
    "Considera hacer un pedido pronto": "Envisagez de commander prochainement",
    "Stock Saludable": "Stock suffisant",
    "El inventario está en buen nivel": "Le niveau de stock est satisfaisant",
    "Información del Producto": "Informations du produit",
    "Código de Barras": "Code-barres",
    "Precio de Venta": "Prix de vente",
    "Costo": "Coût",
    "Valor del Inventario": "Valeur du stock",
    "Editar Stock": "Modifier le stock",
    "Mis Contactos": "Mes contacts",
    "contactos en total": "contacts au total",
    "Distribuir (": "Distribuer (",
    "contactos seleccionados": "contacts sélectionnés",
    "Deseleccionar": "Désélectionner",
    "Distribuir a...": "Distribuer vers…",
    "Buscar por nombre, teléfono, email o empresa...": "Rechercher par nom, téléphone, e-mail ou entreprise…",
    "No hay contactos": "Aucun contact",
    "Agregar Contacto": "Ajouter un contact",
    "Nombre completo": "Nom complet",
    "Dirección completa": "Adresse complète",
    "Nombre de la empresa": "Nom de l’entreprise",
    "Importar desde Excel": "Importer depuis Excel",
    "Categoría para los contactos importados:": "Catégorie des contacts importés :",
    "Deseleccionar todos": "Tout désélectionner",
    "Importando...": "Importation…",
    "Importar": "Importer",
    "Distribuir Contactos": "Distribuer les contacts",
    "Enviando": "Envoi",
    "contacto(s) a otra herramienta": "contact(s) vers un autre outil",
    "Seleccione el destino:": "Sélectionnez la destination :",
    "Enviando...": "Envoi…",
    "Catálogo de Servicios": "Catalogue de services",
    "Buscar servicio…": "Rechercher un service…",
    "Todas las categorías": "Toutes les catégories",
    "Nuevo Servicio": "Nouveau service",
    "% comisión": "% commission",
    "% imp.": "% taxe",
    "Eliminar servicio": "Supprimer le service",
    "Crear primer servicio": "Créer le premier service",
    "Ej: Corte de pelo dama / Preparación de taxes / Notarización": "Ex. : Coupe de cheveux / Déclaration fiscale / Service notarial",
    "Detalles que ayuden al equipo y al cliente": "Informations utiles à l’équipe et au client",
    "— Ninguno —": "— Aucun —",
    "Cobrar impuesto sobre este servicio": "Appliquer une taxe à ce service",
    "📊 Se creará automáticamente una cuenta contable individual para reportes:": "📊 Un compte comptable individuel sera créé automatiquement pour les rapports :",
    "Ingresos · Servicios ·": "Revenus · Services ·",
    "Control de Pagos": "Suivi des paiements",
    "Evita intereses, paga a tiempo": "Évitez les intérêts, payez à temps",
    "Reporte": "Rapport",
    "Agregar Cuenta": "Ajouter une facture",
    "Nuevo Deudor": "Nouveau débiteur",
    "Cuentas por Pagar": "Comptes fournisseurs",
    "Control de Deudores": "Suivi des débiteurs",
    "Vence:": "Échéance :",
    "Pagado:": "Payé :",
    "Marcar como pagada": "Marquer comme payée",
    "activos)": "actifs)",
    "Enviar mensaje a deudores": "Envoyer un message aux débiteurs",
    "Enviar Mensaje": "Envoyer un message",
    "Imprimir lista de deudores": "Imprimer la liste des débiteurs",
    "Deudores": "Débiteurs",
    "pendientes": "en attente",
    "Deuda Total": "Dette totale",
    "Total Cobrado": "Total encaissé",
    "Por Cobrar": "À encaisser",
    "Deudor": "Débiteur",
    "Concepto": "Objet",
    "Monto Deuda": "Montant de la dette",
    "Ha Pagado": "Montant payé",
    "Debe": "Montant dû",
    "+ Agregar primer deudor": "+ Ajouter le premier débiteur",
    "Registrar Pago/Abono": "Enregistrer un paiement / acompte",
    "Enviar Mensaje/Recordatorio": "Envoyer un message / rappel",
    "Historial de Pagos Recientes": "Historique des paiements récents",
    "Ej: Luz, Internet, Tarjeta...": "Ex. : Électricité, Internet, carte…",
    "Monto *": "Montant *",
    "Fecha de Vencimiento *": "Date d’échéance *",
    "Recordatorio de Pago": "Rappel de paiement",
    "Notificarme": "Me notifier",
    "día(s) antes del vencimiento": "jour(s) avant l’échéance",
    "Recibirás un email de recordatorio antes del vencimiento": "Vous recevrez un rappel par e-mail avant l’échéance",
    "Reporte de Pagos por Categoría": "Rapport des paiements par catégorie",
    "Desde:": "Du :",
    "Hasta:": "Au :",
    "Total Pagado en el Período": "Total payé sur la période",
    "pagos": "paiements",
    "Nombre del Deudor *": "Nom du débiteur *",
    "Nombre completo del deudor": "Nom complet du débiteur",
    "Teléfono / WhatsApp": "Téléphone / WhatsApp",
    "Necesario para enviar cobros por WhatsApp": "Nécessaire pour envoyer des demandes de paiement par WhatsApp",
    "Concepto de la Deuda": "Objet de la dette",
    "Ej: Préstamo personal, Mercancía, Servicio...": "Ex. : Prêt personnel, marchandise, service…",
    "Monto de Deuda *": "Montant de la dette *",
    "Registrar Pago": "Enregistrer un paiement",
    "Saldo pendiente:": "Solde restant :",
    "Tipo de Pago": "Type de paiement",
    "Abono": "Acompte",
    "Pago parcial": "Paiement partiel",
    "Pago Total": "Paiement intégral",
    "Liquidar deuda": "Solder la dette",
    "Monto del Abono *": "Montant de l’acompte *",
    "Se liquidará la deuda completa": "La dette sera intégralement soldée",
    "Fecha del Pago": "Date du paiement",
    "Notas (opcional)": "Notes (facultatif)",
    "Nota sobre el pago...": "Note sur le paiement…",
    "Tipo de Mensaje": "Type de message",
    "Automático": "Automatique",
    "Personalizado": "Personnalisé",
    "Escribe tu mensaje personalizado aquí...": "Rédigez votre message personnalisé ici…",
    "Selecciona un deudor para ver el mensaje automático": "Sélectionnez un débiteur pour voir le message automatique",
    "Saldo:": "Solde :",
    "Selecciona cómo enviar el mensaje:": "Choisissez comment envoyer le message :",
    "Copiar": "Copier",
    "BRIEFCASE · PROPIEDADES": "BRIEFCASE · BIENS",
    "Cerrar administración": "Fermer la gestion",
    "Administración de alquileres": "Gestion locative",
    "PARA PROPIETARIOS, ADMINISTRADORES Y AGENTES": "POUR PROPRIÉTAIRES, GESTIONNAIRES ET AGENTS",
    "Inquilinos, rentas, contratos y mantenimiento en un solo lugar.": "Locataires, loyers, baux et entretien au même endroit.",
    "Nueva unidad": "Nouveau logement",
    "Mes de renta": "Mois du loyer",
    "Nombre, unidad, referencia…": "Nom, logement, référence…",
    "Cargando administración…": "Chargement de la gestion…",
    "Tu primera propiedad, organizada": "Votre premier bien, organisé",
    "1. Añade una unidad. 2. Registra al inquilino. 3. Vincula el contrato para controlar sus rentas.": "1. Ajoutez un logement. 2. Enregistrez le locataire. 3. Associez le bail pour suivre les loyers.",
    "Añadir unidad": "Ajouter un logement",
    "Añadir inquilino": "Ajouter un locataire",
    "Rentas de": "Loyers de",
    "El resumen usa la renta mensual pactada de los contratos que coinciden con el mes. No aplica prorrateos ni recargos automáticos.": "Le récapitulatif utilise le loyer mensuel convenu des baux correspondant au mois. Aucun prorata ni supplément automatique n’est appliqué.",
    "· Vence": "· Échéance",
    "pendiente": "en attente",
    "Registrar pago": "Enregistrer un paiement",
    "Cobrar con Briefcase": "Encaisser avec Briefcase",
    "Propiedades y unidades administradas": "Biens et logements gérés",
    "Propietario:": "Propriétaire :",
    "· Administrador:": "· Gestionnaire :",
    "Editar unidad": "Modifier le logement",
    "Añade casas, apartamentos, habitaciones o locales. Usa una unidad distinta para cada espacio alquilado.": "Ajoutez des maisons, appartements, chambres ou locaux. Utilisez un logement distinct pour chaque espace loué.",
    "Inquilinos · A–Z": "Locataires · A–Z",
    "Editar inquilino": "Modifier le locataire",
    "Guarda el nombre y los datos de contacto del inquilino. Luego vincúlalo a su contrato.": "Enregistrez le nom et les coordonnées du locataire, puis associez son bail.",
    "Contratos de alquiler": "Baux de location",
    "Registrar contrato": "Enregistrer un bail",
    "Registra las condiciones de tu contrato existente. Guarda el PDF y solicita firmas desde Archivador.": "Enregistrez les conditions de votre bail existant. Conservez le PDF et demandez les signatures depuis les Archives.",
    "/ mes · Día": "/ mois · Jour",
    "Depósito pactado:": "Dépôt convenu :",
    "Archivos y firmas": "Fichiers et signatures",
    "Registrar fin": "Enregistrer la fin",
    "Primero añade una unidad y un inquilino para registrar el contrato.": "Ajoutez un logement et un locataire avant d’enregistrer le bail.",
    "Rentas y cobros ·": "Loyers et encaissements ·",
    "Verificar cobros": "Vérifier les encaissements",
    "Registrar renta": "Enregistrer un loyer",
    "Efectivo y Zelle se registran manualmente después de recibirlos. Briefcase registra los cobros con tarjeta cuando Stripe los confirma.": "Enregistrez manuellement les espèces et Zelle après réception. Briefcase enregistre les paiements par carte après confirmation de Stripe.",
    "Configurar cobros electrónicos": "Configurer les paiements électroniques",
    "Recibo PDF": "Reçu PDF",
    "Anular registro": "Annuler l’enregistrement",
    "No hay rentas registradas para este mes y búsqueda.": "Aucun loyer enregistré ne correspond à ce mois et à cette recherche.",
    "Mantenimiento": "Entretien",
    "Nueva solicitud": "Nouvelle demande",
    "Estimado": "Estimé",
    "· Real": "· Réel",
    "Actualizar estado": "Mettre à jour le statut",
    "Registra reparaciones, responsables, fechas y costos por unidad.": "Enregistrez les réparations, responsables, dates et coûts par logement.",
    "Contratos y expedientes": "Baux et dossiers",
    "Organiza las carpetas por inquilino o propiedad. Sube tus contratos, guarda los documentos firmados y encuéntralos por nombre.": "Organisez les dossiers par locataire ou bien. Téléversez les baux, conservez les documents signés et retrouvez-les par nom.",
    "Enlace de pago preparado": "Lien de paiement prêt",
    "Enlace de cobro": "Lien de paiement",
    "Copiar enlace": "Copier le lien",
    "El inquilino puede pagar sin tener una cuenta Briefcase. El enlace contiene el importe pendiente al crearlo; verifica los cobros antes de emitir otro.": "Le locataire peut payer sans compte Briefcase. Le lien contient le solde dû à sa création ; vérifiez les encaissements avant d’en émettre un autre.",
    "Listo": "Terminé",
    "Registra únicamente dinero ya recibido. Este formulario no cobra ni transfiere fondos.": "Enregistrez uniquement les fonds déjà reçus. Ce formulaire n’encaisse ni ne transfère de fonds.",
    "Genera un enlace de tarjeta por el saldo pendiente del mes. Necesitas conectar Stripe en Cobros.": "Créez un lien de paiement par carte pour le solde du mois. Connectez d’abord Stripe dans Paiements.",
    "Seleccionar…": "Sélectionner…",
    "Abrir Cobros": "Ouvrir les paiements",
    "Buscar co-broker...": "Rechercher des agents partenaires…",
    "Importar desde celular": "Importer depuis le téléphone",
    "Importar desde contactos": "Importer depuis les contacts",
    "Nuevo Co-Broker": "Nouvel agent partenaire",
    "Agregar Listado": "Ajouter une annonce",
    "Documentos (": "Documents (",
    "Subir": "Téléverser",
    "Sube contratos, acuerdos y otros archivos": "Téléversez des contrats, accords et autres fichiers",
    "Firmado:": "Signé :",
    "Ver documento": "Voir le document",
    "Firmar documento con E-Sign": "Signer le document avec E-Sign",
    "Firmar y descargar PDF": "Signer et télécharger le PDF",
    "Firmado": "Signé",
    "No hay listados para este co-broker": "Aucune annonce pour cet agent partenaire",
    "Tipo de Propiedad": "Type de bien",
    "🏠 Casa": "🏠 Maison",
    "🏢 Apartamento": "🏢 Appartement",
    "🌳 Terreno": "🌳 Terrain",
    "🏪 Comercial": "🏪 Commercial",
    "🏛️ Oficina": "🏛️ Bureau",
    "Transacción": "Transaction",
    "💰 Venta": "💰 Vente",
    "📅 Alquiler": "📅 Location",
    "Precio *": "Prix *",
    "✅ Disponible": "✅ Disponible",
    "⏳ Reservado": "⏳ Réservé",
    "Vendido": "Vendu",
    "Alquilado": "Loué",
    "Rentado": "Loué",
    "Estado/Provincia": "État / province",
    "Galería de Fotos": "Galerie de photos",
    "Categoría de documentación": "Catégorie de documents",
    "Teléfono *": "Téléphone *",
    "🏠 Comprador": "🏠 Acheteur",
    "🔑 Inquilino (Rentar)": "🔑 Locataire (location)",
    "💰 Vendedor": "💰 Vendeur",
    "Inversor": "Investisseur",
    "Presupuesto Mínimo": "Budget minimum",
    "Presupuesto Máximo": "Budget maximum",
    "Ubicación Preferida": "Localisation souhaitée",
    "Ej: Miami, FL": "Ex. : Miami, FL",
    "🏦 Pre-calificación Bancaria": "🏦 Préqualification bancaire",
    "Banco": "Banque",
    "Ej: Bank of America": "Ex. : Bank of America",
    "Monto Aprobado": "Montant approuvé",
    "Fecha de Vencimiento": "Date d’échéance",
    "Documento de Pre-calificación": "Document de préqualification",
    "Subir Documento": "Téléverser un document",
    "Foto": "Photo",
    "✅ Documento cargado": "✅ Document téléversé",
    "Ver / Descargar": "Voir / télécharger",
    "Nueva Interacción -": "Nouvelle interaction -",
    "Tipo de Interacción": "Type d’interaction",
    "📞 Llamada": "📞 Appel",
    "📧 Email": "📧 E-mail",
    "🤝 Reunión": "🤝 Réunion",
    "👁️ Visita a Propiedad": "👁️ Visite du bien",
    "📝 Nota": "📝 Note",
    "Notas *": "Notes *",
    "Describe la interacción...": "Décrivez l’interaction…",
    "Fecha de Seguimiento (opcional)": "Date de suivi (facultatif)",
    "Guardar Interacción": "Enregistrer l’interaction",
    "Auto-generado": "Généré automatiquement",
    "Orden (# para ordenar)": "Ordre (numéro de classement)",
    "Dirección de Propiedad *": "Adresse du bien *",
    "Comisión (%)": "Commission (%)",
    "Detalles adicionales del listado...": "Informations supplémentaires sur l’annonce…",
    "Casillero de Documentos": "Classeur de documents",
    "📝 Cómo firmar un documento:": "📝 Comment signer un document :",
    "Sube tu documento PDF usando el botón \"Subir Documento\"": "Téléversez votre PDF avec Téléverser un document",
    "Una vez subido, haz clic en \"Firmar con BRIEFCASE\"": "Après le téléversement, cliquez sur Signer avec BRIEFCASE",
    "Dibuja tu firma y presiona \"Firmar Documento\"": "Dessinez votre signature et appuyez sur Signer le document",
    "Descarga el PDF firmado con el botón verde": "Téléchargez le PDF signé avec le bouton de téléchargement",
    "Notas del documento (opcional)": "Notes du document (facultatif)",
    "PDF, imágenes o documentos Word. Máximo 10MB.": "PDF, images ou documents Word. Maximum 10 Mo.",
    "Sube contratos, identificaciones o documentos del cliente": "Téléversez des contrats, pièces d’identité ou documents du client",
    "Firmado por": "Signé par",
    "Abrir/Ver documento": "Ouvrir / voir le document",
    "Firmar documento con BRIEFCASE": "Signer le document avec BRIEFCASE",
    "Firmar con BRIEFCASE": "Signer avec BRIEFCASE",
    "Enviar a tercero para firma": "Envoyer à un tiers pour signature",
    "Descargar Firmado": "Télécharger le document signé",
    "Descargar original": "Télécharger l’original",
    "Enviar por WhatsApp": "Envoyer par WhatsApp",
    "Enviar por Email": "Envoyer par e-mail",
    "Seleccionar Contacto": "Sélectionner un contact",
    "No hay contactos disponibles": "Aucun contact disponible",
    "Agrega clientes en la sección de Clientes primero": "Ajoutez d’abord des clients dans la section Clients",
    "Importar Co-Brokers desde Excel": "Importer des agents partenaires depuis Excel",
    "Se encontraron": "Trouvés",
    "contactos. Selecciona los que deseas importar.": "contacts. Sélectionnez ceux à importer.",
    "Seleccionar todos (": "Tout sélectionner (",
    "Importar Clientes desde Excel": "Importer des clients depuis Excel",
    "Importar Clientes desde Celular": "Importer des clients depuis le téléphone",
    "clientes seleccionados": "clients sélectionnés",
    "Tipo de cliente para los importados:": "Type des clients importés :",
    "Comprador": "Acheteur",
    "Vendedor": "Vendeur",
    "Inquilino/Renta": "Locataire / location",
    "Seleccionar todos": "Tout sélectionner",
    "Importar Co-Brokers desde Celular": "Importer des agents partenaires depuis le téléphone",
    "co-brokers seleccionados": "agents partenaires sélectionnés",
    "Firmar Documento": "Signer le document",
    "Sistema de Citas": "Gestion des rendez-vous",
    "Gestiona tus citas con clientes": "Gérez vos rendez-vous clients",
    "Cargando agenda…": "Chargement de l’agenda…",
    "Reintentar carga": "Réessayer le chargement",
    "Citas de Hoy (": "Rendez-vous du jour (",
    "Buscar citas": "Rechercher des rendez-vous",
    "Buscar citas...": "Rechercher des rendez-vous…",
    "Filtrar por estado": "Filtrer par statut",
    "Todos los estados": "Tous les statuts",
    "Lista": "Liste",
    "Calendario": "Calendrier",
    "Crea tu primera cita para empezar": "Créez votre premier rendez-vous pour commencer",
    "+ Crear Cita": "+ Créer un rendez-vous",
    "Fecha/Hora": "Date / heure",
    "Título": "Titre",
    "Ver detalles": "Voir les détails",
    "Mes anterior": "Mois précédent",
    "Mes siguiente": "Mois suivant",
    "más": "de plus",
    "Cierra esta ventana y reintenta la carga.": "Fermez cette fenêtre et réessayez le chargement.",
    "Cliente *": "Client *",
    "-- Seleccionar cliente --": "-- Sélectionner un client --",
    "⚠️ Primero debes agregar clientes en la sección \"Clientes\"": "⚠️ Ajoutez d’abord des clients dans la section Clients",
    "Título de la Cita *": "Titre du rendez-vous *",
    "Ej: Consulta inicial, Revisión de propuesta...": "Ex. : Première consultation, examen de proposition…",
    "Detalles adicionales de la cita...": "Informations supplémentaires sur le rendez-vous…",
    "Hora *": "Heure *",
    "Duración (min)": "Durée (min)",
    "15 minutos": "15 minutes",
    "30 minutos": "30 minutes",
    "45 minutos": "45 minutes",
    "1 hora": "1 heure",
    "1.5 horas": "1,5 heure",
    "2 horas": "2 heures",
    "Zona horaria de la cita *": "Fuseau horaire du rendez-vous *",
    "Ej: America/New_York": "Ex. : America/New_York",
    "La fecha y hora corresponden a esta zona. Confírmala si la cita se realiza en otro lugar.": "La date et l’heure utilisent ce fuseau. Confirmez-le si le rendez-vous a lieu ailleurs.",
    "Dirección o lugar de la cita...": "Adresse ou lieu du rendez-vous…",
    "Recordatorios Automáticos": "Rappels automatiques",
    "24 horas antes": "24 heures avant",
    "1 hora antes": "1 heure avant",
    "Notas Internas": "Notes internes",
    "Notas privadas sobre esta cita...": "Notes privées sur ce rendez-vous…",
    "Detalles de la Cita": "Détails du rendez-vous",
    "Cerrar detalles": "Fermer les détails",
    "Estado de los recordatorios": "Statut des rappels",
    "Registrar revisión del proveedor": "Enregistrer la vérification du prestataire",
    "Historial de revisiones del proveedor": "Historique des vérifications du prestataire",
    "Identificador del mensaje:": "Identifiant du message :",
    "Registrar revisión:": "Enregistrer une vérification :",
    "Resultado comprobado en el proveedor": "Résultat vérifié chez le prestataire",
    "Selecciona el resultado": "Sélectionnez le résultat",
    "El proveedor aceptó el correo": "Le prestataire a accepté l’e-mail",
    "El proveedor confirmó que no se envió": "Le prestataire a confirmé l’absence d’envoi",
    "Identificador del mensaje en el proveedor *": "Identifiant du message chez le prestataire *",
    "Nota de revisión (opcional)": "Note de vérification (facultatif)",
    "Al autorizar el reintento se libera este aviso. Si el servicio automático está activo y el horario corresponde, podrá enviar el correo nuevamente.": "Autoriser une nouvelle tentative libère ce rappel. Si le service automatique est actif et l’horaire correspond, il peut renvoyer l’e-mail.",
    "Cancelar revisión": "Annuler la vérification",
    "Actualizar información": "Actualiser les informations",
    "Preparar o enviar recordatorio": "Préparer ou envoyer un rappel",
    "Email requiere un proveedor configurado. En WhatsApp tú revisas y envías el mensaje.": "L’e-mail nécessite un prestataire configuré. Sur WhatsApp, vous vérifiez et envoyez le message.",
    "Abrir WhatsApp para revisar y enviar": "Ouvrir WhatsApp pour vérifier et envoyer",
    "Cambiar Estado": "Modifier le statut",
    "de": "sur",
    "Venta": "Vente",
    "Renta": "Location",
    "Compartir": "Partager",
    "Reintentar": "Réessayer",
    "Actualizar": "Actualiser",
    "Buscar": "Rechercher",
    "Cancelar": "Annuler",
    "Cerrar": "Fermer",
    "Editar": "Modifier",
    "Empleado": "Employé",
    "Entrada": "Arrivée",
    "Salida": "Départ",
    "Descargar PDF": "Télécharger le PDF",
    "Compartir por WhatsApp": "Partager par WhatsApp",
    "Empresa": "Entreprise",
    "Contactos": "Contacts",
    "Celular": "Téléphone",
    "Ciudad": "Ville",
    "Tipo": "Type",
    "Enviar": "Envoyer",
    "Hoy": "Aujourd’hui",
    "Programadas": "Planifiés",
    "Confirmadas": "Confirmés",
    "Atendidos": "Honorés",
    "No Asistió": "Absent",
    "Canceladas": "Annulés",
    "Programada": "Planifié",
    "Confirmada": "Confirmé",
    "En Espera": "En attente",
    "Atendido": "Honoré",
    "No Se Presentó": "Absent",
    "Cancelada": "Annulé",
    "Reprogramada": "Replanifié",
    "Por definir": "À définir",
    "Nueva Cita": "Nouveau rendez-vous",
    "Editar Cita": "Modifier le rendez-vous",
    "Crear Cita": "Créer le rendez-vous",
    "Guardando…": "Enregistrement…",
    "No se pudo verificar el servicio de recordatorios.": "Le service de rappels n’a pas pu être vérifié.",
    "No se pudieron cargar las citas.": "Impossible de charger les rendez-vous.",
    "No se pudieron cargar los clientes.": "Impossible de charger les clients.",
    "No se pudo cargar el resumen.": "Impossible de charger le résumé.",
    "Estado del servicio sin verificar": "État du service non vérifié",
    "No se pudo comprobar si el envío automático está disponible. Actualiza la información antes de confiar en un aviso.": "La disponibilité de l’envoi automatique n’a pas pu être vérifiée. Actualisez les informations avant de compter sur un rappel.",
    "Comienza agregando contactos manualmente o importándolos": "Commencez par ajouter des contacts manuellement ou par les importer",
    "Crear Contacto": "Créer le contact",
    "Rentas": "Locations",
    "Ventas de Casas": "Ventes de maisons",
    "Inversores": "Investisseurs",
    "Referidos": "Recommandations",
    "Proveedores": "Fournisseurs",
    "Guardar Cambios": "Enregistrer les modifications",
    "Ingresos del mes": "Revenus du mois",
    "Comisiones": "Commissions",
    "Pagadas a profesionales": "Versées aux professionnels",
    "Ingreso neto": "Revenu net",
    "Ingresos − comisiones": "Revenus − commissions",
    "Impuestos": "Taxes",
    "Recolectados este mes": "Collectées ce mois-ci",
    "Crea tu primer servicio": "Créez votre premier service",
    "Ningún servicio coincide con tu búsqueda": "Aucun service ne correspond à votre recherche",
    "Configura cada servicio que ofreces: corte de pelo, notaría, taxes, consultoría, fotocopias, reparaciones… con su precio, duración, comisión y categoría profesional.": "Configurez chaque service proposé : coiffure, services notariaux, fiscalité, conseil, photocopies, réparations… avec son prix, sa durée, sa commission et sa catégorie professionnelle.",
    "Nombre del servicio *": "Nom du service *",
    "Descripción (opcional)": "Description (facultative)",
    "Duración (minutos)": "Durée (minutes)",
    "Categoría profesional": "Catégorie professionnelle",
    "Profesional asignado (por defecto)": "Professionnel affecté (par défaut)",
    "% Comisión profesional": "Commission du professionnel %",
    "Tasa de impuesto %": "Taux de taxe %",
    "Crear Servicio": "Créer le service",
    "<nombre>": "<nom>",
    "Producto": "Produit",
    "Servicio": "Service",
    "Propiedad": "Bien immobilier",
    "Disponible": "Disponible",
    "Reservado": "Réservé",
    "Agregar Servicio": "Ajouter un service",
    "Ver Productos": "Voir les produits",
    "Ocultar": "Masquer",
    "Vencidas": "En retard",
    "Vencen Hoy": "Échéance aujourd’hui",
    "Pendientes": "En attente",
    "Pagadas": "Payées",
    "Todas": "Toutes",
    "cuentas": "comptes",
    "Nueva Cuenta": "Nouvelle facture",
    "Editar Cuenta": "Modifier la facture",
    "Agregar": "Ajouter",
    "Nuevo Empleado": "Nouvel employé",
    "Editar Empleado": "Modifier l’employé",
    "Guardar": "Enregistrer",
    "Otros": "Autres",
    "ventas": "ventes",
    "Medio Día": "Demi-journée",
    "Vacaciones": "Congés",
    "Enfermedad": "Congé maladie",
    "Envío automático desactivado": "Envoi automatique désactivé",
    "Puedes guardar tus preferencias. Los recordatorios automáticos todavía no se están enviando.": "Vous pouvez enregistrer vos préférences. Les rappels automatiques ne sont pas encore envoyés.",
    "Correo pendiente de configuración": "Configuration du courriel en attente",
    "Las preferencias se guardan, pero falta configurar el proveedor de correo.": "Les préférences sont enregistrées, mais le fournisseur de courriel reste à configurer.",
    "Servicio de recordatorios detenido": "Service de rappels arrêté",
    "La configuración está habilitada, pero el proceso automático no está funcionando.": "Le paramètre est activé, mais le processus automatique ne fonctionne pas.",
    "Servicio de recordatorios activo": "Service de rappels actif",
    "El servicio está preparado para procesar citas con zona horaria confirmada. La recepción del correo depende del proveedor.": "Le service est prêt à traiter les rendez-vous dont le fuseau horaire est confirmé. La livraison du courriel dépend du fournisseur.",
    "Editar Servicio": "Modifier le service",
    "Ajusta los filtros para verlos todos.": "Ajustez les filtres pour voir tous les services.",
    "belleza": "Beauté",
    "Todos": "Tous",
    "Clasificación": "Classification",
    "Cambiar foto": "Changer la photo",
    "Subir foto": "Importer une photo",
    "Nombre del Servicio": "Nom du service",
    "Sin código": "Sans code",
    "Generador de Etiquetas": "Générateur d’étiquettes",
    "Revisa los detalles antes de guardar.": "Vérifiez les détails avant d’enregistrer.",
    "Etiquetas:": "Étiquettes :",
    "Barras": "Code-barres",
    "Tamaño": "Taille",
    "Cantidad:": "Quantité :",
    "Cantidad de etiquetas": "Nombre d’étiquettes",
    "Nombre": "Nom",
    "Precio": "Prix",
    "Preparando PDF…": "Préparation du PDF…",
    "VER / IMPRIMIR ETIQUETAS": "VOIR / IMPRIMER LES ÉTIQUETTES",
    "Se abrirá un PDF con solo las etiquetas y sus códigos. Imprime a tamaño real (100 %).": "Un PDF contenant uniquement les étiquettes et leurs codes s’ouvrira. Imprimez à taille réelle (100 %).",
    "Preparando etiquetas": "Préparation des étiquettes",
    "Preparando PDF de etiquetas…": "Préparation du PDF des étiquettes…",
    "No se pudieron generar las etiquetas. Intenta de nuevo.": "Impossible de générer les étiquettes. Réessayez.",
    "Reducir cantidad": "Réduire la quantité",
    "Aumentar cantidad": "Augmenter la quantité",
    "Cerrar aviso": "Fermer le message",
    "No hay productos que coincidan con la búsqueda.": "Aucun produit ne correspond à votre recherche.",
    "Buscar producto para etiquetas": "Rechercher un produit pour les étiquettes",
    "No se pudo generar el enlace": "Impossible de créer le lien",
    "No se pudo copiar el enlace. Selecciónalo y cópialo manualmente.": "Impossible de copier le lien. Sélectionnez-le et copiez-le manuellement.",
    "Enlace copiado": "Lien copié",
    "Enlace del catálogo": "Lien du catalogue",
    "Catálogo Público": "Catalogue public",
    "Tus clientes verán fotos y precios": "Vos clients verront les photos et les prix",
    "Ver catálogo": "Voir le catalogue",
    "Mira nuestro catálogo de productos": "Découvrez notre catalogue de produits",
    "Comparte el enlace de tu catálogo con tus clientes.": "Partagez le lien de votre catalogue avec vos clients.",
    "Se muestran los productos marcados como \"Visible en catálogo\". Puedes ocultar cualquier producto desde su formulario de edición.": "Les produits marqués « Visible dans le catalogue » sont affichés. Vous pouvez masquer un produit depuis son formulaire de modification.",
    "Te quedan {remaining} etiquetas este mes. Actualiza tu plan para generar más.": "Il vous reste {remaining} étiquettes ce mois-ci. Changez de forfait pour en générer davantage.",
    "{count} producto necesita reabastecimiento": "{count} produit doit être réapprovisionné",
    "{count} productos necesitan reabastecimiento": "{count} produits doivent être réapprovisionnés"
  }
};
export const interfaceLanguages = ['es','en','pt','fr'];
export function interfaceText(text,language){
 if(typeof text!=='string')return text;
 const key=text.trim();const value=cashCopy[language]?.[key] ?? cashFlowCopy[language]?.[key] ?? expenseCopy[language]?.[key] ?? projectionCopy[language]?.[key] ?? profitabilityCopy[language]?.[key] ?? financialReportCopy[language]?.[key] ?? purchaseCopy[language]?.[key] ?? transportCopy[language]?.[key] ?? promotionCopy[language]?.[key] ?? operationalCopy[language]?.[key] ?? supplemental[language]?.[key] ?? messages[language]?.[key];
 if(value===undefined)return text;
 const start=text.indexOf(key);return text.slice(0,start)+value+text.slice(start+key.length);
}
export const interfaceTranslationKeys=Object.keys(messages.es);
